{
  "common": {
    "show_password": "显示密码",
    "hide_password": "隐藏密码",
    "loading": "加载中…",
    "retry": "重试",
    "error": "发生错误",
    "none": "—",
    "cancel": "取消",
    "back": "返回",
    "copy": "拷贝",
    "done": "完成",
    "save": "保存",
    "edit": "编辑",
    "close": "关闭",
    "list_sep": "、",
    "list_sep2": "；",
    "colon": "：",
    "paren": "（{{x}}）",
    "saving": "保存中…",
    "yes": "有",
    "on": "开",
    "off": "关",
    "device_id": "设备 ID",
    "action_delete": "删除",
    "action_remove": "移除",
    "action_update_fw": "开始更新",
    "action_apply": "套用",
    "action_change": "改设置",
    "action_revoke": "撤销",
    "action_purge": "清除数据",
    "action_reboot": "重新开机",
    "confirm_type": "输入「{{name}}」确认",
    "action_end": "终止",
    "action_sign_out": "登出",
    "op_failed": "操作没有完成，请稍后再试。（代码：{{code}}）",
    "state_unknown": "未知",
    "pick_date": "选日期",
    "dt24_bad": "请写成 2026-10-13 22:25（24 小时制）",
    "on_this_page": "本页："
  },
  "auth": {
    "title": "登录",
    "email": "Email",
    "password": "密码",
    "submit": "登录",
    "submitting": "登录中…",
    "err_INVALID_CREDENTIALS": "账号或密码错误",
    "err_RATE_LIMITED": "尝试次数过多，请稍后再试",
    "err_NETWORK": "无法连接，请检查网络",
    "err_IDENTITY_UNAVAILABLE": "账号服务暂时无法连接",
    "err_default": "登录失败（{{code}}）",
    "reason_SESSION_IDLE": "闲置太久，已自动注销。请重新登录。",
    "err_SESSION_IDLE": "闲置太久，请重新登录",
    "err_PASSKEY_REQUIRED": "这个账号请用 passkey 登录",
    "reason_SESSION_REAUTH": "值班账号每 12 小时要重新登录。",
    "hint": "用 {{brand}} App 的同一个账号登录：自己的设备、组织授权给你的、别人分享给你的，都在这里。",
    "no_account": "还没有账号？",
    "signup": "注册",
    "signup_title": "注册账号",
    "signup_hint": "这个账号也能登录 {{brand}} App。之后被组织邀请或别人分享设备给你，用同一个账号就看得到。",
    "signup_submit": "创建账号",
    "pending_invite": "登录后会自动接受你点的邀请。",
    "err_EMAIL_EXISTS": "这个 email 已有账号，请直接登录",
    "err_WEAK_PASSWORD": "密码太短或太常见",
    "err_SIGNUP_CLOSED": "这个服务不再开放注册",
    "err_BRAND_OFFBOARDING": "这个品牌已停止新注册",
    "reason_other": "已退出登录，请重新登录。"
  },
  "nav": {
    "overview": "总览",
    "live": "实时视频",
    "playback": "回放",
    "events": "事件与警报",
    "map": "地图",
    "devices": "设备",
    "ai": "AI 分析",
    "backup": "异地备份",
    "exports": "导出与证据",
    "people": "人员与访问",
    "audit": "审计",
    "billing": "套餐与账单",
    "rules": "自动化规则",
    "sites": "组织与场所",
    "org": "组织设置",
    "account": "我的账号"
  },
  "shell": {
    "scope_all": "全部（我自己的 + 组织授权给我 + 别人分享给我）",
    "language": "语言",
    "logout": "退出",
    "env": "环境",
    "env_badge": "环境：{{env}}",
    "scope": "范围",
    "present_end": "结束展示"
  },
  "planned": {
    "title": "{{name}}：规划中",
    "body": "此模块排在 {{milestone}} 交付，规格见 plan/vms-web-v0.md。",
    "spec": "规格章节"
  },
  "overview": {
    "title": "总览",
    "homes": "$t(leaf.cur)",
    "devices": "设备",
    "online": "在线",
    "offline": "离线",
    "role": "角色",
    "no_homes": "目前没有任何$t(leaf.cur)或场所。请用 App 建立$t(leaf.cur)，或请组织管理员授权。",
    "open_devices": "查看设备",
    "cameras": "画面（在线 / 全部）",
    "recent_events": "最近事件",
    "devices_n_one": "{{count}} 台",
    "devices_n_other": "{{count}} 台",
    "channels_note_one": "另有 {{count}} 个 NVR 通道",
    "channels_note_other": "另有 {{count}} 个 NVR 通道",
    "devices_tip": "设备 = 实体台数，不含 NVR 通道（一台 NVR 算 1）",
    "offline_tip": "NVR 在线、只有通道离线时只算通道",
    "online_rate": "设备在线率 {{pct}}%",
    "cameras_tip": "画面 = 摄像头或通道；一台 NVR 有几个通道就算几个画面。点了在影像墙打开",
    "recorders_bad": "{{bad}} / {{total}} 异常",
    "recorders_tip": "录像主机 = NVR 与 Kinio Station（含 Mac / Windows 版）",
    "basis_auto": "以最近平均录像 {{mbps}} Mbps、{{gb}} GB 循环覆写估算",
    "basis_off": "以最近平均录像 {{mbps}} Mbps、剩下 {{gb}} GB 估算（不覆写）",
    "fw_outdated_one": "{{count}} 台有新版",
    "fw_outdated_other": "{{count}} 台有新版",
    "fw_all_latest_one": "{{count}} 台已是最新",
    "fw_all_latest_other": "{{count}} 台已是最新",
    "fw_tip": "只算设备本体（NVR 通道跟着 NVR）；跟“设备 › 固件”同一份数据",
    "todo_title": "需要处理",
    "todo_none": "目前没有需要处理的事。",
    "todo_offline": "离线：{{devices}} 台设备、{{channels}} 个通道",
    "todo_storage_one": "{{count}} 台录像主机存储异常",
    "todo_storage_other": "{{count}} 台录像主机存储异常",
    "todo_cert_one": "{{count}} 台证书已过期或快到期",
    "todo_cert_other": "{{count}} 台证书已过期或快到期",
    "todo_fw_one": "{{count}} 台有新版固件",
    "todo_fw_other": "{{count}} 台有新版固件",
    "todo_alarms_one": "{{count}} 条警报还没处理",
    "todo_alarms_other": "{{count}} 条警报还没处理",
    "todo_gaps_one": "{{count}} 台摄像头过去 24 小时录像有缺口",
    "todo_gaps_other": "{{count}} 台摄像头过去 24 小时录像有缺口",
    "gap_cam_reason": "{{name}}（{{reason}}）",
    "and_more_one": " 等 {{count}} 台",
    "and_more_other": " 等 {{count}} 台",
    "act_view": "查看",
    "act_check": "检查",
    "act_update": "看固件",
    "act_handle": "处理警报",
    "act_playback": "回放",
    "recent_alarms": "最近警报",
    "no_alarms": "最近没有警报",
    "unknown_device": "已移除的设备",
    "home_online": "{{on}} / {{total}} 台在线",
    "armed_hint": "布防模式：决定哪些侦测算警报",
    "fw_item": "{{name}}（当前 {{v}}）",
    "no_new_alarms_open_one": "最近没有新警报；还有 {{count}} 则较早的警报还没处理。",
    "no_new_alarms_open_other": "最近没有新警报；还有 {{count}} 则较早的警报还没处理。",
    "open_alarms": "还没处理的警报",
    "open_alarms_more": "看全部 {{count}} 条",
    "fw_all_latest_card_one": "全部最新（{{count}} 台）",
    "fw_all_latest_card_other": "全部最新（{{count}} 台）",
    "fw_unknown_note_one": "{{count}} 台读不到版本",
    "fw_unknown_note_other": "{{count}} 台读不到版本",
    "recorders_ok_one": "{{count}} 台正常",
    "recorders_ok_other": "{{count}} 台正常",
    "offline_short": "{{devices}} 台 · {{channels}} 通道",
    "offline_dev_only_one": "{{count}} 台",
    "offline_dev_only_other": "{{count}} 台",
    "offline_ch_only_one": "{{count}} 个通道",
    "offline_ch_only_other": "{{count}} 个通道",
    "todo_alarms_more_one": "{{count}}+ 条警报还没处理",
    "todo_alarms_more_other": "{{count}}+ 条警报还没处理",
    "todo_alarms_counting": "有警报还没处理（计算中）",
    "unlisted_open_one": "另有 {{count}} 条来自未登记或已移除的设备，不计入",
    "unlisted_open_other": "另有 {{count}} 条来自未登记或已移除的设备，不计入"
  },
  "devices": {
    "title": "设备",
    "search": "搜索名称、机型",
    "col_name": "名称",
    "col_home": "$t(leaf.cur) / 场所",
    "col_model": "机型",
    "col_kind": "类型",
    "col_fw": "固件",
    "col_status": "状态",
    "col_last_seen": "最后上线",
    "online": "在线",
    "offline": "离线",
    "unknown": "未知",
    "empty": "没有设备",
    "count_one": "共 {{count}} 台",
    "count_other": "共 {{count}} 台",
    "home_failed": "{{home}} 读取失败：{{err}}",
    "expand": "展开",
    "collapse": "收起",
    "channels": "{{n}} 路",
    "watch": "观看",
    "kind_native": "Kinio",
    "kind_child": "通道 / 子设备",
    "kind_lscloud": "LS Cloud",
    "kind_swann": "Swann",
    "filter_status": "状态",
    "filter_all": "全部状态",
    "view": "视图",
    "view_table": "表格",
    "view_tree": "依位置",
    "col_recording": "云端录像",
    "col_ai": "AI",
    "col_location": "位置",
    "seat_event": "事件席位",
    "seat_continuous": "全时席位",
    "reason_keepalive_timeout": "连接超时",
    "reason_gateway_lost": "平台连接中断",
    "reason_missed_check_in": "休眠后没回报",
    "reason_clean_close": "设备主动断开",
    "reason_probe_timeout": "探测超时",
    "reason_superseded": "被新连接取代",
    "reason_channel_offline": "通道离线",
    "reason_read_error": "读取失败",
    "reason_other": "原因不明",
    "count2_one": "{{count}} 台设备 · {{channels}} 个通道",
    "count2_other": "{{count}} 台设备 · {{channels}} 个通道",
    "count_tip": "设备 = 实体台数（一台 NVR 算 1）；通道另外算",
    "filter_cert": "只看证书快到期的",
    "filter_type": "类型",
    "type_all": "全部类型",
    "type_camera": "摄像头",
    "type_recorder": "录像主机",
    "type_sensor": "传感器",
    "cols": "栏位 ▾",
    "col_reason": "离线原因",
    "col_actions": "操作",
    "more": "{{name}} 的更多操作",
    "model_generic": "RTSP 摄像头（没有型号信息）",
    "model_unknown": "还没取得型号",
    "model_onvif": "ONVIF 摄像头"
  },
  "live": {
    "cameras": "摄像头",
    "no_cameras": "没有可观看的摄像头",
    "layout": "布局",
    "autofill": "填满在线摄像头",
    "empty_cell": "从左侧点选或拖动摄像头到这里",
    "back_to_wall": "回视频墙",
    "expand": "放大",
    "remove": "移出视频墙",
    "connecting": "连接中…",
    "offline": "设备离线",
    "no_video": "已连接，设备没有发送视频轨",
    "failed": "无法观看（{{code}}）",
    "err_DEVICE_OFFLINE": "设备离线",
    "err_CHANNEL_OFFLINE": "通道离线",
    "err_HARDWARE_ERROR": "设备影像引擎错误；持续发生请重新启动设备",
    "err_FORBIDDEN": "没有权限观看这台设备",
    "err_NO_WEBRTC": "浏览器不支持 WebRTC",
    "slow_first_frame": "已连接，尚未收到画面（电池 / HaLow 摄像头可能在休眠）",
    "err_MAX_SESSIONS_REACHED": "此设备同时观看已达上限，请先关闭其他画面",
    "err_VIEWER_LIMIT": "此设备同时观看已达上限，请先关闭其他画面",
    "watch_playback": "回放",
    "budget_note": "这台电脑同时解码上限 {{budget}} 路；另外 {{n}} 格显示预览，点“转实时”或放大才开实时。",
    "preview": "预览",
    "go_live": "转实时",
    "stream_main": "高画质",
    "stream_sub": "省流量",
    "reconnect_wait": "{{s}} 秒后自动重连（第 {{n}} 次）",
    "reconnecting": "重新连接中…（第 {{n}} 次）",
    "err_STALLED": "画面中断",
    "err_NETWORK": "网络中断",
    "err_CONNECT_TIMEOUT": "连接超时",
    "err_SIGNAL_CLOSED": "连接中断",
    "err_SESSION_REVOKED": "登录已失效（在别处退出或重置了密码），请重新登录",
    "err_ACCESS_REVOKED": "观看权限已被收回",
    "err_CODEC_UNSUPPORTED": "此通道编码（H.265）浏览器无法播放，请将此通道子码流改为 H.264",
    "err_INVALID_PAYLOAD": "无法建立连接（请求格式不符）",
    "path_lan": "局域网",
    "path_direct": "直连",
    "path_relay": "中继",
    "zoom_reset": "{{z}}× 还原",
    "zoom_hint": "滚轮放大、拖动移动、双击还原",
    "snapshot": "快照（下载）",
    "replay": "倒退 30 秒回看",
    "stream_switch": "切换画质：省流量 / 高画质（当前：{{s}}）",
    "stream_manual": "手动",
    "custom_grid": "自定义",
    "custom_cols": "列",
    "custom_rows": "行",
    "custom_apply": "应用",
    "err_RELAY_IDLE": "中继连接闲置太久，已断开",
    "err_RELAY_LIMIT": "中继连接单次 30 分钟到了，已断开",
    "relay_idle_warn": "中继连接闲置中，{{s}} 秒后断开",
    "relay_continue": "继续观看",
    "talk": "按住说话",
    "talking": "说话中…",
    "talk_starting": "开启麦克风…",
    "talk_hint": "按住说话，松开停止（聚焦后也可以按住空格键）",
    "listen_on": "开启现场声音",
    "listen_off": "关闭现场声音",
    "talk_forbidden": "你没有这台设备的对讲权限",
    "talk_incapable": "这台设备不支持对讲",
    "talk_busy": "另一位用户正在对讲",
    "talk_denied": "浏览器没有允许使用麦克风",
    "talk_error": "对讲开启失败，请再试一次",
    "talk_unavailable": "视频连上后才能对讲",
    "no_live_n_one": "{{count}} 台现在不能看实时视频",
    "no_live_n_other": "{{count}} 台现在不能看实时视频",
    "ms_popout": "开到另一个屏幕（电视墙）",
    "ms_pick_screen": "放到哪个屏幕",
    "ms_this_screen": "这个屏幕",
    "ms_drag_hint": "已打开新窗口；把它拖到要放的屏幕，按 F11 全屏。",
    "ms_blocked": "浏览器拦截了弹出窗口，请允许这个网站打开弹出窗口。",
    "ms_restore": "还原多屏幕配置（{{n}}）",
    "ms_wall": "视频墙（另一个屏幕）",
    "ms_f11": "按 F11 全屏",
    "ms_alarm_here": "警报在这个窗口弹出",
    "ms_claim_alarm": "这个窗口弹警报",
    "ms_close_wall": "关闭这面墙",
    "ms_budget_shared": "其他屏幕已用掉解码预算 {{used}} / {{total}} 路",
    "snapshot_at": "快照 {{at}}",
    "scope_changed": "范围已换到 {{name}}（{{n}} 个画面）。",
    "scope_fill": "用这个范围填满墙",
    "scope_keep": "保留当前的墙",
    "overflow_n_one": "还有 {{count}} 个画面在下一页",
    "overflow_n_other": "还有 {{count}} 个画面在下一页",
    "overflow_next": "下一页",
    "more_grids": "更多版式",
    "ms_popout_hint": "另开一个只有视频墙的窗口，可以拖到另一个屏幕全屏显示",
    "grid_key": "{{n}} 格（快捷键 {{key}}）",
    "stream_main_short": "高",
    "stream_sub_short": "省",
    "conn_info": "连接信息（路径、编码、分辨率）",
    "tile_more": "{{name}} 的更多操作（画质、连接信息、声音、快照、回看、PTZ）",
    "slow_first_frame_wired": "已连接，等第一个画面…",
    "slow_connect": "连接比平常久…",
    "wall_out_of_scope_one": "墙上有 {{count}} 格不在当前范围",
    "wall_out_of_scope_other": "墙上有 {{count}} 格不在当前范围",
    "wall_fill_scope": "换成本范围",
    "out_of_scope_tile": "这一格不在当前范围（在 {{where}}）",
    "scope_changed_all_on": "范围已换到 {{name}}（{{n}} 个画面都已经在墙上）。",
    "scope_ack": "知道了",
    "autofill_all_on": "范围内的画面都已经在墙上",
    "wall_pruned_one": "{{count}} 个画面已不在你能看的清单（摄像头被移走、解绑或没有权限了），已从墙上移除。",
    "wall_pruned_other": "{{count}} 个画面已不在你能看的清单（摄像头被移走、解绑或没有权限了），已从墙上移除。",
    "wall_pruned_undo": "复原",
    "wall_pruned_ok": "知道了",
    "cell_gone": "这台摄像头已不在你的清单",
    "cell_no_live": "这台设备没有实时影像",
    "err_UNREACHABLE": "连不上画面（设备状态是在线）",
    "err_ICE_FAILED": "连接中断，正在重连…",
    "failed_retrying": "连接中断，正在重连…",
    "failed_plain": "无法观看",
    "reconnect_now": "立刻重连",
    "focus": "专注",
    "focus_tip": "收起菜单，画面占满屏幕（Shift+F）",
    "focus_exit": "退出专注（Esc）",
    "empty_cell_focus": "退出专注模式后可加入摄像头"
  },
  "events": {
    "search": "搜索类型、设备、$t(leaf.cur)",
    "count": "{{n}} 条",
    "empty": "没有符合的事件",
    "class_motion": "动态",
    "class_sensor": "传感器",
    "class_system": "系统",
    "class_other": "其他",
    "live_new": "实时",
    "class_alarm": "警报",
    "class_detection": "侦测",
    "mark_all_seen": "全部标为已看",
    "unseen_n": "{{n}} 条未看的警报与侦测",
    "thumb_alt": "事件缩略图",
    "cls_name": {
      "motion": "移动",
      "person": "人",
      "human": "人",
      "vehicle": "车辆",
      "pet": "动物",
      "package": "包裹",
      "ai_label": "AI 侦测",
      "sound": "声音",
      "alarm": "警报",
      "tamper": "遮挡或破坏",
      "contact": "门窗",
      "occupancy": "有人 / 无人",
      "doorbell": "门铃",
      "call": "呼叫",
      "connection": "连接",
      "storage": "存储",
      "recording": "录像",
      "power": "电源",
      "ota": "固件更新",
      "credential": "证书",
      "system": "系统",
      "security_mode": "警戒模式",
      "bookmark": "书签"
    },
    "type_unknown": "其他事件",
    "chip_tip": "点一下只看这一类，再点一次回到全部；按住 ⌘ / Ctrl 可以多选",
    "more": "更多",
    "unregistered_channel": "{{parent}} / CH{{n}}（未登记的通道）",
    "device_unknown": "不在清单里的设备",
    "tab_alarms": "警报",
    "tab_alarms_n_one": "警报（未处理 {{count}}）",
    "tab_alarms_n_other": "警报（未处理 {{count}}）",
    "tab_all": "全部事件",
    "tab_saved": "已存搜索",
    "other_channels": "其他通道（{{n}}）",
    "device_unknown_tail": "不在列表里的设备（…{{tail}}）",
    "tag": {
      "person": "人",
      "human": "人",
      "vehicle": "车",
      "car": "车",
      "animal": "动物",
      "pet": "宠物",
      "dog": "狗",
      "cat": "猫",
      "package": "包裹",
      "face": "人脸",
      "bark": "狗叫",
      "glass_break": "玻璃破裂",
      "baby_cry": "哭声",
      "smoke_alarm": "烟雾警报声",
      "motion": "动态",
      "sound": "声音",
      "bicycle": "自行车",
      "motorcycle": "摩托车"
    },
    "other_devices": "其他（{{n}}）",
    "times_n": "× {{n}} 次（最早 {{since}}）",
    "times_only": "× {{n}} 次",
    "ep_lasted": "持续 {{dur}}",
    "ep_open": "进行中",
    "ep_stale": "没有收到结束记录",
    "ep_end_only": "结束",
    "times_counting": "计算中",
    "all_loaded": "已载入全部 {{n}} 次（合并成 {{rows}} 行）",
    "no_thumb": "没有缩略图",
    "tab_alarms_more_one": "警报（未处理 {{count}}+）",
    "tab_alarms_more_other": "警报（未处理 {{count}}+）",
    "ep_lasted_lt1": "持续不到 1 秒",
    "tab_alarms_counting": "警报（计算中）",
    "compose": {
      "multi_press_n": "连按 {{count}} 下",
      "contact_opened": "打开",
      "contact_closed": "关闭",
      "leak_detected": "检测到漏水",
      "leak_cleared": "漏水解除",
      "occupied": "有人",
      "unoccupied": "无人",
      "ai_detected": "AI {{what}}"
    },
    "lens_chip_a11y": "{{name}}的事件"
  },
  "playback": {
    "day": "日期",
    "pick_time": "拖动或点下方时间轴选择要回放的时间",
    "timeline": "录像时间轴",
    "type_continuous": "连续",
    "type_event": "事件",
    "no_recording_after": "这个时间之后没有录像",
    "tunnel_idle": "回放通道未开",
    "tunnel_opening": "建立回放通道…",
    "tunnel_open": "回放通道已连接",
    "tunnel_failed": "回放通道失败",
    "tunnel_closed": "回放通道已关闭",
    "err_MAX_SESSIONS_REACHED": "设备同时连接已达上限（实时视频与回放共用），请先关闭其他画面",
    "err_VIEWER_LIMIT": "设备同时连接已达上限（实时视频与回放共用），请先关闭其他画面",
    "err_CHANNEL_OFFLINE": "通道离线",
    "err_HARDWARE_ERROR": "设备影像引擎错误；持续发生请重新启动设备",
    "err_CODEC_UNSUPPORTED": "此通道编码（H.265）浏览器无法播放，请将此通道子码流改为 H.264",
    "err_INVALID_PAYLOAD": "无法建立连接（请求格式不符）",
    "err_TUNNEL_TIMEOUT": "回放通道超时",
    "unified": "时间轴",
    "all_sources": "查看全部来源",
    "src_cloud": "云端",
    "src_nvr": "NVR 硬盘",
    "src_sd": "SD 卡",
    "src_edge": "ONVIF edge",
    "src_backup": "异地备份",
    "gap": "缺口",
    "gap_offline": "设备离线",
    "gap_retention": "超出保留期",
    "gap_unknown": "来源未知（设备连不上）",
    "gap_not_recorded": "无录像",
    "gaps_title_one": "{{count}} 个缺口",
    "gaps_title_other": "{{count}} 个缺口",
    "summary": "{{spans}} 段录像、{{gaps}} 个缺口",
    "source_changed": "来源切换：{{from}} → {{to}}。",
    "end_of_day": "这天之后没有更多录像",
    "zoom_in": "放大",
    "zoom_out": "缩小",
    "pan_back": "往前",
    "pan_forward": "往后",
    "zoom_span": "窗口 {{span}}",
    "hours": "{{n}} 小时",
    "minutes": "{{n}} 分钟",
    "dst_day": "夏令时日（{{h}} 小时）",
    "err_no_recording_after": "这个时间之后没有录像",
    "err_TUNNEL_NOT_READY": "回放通道还没连上，稍候再试",
    "err_TUNNEL_FAILED": "回放通道失败，设备本地录像暂时看不到",
    "tz": "时区",
    "tz_site": "场所时区",
    "tz_browser": "浏览器时区",
    "src_node": "电脑端",
    "src_phone": "手机本机",
    "gap_paused": "暂停：{{reason}}",
    "unknown_node_offline": "未知（电脑目前离线）",
    "unknown_node_pending": "未知（电脑还没回报）",
    "unknown_phone_offline": "未知（手机目前离线）",
    "err_NODE_PLAYBACK_UNAVAILABLE": "电脑端的录像回放尚未提供（这段有录像，在电脑端）",
    "pause_app_background": "App 在后台",
    "pause_killed": "App 被关闭",
    "pause_updating": "更新中",
    "pause_schedule": "排程",
    "pause_home_mode": "主人在家",
    "pause_thermal": "过热",
    "pause_battery_low": "电量低",
    "pause_storage_full": "空间已满",
    "pause_camera_busy": "摄影机被占用",
    "pause_permission": "缺少摄影机权限",
    "pause_local_network_denied": "缺少本地网络权限",
    "pause_mic_denied": "缺少麦克风权限",
    "pause_plan_limit": "超过方案台数",
    "pause_in_pocket": "手机被收起",
    "pause_user": "手动暂停",
    "pause_source_unreachable": "电脑连不到摄像头",
    "pause_not_recorded": "按录像方式不录",
    "prev_month": "上个月",
    "next_month": "下个月",
    "day_has_rec": "{{day}}（有录像）",
    "day_legend": "有底色的日子有录像（云端或设备本机）",
    "event_density": "事件密度",
    "events_n_one": "{{count}} 条事件",
    "events_n_other": "{{count}} 条事件",
    "speed": "速度",
    "frame_back": "上一帧",
    "frame_fwd": "下一帧",
    "timeline_aria": "回放时间轴（拖动滚动、滚轮缩放；← / → 移动、Shift + ← / → 上下一个事件、空格键播放 / 暂停）",
    "seam": "已折叠 {{d}} 没有事件的时段",
    "dur_hm": "{{h}} 小时 {{m}} 分",
    "only_events": "只看有事件的时段",
    "no_events_day": "这天没有事件",
    "end_of_events": "这天之后没有更多事件",
    "group_person": "人",
    "group_vehicle": "车",
    "group_animal": "动物",
    "group_package": "包裹",
    "group_sound": "声音",
    "group_sensor": "传感器",
    "group_alarm": "警报",
    "group_motion": "移动",
    "skipped_from": "{{gaps}}，已从 {{at}} 开始播放。",
    "err_local_unreachable": "读不到 {{name}} 的 {{src}}录像（设备没有响应）。",
    "err_source_unreachable": "读不到这段录像（{{src}}）。请稍后重试。",
    "err_decode": "浏览器播放不了这段录像（格式不支持或文件损坏）。",
    "err_generic": "这段录像播放不了。请稍后重试。",
    "err_detail": "详细",
    "no_sources": "这台摄像头没有任何录像来源：没有 SD 卡或录像主机，云端录像也没有开启。",
    "no_recording_unreachable": "这一天没有读到录像：有来源连不上（设备离线或没响应），可能还有录像没显示出来。",
    "no_recording_day": "这一天没有任何来源的录像。可能原因：",
    "go_last_day": "看最近有录像的一天（{{day}}）",
    "err_overlay": "这段播放不了（原因在下方）",
    "err_local_offline": "{{name}} 离线，读不到它的本地录像。",
    "err_cloud_unreachable": "云端录像暂时读不到，请稍后再试。",
    "err_no_cloud": "这台没有云端录像。",
    "err_forbidden": "你没有这台的回放权限。",
    "try_cloud": "改看云端录像",
    "try_source": "改看{{src}}",
    "go_nearest": "跳到最近的录像",
    "buy_seats": "购买席位",
    "gap_none_span": "{{from}}–{{to}} 没有录像",
    "why_overwritten": "{{src}}已循环覆写（旧的录像会被新的覆盖）",
    "why_no_cloud": "没有开云端录像",
    "why_schedule": "录像排程没有涵盖这段时间",
    "why_offline": "{{name}} 这段时间离线",
    "no_rec_events_one": "这天有 {{count}} 条事件，但没有录像可以播放。",
    "no_rec_events_other": "这天有 {{count}} 条事件，但没有录像可以播放。",
    "from_event": "从事件：{{name}} · {{cam}} · {{at}}",
    "from_event_generic": "事件",
    "from_event_dismiss": "去掉这个标示",
    "drag_hint": "拖动时间轴换时间，中间的线就是播放位置；点一下直接跳过去。",
    "hint_ok": "知道了",
    "settings": "时间轴设置（时区、图例、只看有事件的时段、查看全部来源）",
    "modes": "回放模式",
    "mode_single": "单路",
    "day_no_rec": "这天没有录像",
    "why_local_unreachable": "{{name}} 的 {{src}}录像目前读不到（设备没有响应）。",
    "why_local_offline": "{{name}} 离线，读不到它的 {{src}}录像。",
    "why_cloud_no_clip": "{{name}} 在这段时间没有云端片段（云端只存事件片段）。",
    "why_cloud_retention": "这段已超过云端保存期限（{{n}} 天）。",
    "why_local_empty": "{{src}}在这段时间也没有录像（可能已循环覆写，或排程没录这段）。",
    "retry_local": "重试读 {{src}}",
    "seek_no_rec": "{{at}} 没有录像，从 {{from}} 开始播。",
    "fallback": "读不到 {{dev}} 的 {{src}}，改播{{to}}的录像（{{at}} 起）。",
    "cam_not_found": "找不到这台摄像头（可能已移除，或你没有回放权限）。请在左边或上方选一台。",
    "pick_camera": "选一台摄像头…",
    "slow": "{{src}}的录像加载很久，还没有画面。",
    "slow_fallback": "{{src}}的录像 {{sec}} 秒还没有画面，已改看{{to}}（{{at}} 起）。",
    "avoid_broken": "{{dev}} 的 {{src}}刚才读不到，先播{{to}}（{{at}} 起）。",
    "src_missing": "这台在这段时间没有{{src}}的录像，改用其他来源。",
    "back_to": "改回{{src}}",
    "src_pinned": "你选的来源：换摄像头也会沿用",
    "src_auto_hint": "自动选的来源（最近播得出来的优先）",
    "src_auto": "改回自动选来源",
    "play": "▶ 播放",
    "pause": "⏸ 暂停",
    "sound_on": "🔇 开声音",
    "sound_off": "🔊 关声音",
    "fullscreen": "⛶ 全屏",
    "cloud_suspect": "这段云端片段可能不完整（片段长度不合理），画面可能是绿色或卡住。",
    "cloud_suspect_switched": "这段云端片段可能不完整（片段长度不合理），已改看{{to}}（{{at}} 起）。",
    "events_n_more": "超过 {{count}} 条事件（只标了前 {{count}} 条）",
    "slow_tier_hint": "网络不够快，回放会断断续续。建议把录像画质改成标准（只影响之后的录像）。",
    "slow_tier_switch": "改成标准",
    "slow_tier_never": "不再提示",
    "slow_tier_close": "关闭",
    "slow_tier_done": "已改成标准。之后的录像会用标准画质，已录的不变。",
    "slow_tier_sent": "已发送，摄像头连上后会改成标准。",
    "slow_tier_hint_no_write": "网络不够快，回放会断断续续。有这台设置权限的人可以把录像画质改成标准。",
    "slow_tier_failed": "没改成，请到设备的“录像与存储”分页 › 录像画质再试一次。",
    "err_local_host_limit": "{{name}} 的录像主机同时最多 {{n}} 路本地回放，这一路没有加载；可以改看单路。"
  },
  "map": {
    "plans": "平面图",
    "upload": "上传平面图",
    "place_devices": "摆放设备",
    "pick_device": "先点选设备，再点平面图放下",
    "click_to_place": "点平面图上的位置放下",
    "done": "完成",
    "edit": "编辑摆放",
    "delete": "删除平面图",
    "confirm_delete": "删除平面图「{{name}}」？",
    "no_map_key": "地图需要品牌方申请的 Google / 百度 key（brands/<Brand>/vms/vms.yaml maps.*）。平面图模式不受影响。",
    "empty": "还没有平面图。上传楼层图（PNG / JPG / SVG / WebP，20 MB 内）后把摄像头与传感器摆上去。",
    "rotate_left": "向左转 15°",
    "rotate_right": "向右转 15°",
    "remove": "移除",
    "load_demo": "载入示例平面图（自动摆放）",
    "demo_name": "示例 1F",
    "owner": "上传到",
    "conflict": "数据已被别人改过，已重新读取，请再操作一次",
    "empty_readonly": "还没有平面图；$t(leaf.cur)拥有者 / 管理员 或组织管理员可以上传。",
    "mode_map": "地图",
    "mode_plan": "平面图",
    "load_failed": "地图加载失败：{{err}}",
    "fallback": "{{from}} 加载失败，已改用 {{to}}",
    "provider": "地图",
    "provider_google": "Google",
    "provider_baidu": "百度",
    "provider_dev": "开发用底图",
    "dev_basemap": "开发环境：品牌还没有 Google / 百度地图密钥，先用开发用底图（正式环境不会出现）。",
    "health_ok": "正常",
    "health_warn": "有设备离线",
    "health_alarm": "警报中",
    "sites": "场所",
    "set_location": "在地图上点选位置",
    "click_map_home": "点地图设置这个场所的位置",
    "click_map_to_place": "点地图放下（再点一次设备可以移动）",
    "overlays": "平面图叠图",
    "align": "对齐",
    "opacity": "透明度",
    "heading": "朝向",
    "fov": "视角",
    "range": "距离",
    "move": "移动",
    "align_title": "对齐“{{name}}”",
    "align_help": "在平面图上点一个点，再到地图上点同一个位置；2 点 = 平移旋转缩放，3 点 = 可修正变形。",
    "align_click_img": "点平面图上的第 {{n}} 点",
    "align_click_map": "到地图上点第 {{n}} 点的实际位置",
    "align_save": "应用（{{n}} 点）",
    "align_reset": "重来",
    "align_clear": "取消叠图",
    "align_bad": "控制点不能重叠或共线",
    "align_ready": "3 点都选好了，按“应用”",
    "timezone": "时区",
    "timezone_unset": "时区（未设，用浏览器）",
    "events_recent": "最近事件（{{n}}）",
    "events_results": "搜索结果（{{n}}）",
    "events_clear": "清除搜索结果",
    "events_title": "事件",
    "events_none": "没有事件",
    "events_playback": "回放这一段",
    "events_help": "有事件的设备在图上闪烁；点一条会标出那台设备。只有已经摆到图上的设备看得到位置。",
    "search_placeholder": "搜索地址或地名",
    "search": "搜索",
    "search_none": "找不到这个地址",
    "search_busy": "地址搜索太频繁，稍后再试",
    "search_attrib": "开发用地址搜索：© OpenStreetMap 贡献者（Nominatim）",
    "tiles_failed": "地图底图暂时加载不了。",
    "use_plan": "改用平面图",
    "alarms_only": "只看警报",
    "unplaced_devices_one": "还没放到地图上的设备（{{count}}）· {{home}}",
    "unplaced_devices_other": "还没放到地图上的设备（{{count}}）· {{home}}",
    "placed_devices_one": "已放上地图（{{count}}）",
    "placed_devices_other": "已放上地图（{{count}}）",
    "all_placed": "这个场所的设备都放上地图了。",
    "timezone_change": "改",
    "timezone_edit": "改时区",
    "site_health_alarm": "红：这里有设备正在警报",
    "site_health_warn": "黄：这里有设备离线",
    "site_health_ok": "绿：这里的设备都正常",
    "location_set": "位置：已设置",
    "location_unset": "位置：未设置",
    "location_pick": "设置",
    "location_move": "移动",
    "timezone_label": "时区：{{tz}}",
    "timezone_unset_short": "未设（用浏览器）",
    "unplaced_devices_ch": "还没放到地图上的设备（{{count}}，含 {{ch}} 个通道）· {{home}}"
  },
  "mfa": {
    "title": "两步验证",
    "code_body": "打开验证器 App（Google Authenticator、Microsoft Authenticator 等），输入 6 位数验证码。",
    "code": "验证码",
    "recovery_hint": "手机不在身边？输入一组恢复码（xxxx-xxxx）。",
    "verify": "验证",
    "enroll_title": "设置两步验证",
    "enroll_body": "用验证器 App 扫描 QR code，再输入 App 显示的 6 位数验证码。",
    "first_code": "App 显示的验证码",
    "enable": "激活两步验证",
    "recovery_title": "恢复码",
    "saved_continue": "我已妥善保存，继续",
    "qr_alt": "验证器 App 设置 QR code",
    "manual_entry": "无法扫描？手动输入密钥：",
    "recovery_notice": "每组恢复码只能用一次。请存放在安全的地方（密码管理器或纸质），这是遗失手机时唯一的登录方式，之后不会再显示。",
    "copy_codes": "拷贝全部",
    "section": "两步验证",
    "enabled": "已激活",
    "disabled": "未激活",
    "required_policy": "你参加的组织要求两步验证",
    "recovery_remaining": "剩 {{n}} 组恢复码",
    "regenerate": "重新产生恢复码",
    "regenerate_body": "旧的恢复码会全部作废。请输入目前的验证码。",
    "disable": "停用两步验证",
    "disable_body": "停用后只靠密码登录。请输入密码与目前的验证码。",
    "err_MFA_CODE_INVALID": "验证码错误或已使用过",
    "err_MFA_TOKEN_INVALID": "验证逾时，请重新输入密码",
    "err_RATE_LIMITED": "尝试太多次，请稍后再试",
    "err_INVALID_CREDENTIALS": "密码错误",
    "err_MFA_REQUIRED": "请输入验证码",
    "err_MFA_ALREADY_ENABLED": "两步验证已激活",
    "err_MFA_NOT_SETUP": "尚未设置两步验证",
    "err_MFA_REQUIRED_BY_POLICY": "你参加的组织要求两步验证：至少要保留一种（TOTP 或 passkey）",
    "err_SESSION_UNKNOWN": "登录状态已更新，请再试一次",
    "err_NETWORK": "无法连接，请检查网络",
    "err_IDENTITY_UNAVAILABLE": "账号服务暂时无法连接",
    "err_default": "验证失败（{{code}}）"
  },
  "stepup": {
    "title": "重新验证身分",
    "body": "这是敏感操作（授权、停用成员等），请在 5 分钟内重新验证。",
    "code_hint": "开了两步验证：打开验证 App（Google Authenticator 等），输入 Kinio 那一项当前的 6 位数。没开就留空，只填密码。",
    "submit": "验证并继续",
    "code": "两步验证码",
    "code_optional": "两步验证码（开了才要填）",
    "code_hint_on": "打开验证 App（Google Authenticator、Microsoft Authenticator 等），输入 Kinio 那一项当前的 6 位数；手机不在身边可以输入一组备用码（xxxx-xxxx）。"
  },
  "settings": {
    "security": "安全性",
    "org": "组织",
    "notifications": "通知"
  },
  "activate": {
    "title": "接受邀请",
    "bad_link": "邀请链接不完整或已失效，请向邀请你的人索取新的邀请。",
    "done": "账号 {{email}} 已创建并加入。请回登录页登录。",
    "to_login": "前往登录",
    "body": "你被邀请加入一个组织（或有人分享设备给你）。已经有账号就直接登录；还没有就用这个邀请注册（email 是受邀的那个，不能改）。",
    "display_name": "显示名称（选填）",
    "password_hint": "至少 8 个字符，避免常见密码。",
    "password_again": "再输入一次密码",
    "mismatch": "两次输入的密码不一样",
    "submit": "注册并加入",
    "err_INVITE_GONE": "邀请已失效或已使用，请管理员重新邀请",
    "err_ACCOUNT_EXISTS": "这个 email 已有账号，请直接登录",
    "err_WEAK_PASSWORD": "密码太短或太常见",
    "err_INVITE_EMAIL_MISMATCH": "邀请的 email 跟你登录的账号不同",
    "err_default": "激活失败（{{code}}）",
    "have_account": "我已经有账号，登录",
    "no_account": "我还没有账号，注册",
    "register_body": "设置密码后就会创建账号并加入。这个账号也能登录品牌 App。",
    "done_existing": "这个 email 已经有账号，已直接加入。请用原本的密码登录。",
    "done_share": "分享已生效，设备会出现在「别人分享给我」。",
    "err_INVITE_EMAIL_MISMATCH_masked": "这个邀请是给 {{email}} 的，请改用那个账号登录。",
    "err_ALREADY_MEMBER": "你已经是这个组织的成员",
    "err_ORG_SUSPENDED": "这个组织已被停用，不能加入",
    "err_EMAIL_NOT_VERIFIED": "先验证你的 email，才能接受邀请。",
    "org": "组织",
    "invited_by": "邀请人",
    "invited_email": "受邀 email",
    "expires": "到期",
    "already_member": "你已经是这个组织的成员（{{role}}）。",
    "accept": "接受并加入",
    "joined": "已加入「{{name}}」。组织的设备会出现在「组织授权给我」。",
    "joined_short": "已接受邀请。",
    "switch_account": "退出，换账号",
    "to_devices": "前往设备",
    "joined_org": "已加入「{{name}}」。"
  },
  "org": {
    "err_default": "操作失败（{{code}}）",
    "err_VERSION_CONFLICT": "数据已被别人更新，请刷新后再试",
    "err_REAUTH_REQUIRED": "需要重新验证身分才能运行",
    "err_SITE_CYCLE": "不能把场所搬到自己底下",
    "err_CROSS_TREE": "场所不在同一棵树",
    "err_SITE_ARCHIVED": "场所已封存",
    "err_OUT_OF_ANCHOR": "设备不在这个场所范围内",
    "err_OUT_OF_SITE": "指定的设备不在授权场所内",
    "err_SITE_NOT_RELATED": "授权的场所要是这个$t(leaf.cur)所在场所的上层或下层",
    "err_EMPTY_SCOPE": "范围内没有任何设备",
    "err_GRANT_TOO_LONG": "授权最长 90 天",
    "err_NOT_ACTIVE_ORG_MEMBER": "对象不是这个组织在职的成员",
    "err_ROLE_NOT_GRANT": "这个角色不是数据授权角色",
    "err_NO_ACTIONS": "至少选一个动作",
    "err_BAD_SITE": "场所数据不正确（名称 1–64 字）",
    "err_BAD_TIMEZONE": "时区格式不正确（例如 Asia/Taipei）",
    "err_ALREADY_MEMBER": "对方已经是成员",
    "err_TOO_MANY_INVITES": "待接受的邀请太多，请先撤销不用的",
    "err_LAST_ORG_ADMIN": "至少要保留一位组织管理员",
    "err_SELF": "不能停用自己",
    "err_LIMIT": "已达上限",
    "err_ORG_LIMIT": "每人最多创建 5 个组织（你的家不算）",
    "err_FORBIDDEN": "没有权限",
    "err_NOT_FOUND": "找不到数据",
    "err_NETWORK": "无法连接，请检查网络",
    "no_site_permission": "你没有管理这个组织场所的权限，请洽组织管理员。",
    "create_title": "创建组织",
    "create_body": "公司、店、社区、保全、安装商都可以建组织：有自己的场所树、成员、角色与安全政策。你是拥有者。每人最多建 5 个（你的家不算）。",
    "name": "组织名称",
    "create": "创建",
    "sites_title": "{{name}} 的场所",
    "add_root_site": "添加场所",
    "revoked_grants": "已撤销 {{n}} 笔受影响的授权",
    "no_sites": "还没有场所。先添加总部或第一个据点。",
    "kind_site": "据点",
    "kind_building": "建筑",
    "kind_floor": "楼层",
    "kind_zone": "区域",
    "archived": "已封存",
    "add_child": "添加子场所",
    "add_home": "添加$t(leaf.cur)",
    "archive": "封存",
    "restore": "恢复",
    "home": "$t(leaf.cur)",
    "add_child_of": "在「{{name}}」底下添加",
    "edit_site": "编辑「{{name}}」",
    "add_home_at": "在「{{name}}」新增$t(leaf.cur)",
    "home_body": "$t(leaf.cur)是设备实际所在的空间（例如「我家」「A 栋监控」）。设备配对进这个$t(leaf.cur)后，就能依角色与授权使用。",
    "home_name": "$t(leaf.cur)名称",
    "kind": "类型",
    "site_name": "名称",
    "timezone": "时区",
    "parent": "上层场所",
    "parent_root": "（最上层）",
    "move_warning": "搬移会撤销不再涵盖的授权。",
    "pick": "组织",
    "err_OWNS_HOMES": "他还是$t(leaf.cur)的管理人，请先交接",
    "err_HOME_UNASSIGNED": "这个$t(leaf.cur)目前无人管理，请组织管理员先接管",
    "err_NOT_OWNER": "交接要由现任管理人发起",
    "err_REASON_REQUIRED": "请填写理由",
    "err_IDEMPOTENCY_KEY_REQUIRED": "请刷新后再试",
    "err_HOME_NOT_FOUND": "找不到这个$t(leaf.cur)",
    "err_WOULD_LOCK_OUT": "保存后你会被挡在外面（目前的 IP 不在清单内，或这次登录没有两步验证）",
    "err_BAD_CIDR": "IP / CIDR 格式不正确",
    "err_IP_NOT_ALLOWED": "组织的安全政策不允许从这个网络访问",
    "err_BAD_SCHEDULE": "时段设置不正确",
    "my_orgs": "我的组织",
    "my_orgs_hint": "每个账号都有自己的家（个人组织，不能离开或删除）；也可以另建组织（公司、店、社区…），或被邀请加入别的组织。各组织彼此看不到。",
    "kind_col": "种类",
    "kind_personal": "个人",
    "kind_team": "团体",
    "personal_badge": "我的家",
    "requires_mfa": "要求两步验证",
    "manage": "管理",
    "leave": "离开",
    "leave_confirm": "离开「{{name}}」？",
    "leave_body": "只会失去这个组织给你的权限；你自己的家、其他组织与别人分享给你的都不受影响。之后要回来得再被邀请。",
    "created": "已创建「{{name}}」，你是拥有者。",
    "personal_hint": "这是你的家（个人组织）：在这里新增$t(leaf.cur)与场所、邀请家人。不能离开、转移或删除，跟着账号。",
    "team_hint": "团体组织：组织角色只管组织事务；看视频要有$t(leaf.cur)角色或场所授权。",
    "member_count_one": "{{count}} 位成员",
    "member_count_other": "{{count}} 位成员",
    "owner_transfer": "转移拥有权",
    "owner_transfer_of": "转移「{{name}}」的拥有权",
    "owner_transfer_hint": "新拥有者要是在职的管理员；你会变成管理员。会通知双方与其他管理员。",
    "new_owner": "新拥有者",
    "no_admins": "还没有其他管理员：先在成员分页把要接手的人设为管理员。",
    "owner_transfer_done": "拥有权已转移。",
    "delete": "删除组织",
    "delete_confirm": "删除「{{name}}」？",
    "delete_body": "成员会全部离开、分享给这个组织的分享会结束。组织还有$t(leaf.cur)时不能删，要先删除或移走$t(leaf.cur)。这个动作不能复原。",
    "err_ORG_NOT_EMPTY": "组织还有$t(leaf.cur)，先删除或移走这些$t(leaf.cur)：",
    "err_INVALID_NAME": "组织名称要 2–60 字",
    "err_OWNER_REQUIRED": "只有拥有者能做这件事",
    "err_OWNER_CANNOT_LEAVE": "拥有者不能离开：你的家跟着账号；团体组织请先转移拥有权",
    "err_OWNER_ROLE": "拥有者的角色只能用转移拥有权改",
    "err_PERSONAL_ORG": "你的家（个人组织）不能转移或删除",
    "err_TARGET_NOT_ORG_ADMIN": "对象要是这个组织在职的管理员",
    "err_NOT_AN_ORG_MEMBER": "对方已经不是这个组织的成员",
    "err_ORG_SUSPENDED": "这个组织已被停用，不能做任何变更",
    "err_ORG_MFA_REQUIRED": "这个组织要求两步验证：开启后重新登录",
    "err_ORG_NOT_FOUND": "找不到这个组织",
    "err_DEV_HOME_NOT_ALLOWED": "在这个环境建组织或$t(leaf.cur)要先开放",
    "err_TEST_IDENTITY_REQUIRED": "在这个环境只有测试账号能建组织或$t(leaf.cur)",
    "err_FEATURE_DISABLED": "这个环境不提供这项功能",
    "err_BAD_EMAIL": "email 格式不正确",
    "err_BAD_ROLE": "这个角色不能用在这里",
    "err_INVALID_ROLE": "这个角色不能用在这个组织",
    "err_INVITE_GONE": "邀请已失效或已使用",
    "err_SHARE_EXISTS": "已经有一笔同样用途的分享，请在原本那笔调整",
    "err_SHARE_NOT_FOUND": "找不到这笔分享",
    "err_SHARE_SCOPE_EXCEEDED": "超过分享的范围",
    "err_GRANT_EXCEEDS_ROLE": "不能分享你自己没有的权限",
    "err_INVALID_SCOPE": "勾选的权限不能用在这里",
    "err_INVALID_GRANTEE": "分享对象不正确",
    "err_SCOPE_EXPAND": "只能缩小，要扩大请重新分享",
    "err_TOO_LONG": "期限超过这种用途的上限",
    "err_REQUEST_GONE": "分享请求已失效或已使用",
    "err_ORG_NOT_VERIFIED": "这个组织还没通过这种用途的审核",
    "err_NOT_A_RENEWAL": "这个代码不是续约请求",
    "err_NOT_INSTALL": "只有安装分享能完成安装",
    "err_EMAIL_EXISTS": "这个 email 已有账号",
    "err_BAD_TARGET": "选的设备不在这个$t(leaf.cur)",
    "err_BAD_POLICY": "政策设置不正确",
    "err_SITE_NOT_FOUND": "找不到这个场所",
    "rename": "改名",
    "rename_of": "改「{{name}}」的名称",
    "err_USE_ORG_API": "请改成离开组织",
    "err_USER_NOT_FOUND": "对方要先是这个组织的成员",
    "err_UNAVAILABLE": "暂时无法使用，稍后再试",
    "err_NOT_ORG_HOME": "$t(leaf.cur)不在所选节点下面",
    "err_IDEMPOTENCY_CONFLICT": "同一个请求的内容变了，请关掉对话框重来",
    "err_IDEMPOTENCY_IN_PROGRESS": "上一个请求还在处理，稍后再试",
    "err_RATE_LIMITED": "太频繁了，请稍后再试",
    "err_CLAIM_NOT_FOUND": "序列号或订单号对不上",
    "levels_hint": "结构树上每一层的名字（例：区域 › 据点 › 楼层 › 家庭），也用在路径与报表。",
    "err_SHARE_KIND_NOT_ALLOWED": "Kinio Node 与 Wi-Fi 基站不能分享（没有影像或数据可以交给对方），请去掉这两种设备再提交。"
  },
  "people": {
    "members": "成员",
    "grants": "授权",
    "roles": "角色",
    "home_members": "$t(leaf.cur)成员",
    "members_of": "{{name}} 的成员",
    "invite": "邀请成员",
    "members_hint": "成员能看到的设备由$t(leaf.cur)角色与场所授权决定（组织角色只管组织事务）；停用或移出的成员 30 秒内会被中断实时视频与回放。",
    "name": "人员",
    "role": "角色",
    "status": "状态",
    "org_perms": "组织权限",
    "joined": "加入时间",
    "all_perms": "全部",
    "edit_perms": "权限",
    "suspend": "停用",
    "reactivate": "恢复",
    "pending_invites": "待接受的邀请",
    "expires": "{{date}} 到期",
    "revoke_invite": "撤销",
    "org_role_org_admin": "管理员",
    "org_role_developer": "开发者",
    "status_active": "正常",
    "status_suspended": "已停用",
    "status_left": "已离开",
    "edit_perms_of": "{{name}} 的组织权限",
    "perms_hint": "组织权限不含看视频；看视频要另外在“访问权限”授予。",
    "perm_org_sites": "场所与人员",
    "perm_org_sites_desc": "管理场所树、$t(leaf.cur)、授权",
    "perm_org_audit": "审计",
    "perm_org_audit_desc": "查看审计日志",
    "perm_org_billing": "帐单",
    "perm_org_billing_desc": "方案、付款与用量",
    "invite_link_body": "{{email}} 还没有账号，已寄出邀请信。也可以把这个链接直接交给对方（7 天内有效）：",
    "invite_body": "一律用 email 邀请：对方已经有账号就直接加入、会收到通知；还没有账号就寄邀请信，用邀请注册后加入（7 天内有效）。",
    "invite_role_hint": "“成员”本身没有任何设备权限，要在“访问权限”分页〔＋ 授予访问权限〕另外授予；只有拥有者能邀请管理员。",
    "send_invite": "发送邀请",
    "filter_user": "筛选人员",
    "all_users": "全部人员",
    "show_revoked": "显示已撤销",
    "assign": "指派授权",
    "grants_hint": "授权 = 人 × 场所 × 设备范围 × 期限。场所搬移或设备换位置后，需按「刷新」重新展开目标。",
    "no_grants": "还没有授权。",
    "site": "场所",
    "home": "$t(leaf.cur)",
    "scope": "设备范围",
    "expires_col": "到期",
    "incl_desc": "（含子场所）",
    "scope_all": "场所内全部",
    "scope_list": "指定 {{n}} 台",
    "targets": "{{n}} 个目标",
    "grant_active": "有效",
    "grant_expired": "已到期",
    "grant_revoked": "已撤销",
    "refresh": "刷新",
    "refresh_hint": "依目前的场所与设备位置重新展开目标（可延长期限）",
    "revoke": "撤销",
    "revoke_confirm": "确定撤销？对方 30 秒内会失去这些设备的访问。",
    "assigned": "已授权，展开为 {{n}} 个设备目标：",
    "include_descendants": "包含子场所",
    "no_related_homes": "这个场所的上下层没有$t(leaf.cur)",
    "custom_actions": "自订动作…",
    "actions": "动作",
    "scope_all_desc": "场所内全部设备（之后添加的要刷新）",
    "scope_list_desc": "只限指定设备",
    "devices": "设备清单",
    "days": "有效天数",
    "days_hint": "最长 90 天，到期前可刷新延长。",
    "stepup_note": "送出时可能要求重新验证身分。",
    "new_role": "添加角色",
    "role_kind": "类型",
    "kind_grant": "数据授权",
    "kind_home_admin": "$t(leaf.cur)管理",
    "kind_org_admin": "组织管理",
    "kind_org_permission": "组织权限",
    "system": "系统",
    "pending_apply": "添加的动作不会自动套用到既有授权：有 {{n}} 笔授权待套用，按〔套用〕才生效。",
    "pending_chip": "{{n}} 笔待套用",
    "apply": "套用",
    "apply_title": "套用到既有授权",
    "apply_confirm": "把「{{role}}」目前的动作套用到 {{n}} 笔还没更新的授权？各授权另外勾选的动作会保留。",
    "applied": "已套用到 {{n}} 笔授权。",
    "edit_role": "编辑角色",
    "role_name": "角色名称",
    "role_desc": "说明",
    "role_edit_note": "拿掉动作会立刻缩减所有使用这个角色的授权；加入的动作要按〔套用〕才会加到既有授权。",
    "home_members_hint": "$t(leaf.cur)角色只给本组织的成员；家人要先加入你的家（成员分页）。这里列出你看得到的成员。",
    "members_hidden": "你通过组织授权访问这个$t(leaf.cur)，看不到成员名单。",
    "hrole_owner": "拥有者",
    "hrole_admin": "管理员",
    "hrole_member": "成员",
    "hrole_guest": "访客",
    "hrole_undefined": "授权",
    "access": "权限来源",
    "access_of": "{{name}} 的权限来源",
    "src_org": "组织",
    "src_homes": "$t(leaf.cur)角色",
    "src_grants": "场所授权（{{n}} 笔有效）",
    "src_note": "组织角色本身不带视频权；看视频要有$t(leaf.cur)角色或场所授权。",
    "owns_homes": "他还是以下$t(leaf.cur)的管理人，请先到“组织与场所”交接；确定没有接任者才设为无人管理：",
    "unassign_owned": "没有接任者，这些$t(leaf.cur)改为「无人管理」（之后只能由组织管理员接管）",
    "left_done": "已移出：撤销 {{grants}} 笔授权、移除 {{homes}} 个$t(leaf.cur)角色、{{unassigned}} 个$t(leaf.cur)改为无人管理。",
    "schedule": "时段限制",
    "schedule_on": "只在指定时段有效（场所时区 {{tz}}）",
    "dow_1": "一",
    "dow_2": "二",
    "dow_3": "三",
    "dow_4": "四",
    "dow_5": "五",
    "dow_6": "六",
    "dow_7": "日",
    "from": "开始",
    "to": "结束",
    "duty_mode": "值班操作台账号",
    "duty_mode_desc": "闲置不注销、每 12 小时重新登录、不能导出录像",
    "duty_badge": "值班",
    "org_role_owner": "拥有者",
    "org_role_member": "成员",
    "org_role_guest": "访客",
    "org_role_factory_ops": "产线",
    "role_of": "{{name}} 的角色",
    "members_hint_personal": "加入你家的人（例如家人）：管理员看得到、也管得到全部$t(leaf.cur)；成员看得到全部$t(leaf.cur)；访客默认看不到设备，逐台开放。",
    "invite_body_personal": "邀请家人加入你的家。对方已经有账号就直接加入；没有就寄邀请信（7 天内有效）。",
    "invite_role_hint_personal": "管理员看得到也管得到全部$t(leaf.cur)；成员看得到全部$t(leaf.cur)；访客默认看不到设备。只有拥有者能邀请管理员。",
    "invite_joined": "{{email}} 已经有账号，已直接加入并收到通知。",
    "invite_here": "在这个网站接受邀请的链接：",
    "perm_org_devices": "设备库存",
    "perm_org_devices_desc": "看库存、认领、预先指派与收编（不含看视频）",
    "remove": "移出",
    "remove_of": "移出 {{name}}",
    "remove_body": "只收回这个组织给他的权限（$t(leaf.cur)角色、场所授权、分享给本组织的设备）；他自己的家、其他组织、别人分享给他的都不受影响。30 秒内停止他在这个组织的实时视频。账号本身保留（可再邀请）。",
    "invited_by": "{{name}} 邀请",
    "perm_org_support": "问题反馈",
    "perm_org_support_desc": "反馈问题、查看本组织的反馈（不含看画面）"
  },
  "roles": {
    "role-org-admin": "组织管理员",
    "role-org-admin_desc": "组织、场所树、成员、帐单、审计；看视频要另外授权",
    "role-site-admin": "场所管理员",
    "role-site-admin_desc": "范围内$t(leaf.cur)的管理员：设备、授权、录像政策",
    "role-operator": "操作员",
    "role-operator_desc": "即时、回放、对讲、PTZ、警报器",
    "role-viewer": "观看者",
    "role-viewer_desc": "即时与事件",
    "role-technician": "安装技师",
    "role-technician_desc": "对焦调角度、设置；不看回放与事件历史",
    "role-auditor": "审计员",
    "role-auditor_desc": "审计日志"
  },
  "actions": {
    "device": {
      "read": "看设备",
      "control": "控制设备",
      "install": "安装设备",
      "diagnose": "远程侦测"
    },
    "media": {
      "live": "实时视频",
      "talk": "对讲"
    },
    "recording": {
      "read": "回放",
      "export": "导出录像"
    },
    "event": {
      "read": "看事件"
    },
    "case": {
      "read": "看案件",
      "handle": "处理案件"
    },
    "alarm": {
      "receive": "收警报"
    },
    "security": {
      "arm": "远程布防",
      "disarm": "远程撤防"
    },
    "home": {
      "profile": {
        "read": "看$t(leaf.cur)数据"
      }
    },
    "install": {
      "complete": "完成安装"
    }
  },
  "audit": {
    "pick_org": "选择要查看的组织。",
    "action": "动作",
    "all_actions": "全部动作",
    "actor": "操作者",
    "all_actors": "全部操作者",
    "empty": "没有符合的纪录。",
    "system": "系统",
    "more": "加载更早的纪录",
    "a_org_create": "创建组织",
    "a_site_create": "添加场所",
    "a_site_update": "修改场所",
    "a_home_create": "添加$t(leaf.cur)",
    "a_home_member_add": "指派$t(leaf.cur)成员",
    "a_device_location": "设备换位置",
    "a_grant_create": "指派授权",
    "a_grant_refresh": "刷新授权",
    "a_grant_revoke": "撤销授权",
    "a_role_create": "添加角色",
    "a_role_update": "修改角色",
    "a_member_update": "修改成员",
    "a_member_join": "成员加入",
    "a_member_activate": "接受邀请加入",
    "a_member_leave": "成员离开",
    "a_home_owner_handover": "管理人交接",
    "a_home_owner_takeover": "受控接管",
    "a_home_unassigned": "$t(leaf.cur)改为无人管理",
    "a_org_security_policy": "修改安全政策",
    "a_member_service_roles": "设置服务角色",
    "a_member_duty_mode": "设置值班账号",
    "a_billing_checkout": "开始购买",
    "a_billing_seat_assign": "分配席位",
    "a_billing_seat_unassign": "解除席位",
    "a_ai_consent_grant": "云端 AI 同意",
    "a_ai_consent_exclusions": "云端 AI 排除清单",
    "a_ai_consent_revoke": "撤回云端 AI 同意",
    "a_ai_usage_threshold": "云端 AI 额度提醒",
    "a_test_hook_billing_contract": "测试挂钩：合同",
    "search": "搜索动作、设备、内容、IP",
    "export_csv": "导出 CSV（最近 30 天）",
    "export_failed": "导出失败，请稍后再试",
    "a_device_settings": "设备设置变更",
    "a_device_command": "设备命令",
    "a_member_invite": "邀请成员",
    "a_member_invite_revoke": "撤销邀请",
    "a_member_role": "改组织角色",
    "a_member_remove": "移出成员",
    "a_org_owner_transfer": "转移拥有权",
    "a_org_delete": "删除组织",
    "a_share_create": "分享给个人",
    "a_share_request": "发分享请求",
    "a_share_request_cancel": "撤回分享请求",
    "a_share_accept": "同意分享给组织",
    "a_share_shrink": "缩小分享",
    "a_share_revoke": "撤销分享",
    "a_share_end": "组织终止分享",
    "a_share_handover": "交屋",
    "a_share_grantee_removed": "对方移除分享",
    "range": "日期范围",
    "r_today": "今天",
    "r_yesterday": "昨天",
    "r_7d": "过去 7 天",
    "r_custom": "自定义",
    "from": "开始日期",
    "to": "结束日期",
    "g_media": "视频访问",
    "g_control": "设备控制",
    "g_settings": "设置变更",
    "g_perms": "权限",
    "g_account": "账号",
    "g_export": "导出",
    "g_billing": "账单",
    "g_other": "其他",
    "g_all": "全部{{group}}",
    "line": "{{who}} {{what}}",
    "line_target": "{{who}} {{what}}：{{target}}",
    "unknown_device": "一台设备",
    "unknown_user": "已离开的成员",
    "unknown_home": "一个$t(leaf.cur)",
    "unknown_node": "一个节点",
    "src_local": "本地录像",
    "src_cloud": "云端录像",
    "f_device_ref": "设备",
    "f_device": "设备",
    "f_user_id": "对象",
    "f_target_user_id": "对象",
    "f_home_id": "$t(leaf.cur)",
    "f_node_id": "节点",
    "f_source": "来源",
    "f_reason": "理由",
    "f_keys": "改了哪些设置",
    "f_command": "命令",
    "f_path": "连接方式",
    "f_from": "播放起点",
    "f_ip": "IP",
    "tech": "技术细节（复制给客服）",
    "s_device_settings": "{{who}} 变更了 {{target}} 的设置",
    "s_device_command": "{{who}} 对 {{target}} 下了命令",
    "s_device_rpc": "{{who}} 对 {{target}} 下了命令",
    "s_device_control": "{{who}} 操作了 {{target}}",
    "s_device_location": "{{who}} 改了 {{target}} 的位置",
    "s_media_session_start": "{{who}} 开始看 {{target}} 的实时视频",
    "s_media_session_end": "{{who}} 结束看 {{target}} 的实时视频",
    "s_recording_playback": "{{who}} 看了 {{target}} 的{{src}}",
    "s_recording_download": "{{who}} 下载了 {{target}} 的录像",
    "s_recording_delete": "{{who}} 删除了 {{target}} 的录像",
    "s_grant_create": "{{who}} 给 {{target}} 场所授权",
    "s_grant_refresh": "{{who}} 刷新了 {{target}} 的场所授权",
    "s_grant_revoke": "{{who}} 撤销了 {{target}} 的场所授权",
    "s_member_invite": "{{who}} 邀请了新成员",
    "s_member_role": "{{who}} 改了 {{target}} 的组织角色",
    "s_member_remove": "{{who}} 把 {{target}} 移出组织",
    "s_member_update": "{{who}} 改了 {{target}} 的成员设置",
    "s_member_join": "{{target}} 加入组织",
    "s_node_assignment_create": "{{who}} 在 {{target}} 指派了人",
    "s_node_assignment_revoke": "{{who}} 撤销了 {{target}} 的一条指派",
    "s_node_assignment_update": "{{who}} 改了 {{target}} 的一条指派",
    "s_node_block_inheritance": "{{who}} 改了 {{target}} 的中断继承",
    "s_audit_export": "{{who}} 导出了审计记录",
    "s_billing_seat_assign": "{{who}} 指派了云录席位",
    "a_device_rpc": "设备远程调用",
    "a_media_session_start": "开始看实时视频",
    "a_media_session_end": "结束看实时视频",
    "a_recording_playback": "回放录像",
    "a_recording_download": "下载录像",
    "a_recording_delete": "删除录像",
    "a_recording_policy_update": "改录像设置",
    "a_node_assignment_create": "节点指派",
    "a_node_assignment_update": "改节点指派",
    "a_node_assignment_revoke": "撤销节点指派",
    "a_node_create": "新增节点",
    "a_node_update": "修改节点",
    "a_node_move": "移动节点",
    "a_node_archive": "停用节点",
    "a_node_block_inheritance": "中断继承",
    "a_node_self_assign": "指派自己",
    "a_role_apply": "套用角色变更",
    "a_member_group_create": "新增成员群组",
    "a_member_group_update": "修改成员群组",
    "a_member_group_delete": "删除成员群组",
    "a_audit_export": "导出审计",
    "a_org_rename": "改组织名称",
    "a_org_tree_settings": "改层级名称",
    "a_home_delete": "删除$t(leaf.cur)",
    "a_home_move_node": "移动$t(leaf.cur)",
    "line_generic_target": "{{who}} 对 {{target}} 做了一项操作",
    "line_generic": "{{who}} 做了一项操作",
    "times_one": "× {{count}} 次",
    "times_other": "× {{count}} 次",
    "see_all": "到审计页看全部",
    "only_device": "只看 {{name}}",
    "clear_device": "不限设备",
    "a_media_live": "看实时视频",
    "s_media_watched": "{{who}} 看了 {{target}} 的实时影像 {{dur}}",
    "dur_s": "{{s}} 秒",
    "dur_ms": "{{m}} 分 {{s}} 秒",
    "s_media_replayed": "{{who}} 看了 {{target}} 的本地录像 {{dur}}",
    "paren": "（{{v}}）",
    "mode_write": "（可输入）",
    "mode_read": "（只读）",
    "mac_tail": "MAC 尾码 {{v}}",
    "fleet_cmd_other": "一个指令",
    "fleet_cmd_reboot": "重新启动",
    "fleet_cmd_identify": "闪灯找设备",
    "fleet_cmd_site_wifi_set": "设置场所 Wi-Fi",
    "fleet_cmd_wifi_set": "设置 Wi-Fi",
    "fleet_cmd_ttl_config": "设置 UART（TTL）",
    "fleet_cmd_ttl_open": "打开 UART（TTL）",
    "fleet_cmd_ttl_close": "关闭 UART（TTL）",
    "fleet_cmd_caps": "读取能力",
    "fleet_cmd_ota_update": "更新固件",
    "fleet_cmd_host_nodes": "列出接着的 Node",
    "fleet_cmd_host_power": "开关 Node 电源",
    "fleet_cmd_host_reset": "重置 Node",
    "fleet_cmd_host_ota": "更新 Node 固件",
    "fleet_cmd_host_flash": "烧录 Node",
    "fleet_cmd_host_wifi": "设置 Node Wi-Fi",
    "fleet_cmd_host_health": "读取 Node 健康",
    "fleet_cmd_host_imeas": "测量电流",
    "org_status_active": "启用",
    "org_status_suspended": "停权",
    "org_status_closed": "关闭",
    "s_recording_read": "{{who}} 查看了 {{target}} 的录像清单",
    "s_fleet_console_ticket": "{{who}} 取得 {{target}} 的终端机连接{{mode}}",
    "s_fleet_console_open": "{{who}} 开了 {{target}} 的终端机{{mode}}",
    "s_fleet_console_close": "{{who}} 结束了 {{target}} 的终端机",
    "s_fleet_console_writer": "{{who}} 取得 {{target}} 终端机的输入权",
    "s_fleet_command": "{{who}} 对 {{target}} 下指令「{{cmd}}」",
    "s_fleet_local_credential": "{{who}} 设置了 {{target}} 的本机登录密码",
    "s_thing_update": "{{who}} 把 {{target}} 改名为「{{name}}」",
    "s_thing_update_plain": "{{who}} 修改了 {{target}}",
    "s_thing_assigned": "{{who}} 把 {{target}} 指派到 {{place}}",
    "s_thing_moved": "{{who}} 把 {{target}} 搬到 {{place}}",
    "s_thing_ttl_direct_token": "{{who}} 取得 {{target}} 的局域网直连令牌",
    "s_thing_admin_credential_set": "{{who}} 设置了 {{target}} 的管理员密码",
    "s_media_clip_fetch": "{{who}} 取了 {{target}} 的一段视频{{dur}}",
    "s_vms_ai_assign": "{{who}} 把 {{target}} 指派给 AI 主机 {{provider}}",
    "s_vms_ai_unassign": "{{who}} 取消了 {{target}} 的 AI 主机指派",
    "s_vms_alarm_state": "{{who}} 把 {{target}} 的警报标成「{{state}}」",
    "s_vms_device_links_put": "{{who}} 设置了 {{target}} 联动的摄像头（{{n}} 台）",
    "s_vms_floorplan_create": "{{who}} 新增了平面图「{{name}}」",
    "s_vms_floorplan_delete": "{{who}} 删除了平面图「{{name}}」",
    "s_view_create": "{{who}} 新增了布局「{{name}}」",
    "s_view_delete": "{{who}} 删除了布局「{{name}}」",
    "s_org_node_enroll_lookup": "{{who}} 查询了一台 Kinio Node{{mac}}",
    "s_org_node_enroll_identify": "{{who}} 确认了一台 Kinio Node{{mac}}",
    "s_org_node_enroll_approve": "{{who}} 开通了一台 Kinio Node{{mac}}",
    "s_org_inventory_claim": "{{who}} 认领了库存设备{{serial}}",
    "s_org_status": "{{who}} 把组织状态改成「{{state}}」",
    "s_org_verification": "{{who}} 审核了组织的服务类别",
    "s_relationship_request": "{{who}} 申请了服务关系",
    "s_relationship_handover": "{{who}} 交接了服务关系",
    "s_service_client_created": "{{who}} 创建了服务账号密钥",
    "s_service_client_revoked": "{{who}} 撤销了服务账号密钥",
    "s_service_client_secret_rotated": "{{who}} 轮换了服务账号密钥",
    "s_service_write": "服务账号写入了数据",
    "s_model_org_assign": "{{who}} 把机种 {{model}} 指派到组织",
    "s_model_org_moved": "{{who}} 把机种 {{model}} 移到另一个组织",
    "s_model_admin_create": "{{who}} 新增了机种 {{model}}",
    "s_aid_allocate": "{{who}} 配发了一批 AID",
    "s_qa_org_case": "{{who}} 改了机种的测试案例",
    "a_recording_read": "查看录像清单",
    "a_fleet_console_ticket": "取得终端机连接",
    "a_fleet_console_open": "开终端机",
    "a_fleet_console_close": "结束终端机",
    "a_fleet_console_session_closed": "终端机已结束",
    "a_fleet_console_writer": "取得终端机输入权",
    "a_fleet_command": "Node 指令",
    "a_fleet_local_credential": "设置本机登录密码",
    "a_thing_update": "改设备名称",
    "a_thing_assigned": "指派设备",
    "a_thing_moved": "搬移设备",
    "a_thing_ttl_direct_token": "局域网直连令牌",
    "a_thing_admin_credential_set": "设置管理员密码",
    "a_media_clip_fetch": "取视频片段",
    "a_vms_ai_assign": "指派 AI 主机",
    "a_vms_ai_unassign": "取消 AI 主机指派",
    "a_vms_alarm_state": "处理警报",
    "a_vms_device_links_put": "设置联动摄像头",
    "a_vms_floorplan_create": "新增平面图",
    "a_vms_floorplan_delete": "删除平面图",
    "a_view_create": "新增布局",
    "a_view_delete": "删除布局",
    "a_org_node_enroll_lookup": "查询 Kinio Node",
    "a_org_node_enroll_identify": "确认 Kinio Node",
    "a_org_node_enroll_approve": "开通 Kinio Node",
    "a_org_inventory_claim": "认领库存设备",
    "a_org_status": "改组织状态",
    "a_org_verification": "审核服务类别",
    "a_relationship_request": "申请服务关系",
    "a_relationship_handover": "交接服务关系",
    "a_service_client_created": "创建服务账号密钥",
    "a_service_client_revoked": "撤销服务账号密钥",
    "a_service_client_secret_rotated": "轮换服务账号密钥",
    "a_service_write": "服务账号写入",
    "a_model_org_assign": "指派机种到组织",
    "a_model_org_moved": "搬移机种",
    "a_model_admin_create": "新增机种",
    "s_device_read": "{{who}} 读取了 {{target}} 的{{rcmd}}",
    "rcmd_other": "资料",
    "rcmd_ch_list": "通道列表",
    "rcmd_pb_timeline": "录像时间轴",
    "rcmd_pb_days": "有录像的日期",
    "rcmd_pb_thumb": "录像缩略图",
    "rcmd_sys_info": "系统信息",
    "rcmd_hdd_info": "硬盘信息",
    "rcmd_rec_status": "录像状态",
    "rcmd_wifi_state": "Wi-Fi 状态",
    "rcmd_pb_list": "录像列表",
    "s_recording_playback_at": "{{who}} 看了 {{target}} {{at}} 起的{{src}}",
    "s_media_watched_nodur": "{{who}} 看了 {{target}} 的实时影像",
    "s_media_replayed_nodur": "{{who}} 看了 {{target}} 的本地录像",
    "no_end_record": "（没有结束记录）",
    "s_media_replay_started": "{{who}} 开始看 {{target}} 的本地录像",
    "s_media_replayed_at": "{{who}} 看了 {{target}} {{at}} 起的本地录像 {{dur}}",
    "s_media_replayed_at_nodur": "{{who}} 看了 {{target}} {{at}} 起的本地录像",
    "s_media_replay_started_at": "{{who}} 开始看 {{target}} {{at}} 起的本地录像",
    "catalog_zh_hant": "no",
    "quoted": "“{{v}}”",
    "s_device_command_named": "{{who}} 对 {{target}} 下了命令“{{cmdName}}”",
    "s_device_set_named": "{{who}} 更改了 {{target}} 的“{{cmdName}}”",
    "rpc_pb_export": "导出录像",
    "rpc_cfg_set": "更改设置",
    "rpc_hdd_smartTest": "硬盘健康检查",
    "rpc_kinio_pair": "配对设备",
    "rpc_kinio_pairWindow": "开放配对",
    "rpc_kinio_net": "更改网络设置",
    "rpc_sys_factoryReset": "恢复出厂设置",
    "rpc_upgrade_check": "检查固件更新",
    "rpc_tool_run": "运行诊断工具",
    "rpc_tool_cancel": "停止诊断工具",
    "times_since": "× {{n}} 次（最早 {{since}}）",
    "each": "这 {{n}} 次",
    "filling": "正在往前找符合的记录…",
    "reason_client_stop": "观看的人关掉",
    "reason_client_gone": "观看的人断线或关掉页面",
    "reason_device_gone": "设备断线",
    "reason_viewer_limit": "同时观看人数已满，被挤掉",
    "reason_token_expired": "登录超时",
    "reason_access_revoked": "观看权限被收回",
    "reason_authorization_unavailable": "暂时无法确认权限",
    "reason_api_delete": "经 API 结束",
    "reason_timeout": "超时"
  },
  "sessions": {
    "title": "登录中的设备",
    "hint": "强制注销后，该设备 30 秒内会停止实时视频，也不能再换发登录。",
    "device": "设备",
    "ip": "IP",
    "signed_in": "登录 / 最后验证",
    "last_active": "最后活动",
    "current": "目前这个",
    "mfa": "两步验证",
    "revoke": "注销",
    "sign_out": "注销这里",
    "revoke_others": "注销其他所有设备",
    "revoke_others_confirm": "确定注销其他所有设备？",
    "revoke_current_confirm": "这会注销目前这个浏览器，确定？",
    "client_c_livingstyle_vms": "ls-vms",
    "client_c_kinio_vms_work": "VMS",
    "client_c_kinio_emu": "Kinio 仿真器"
  },
  "transfer": {
    "button": "交接 / 接管",
    "title_handover": "交接「{{name}}」",
    "title_takeover": "接管「{{name}}」",
    "current": "目前管理人",
    "unassigned": "无人管理",
    "target": "新管理人",
    "me": "我",
    "warn_new": "新管理人会取得这个$t(leaf.cur)的实时视频、录像与管理权。",
    "warn_old": "原管理人会失去管理人身分，以及他在这个$t(leaf.cur)的场所授权（不会自动降为管理员）。",
    "warn_takeover": "这是组织管理员的受控接管，会完整记录在审计并通知相关的人。",
    "reason": "理由（必填，会写进审计）",
    "submit_handover": "交接",
    "submit_takeover": "接管",
    "done": "完成。原管理人在这个$t(leaf.cur)的 {{n}} 笔授权已撤销，30 秒内生效。",
    "unchanged": "对象本来就是管理人，没有变动。",
    "not_allowed": "只有现任管理人能交接；组织管理员可以接管。"
  },
  "policy": {
    "title": "安全政策",
    "hint": "只在使用这个组织的设备与管理功能时套用；成员自己的家与其他组织不受影响。政策变更后下一次请求就生效。",
    "idle": "闲置逾时",
    "idle_hint": "用户没操作（鼠标、键盘、触控）超过这段时间，要重新验证才能继续用这个组织的设备；监控大屏请用值班模式。",
    "max_sessions": "同时登录上限",
    "max_hint": "只计使用这个组织的登录；超过时那个登录要重新验证，不会退出整个账号。",
    "unlimited": "不限",
    "sessions": "{{n}} 个",
    "minutes": "{{n}} 分钟",
    "hours": "{{n}} 小时",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "saved": "已保存",
    "ip_allowlist": "IP 允许清单",
    "ip_hint": "每行一个 IP 或 CIDR（例 203.0.113.0/24）；空白 = 不限。清单外连接访问这个组织的设备与管理功能一律拒绝。保存时你目前的 IP 必须在清单内。",
    "require_mfa": "要求两步验证",
    "require_mfa_hint": "没开两步验证的成员看不到这个组织的设备，会提示他开启；账号本身不强制。",
    "login_max_age": "登录时效",
    "login_max_age_hint": "登录超过这段时间，要重新登录才能继续用这个组织的设备（不会退出整个账号）。",
    "api_keys": "成员可用 API 密钥访问本组织",
    "api_keys_hint": "开启后，成员可以用自己的 API 密钥让 Claude 查询本组织的设备、事件与报警（权限按各人此刻的授权；写入与影像每次记审计，读取不记）。",
    "snapshot_upload": "事件快照存到云端",
    "snapshot_upload_hint": "每个事件存一张小图到云端，推送与事件列表会带缩略图、云端 AI 才能分析。关闭立即生效；打开要重新验证。",
    "snapshot_upload_off_hint": "已关闭：事件照常记录，但推送没有缩略图、事件列表与预览格显示类别图标、云端 AI 不能用（本地 AI 集成中心不受影响）。已上云的快照按保存期到期。App 截图不受影响。"
  },
  "passkey": {
    "title": "Passkey（通行密钥）",
    "hint": "用指纹、脸部辨识或设备 PIN 登录，不用输入密码，本身就算两步验证。存在 iCloud 钥匙圈或 Google 密码管理工具的 passkey 会同步到你的其他设备。",
    "add": "添加 passkey",
    "none": "还没有 passkey。",
    "unsupported": "这个浏览器不支持 passkey。",
    "synced": "已同步",
    "created": "{{date}} 添加",
    "last_used": "上次使用 {{date}}",
    "delete": "删除",
    "delete_confirm": "删除「{{name}}」？删除后就不能用它登录。",
    "sign_in": "用 passkey 登录",
    "or": "或",
    "verify": "用 passkey 验证",
    "or_password": "或输入密码",
    "err_PASSKEY_CANCELED": "已取消或逾时",
    "err_PASSKEY_EXISTS": "这个设备已经有这个账号的 passkey",
    "err_PASSKEY_INVALID": "passkey 验证失败",
    "err_PASSKEY_STATE_INVALID": "逾时，请重试",
    "err_NO_PASSKEY": "这个账号还没在这个网站设置 passkey，请改用下面的密码验证（passkey 可以到〔设置 › 安全性〕添加）。",
    "err_LAST_FACTOR": "你参加的组织要求两步验证：至少要保留一种（TOTP 或 passkey）",
    "err_PASSKEY_DISABLED": "这个环境没有开 passkey",
    "err_BAD_RP": "这个网址不能使用 passkey",
    "err_REAUTH_REQUIRED": "需要重新验证身分",
    "err_default": "passkey 失败（{{code}}）"
  },
  "ext": {
    "verified": "Kinio 已审核：{{kind}}",
    "until": "到 {{date}}",
    "shrink": "删减范围",
    "revoke": "撤销",
    "auto_include_new_on": "新设备自动加入（只限状态 / 事件 / 警报）",
    "cond_always": "视频随时可看",
    "cond_alarm_window": "只在警报后 {{n}} 分钟内可看视频",
    "cond_armed": "只在布防时可看视频",
    "code": "邀请码",
    "code_hint": "输入服务商给你的邀请码（或打开他们给的链接）。你在自己的账号内核准，服务商看不到你的账号数据。",
    "preview": "查看内容",
    "duration_one": "期限 {{count}} 天",
    "duration_other": "期限 {{count}} 天",
    "scopes": "允许的操作",
    "devices": "设备",
    "devices_all": "$t(leaf.cur)目前全部设备",
    "devices_list": "只限勾选的设备",
    "auto_include_new": "之后添加的设备自动加入（只限看状态、事件与收警报；视频与控制永远要另外同意）",
    "media_condition": "视频条件",
    "history": "开始前的历史数据",
    "history_none": "不提供（缺省）",
    "history_days_one": "往前 {{count}} 天",
    "history_days_other": "往前 {{count}} 天",
    "install_lan": "允许施工模式（安装人员在现场用区网连接，最长 8 小时，交屋即作废）",
    "consent_note": "含视频、布撤防或施工模式时会要求重新验证身分。",
    "accept": "核准",
    "shrink_of": "删减「{{name}}」的范围",
    "shrink_hint": "只能缩小；要扩大请服务商重新发请求。",
    "access_log_empty": "还没有服务访问纪录。",
    "when": "时间",
    "who": "人员",
    "what": "操作",
    "device": "设备",
    "purpose_install": "安装",
    "purpose_maintenance": "维护",
    "purpose_monitoring": "监控",
    "purpose_security_service": "保全服务",
    "purpose_care": "照护",
    "purpose_property": "物业",
    "kind_installer": "安装商",
    "kind_security_provider": "保全业",
    "kind_monitoring_center": "监控中心",
    "kind_property_manager": "物业管理",
    "kind_care_provider": "照护机构",
    "kind_dealer": "经销",
    "kind_enterprise": "企业",
    "device_unknown": "已移除的设备"
  },
  "svc": {
    "title": "分享请求",
    "note": "给屋主的说明（选填）",
    "issue": "产生邀请码",
    "issued": "邀请码 7 天内有效、只能用一次。把码或链接交给屋主：",
    "status_active": "服务中",
    "status_suspended": "暂停",
    "status_ended": "已结束",
    "complete_install": "完成安装（交屋）",
    "end": "终止",
    "end_confirm": "确定终止这笔分享？",
    "service_roles": "服务角色",
    "service_roles_hint": "服务角色决定这个人在客户$t(leaf.cur)能做什么，最多到客户核准的范围。",
    "role_operator": "操作员",
    "role_operator_desc": "看状态、事件、视频、回放、收警报",
    "role_supervisor": "主管",
    "role_supervisor_desc": "布撤防、导出录像",
    "role_technician": "技师",
    "role_technician_desc": "安装、设置、远程侦测",
    "tab": "分享给本组织",
    "hint_kinds": "这个组织的服务类别：{{kinds}}。产生一次性代码给$t(leaf.cur)，$t(leaf.cur)在自己的 App 或 VMS 同意后才能访问（还没通过平台审核的用途，$t(leaf.cur)会看到提示、服务器也会挡）。",
    "no_kinds": "这个组织没有服务类别（例如安装、保安、监控中心），不能发分享请求；$t(leaf.cur)仍然可以把设备分享给你们。",
    "purpose": "用途",
    "pending_requests": "等待$t(leaf.cur)同意",
    "renewal": "续约",
    "cancel_request": "撤回",
    "received": "收到的分享",
    "received_hint": "成员能做什么在成员的“组织权限…”里设服务角色，最多到$t(leaf.cur)分享的范围；组织不能管理、也不能再分享这些设备。",
    "none_received": "还没有收到分享。",
    "a_home": "一个$t(leaf.cur)",
    "unverified": "这个组织的服务类别还没通过平台审核（或已过期），审核通过后才能发分享请求。",
    "verified_until": "审核到 {{date}}"
  },
  "sensor": {
    "popups": "传感器弹窗",
    "contact_title": "{{name}} 门开了",
    "motion_title": "{{name}} 检测到有人",
    "playback": "回放 {{cam}}",
    "no_link": "没有关联摄像头；到“设备”设置关联后，触发时会带实时画面。",
    "contact_on": "开启",
    "contact_off": "关闭",
    "motion_on": "有人",
    "motion_off": "无人",
    "alarm_title2": "警报 · {{what}} · {{name}}",
    "detection_title2": "侦测 · {{what}} · {{name}}",
    "more_n_one": "还有 {{count}} 条",
    "more_n_other": "还有 {{count}} 条",
    "expand": "展开",
    "collapse": "收起",
    "watch_live": "看实时",
    "no_snapshot": "还没有快照；按〔看实时〕看现场",
    "switch_scope": "切到该范围",
    "alarm_kind": "警报 · {{what}}",
    "detection_kind": "侦测 · {{what}}",
    "out_of_scope_path": "不在当前范围：{{path}}",
    "switch_scope_to": "切到 {{path}}"
  },
  "link": {
    "button": "关联",
    "title": "{{name}} 的关联摄像头",
    "help": "触发时（门开 / 有人）要带哪几台摄像头的画面。",
    "cameras": "摄像头",
    "no_cameras": "这个$t(leaf.cur)没有摄像头",
    "purposes": "用于",
    "purpose_popup": "实时弹窗",
    "purpose_clip": "事件卡片带回放",
    "readonly": "只有$t(leaf.cur)拥有者 / 管理员 或组织管理员可以修改"
  },
  "onvif": {
    "open": "新增 ONVIF 摄像头",
    "title": "新增 ONVIF 摄像头（经 Kinio 网关）",
    "help": "经现场的 NVR、Kinio Station 或 AI box（网关）接第三方 ONVIF 摄像头；账密只送到网关。Kinio 自家设备会改用 Kinio 配对。",
    "no_gateway": "这个范围里没有你能管理、可以当网关的 Kinio NVR 或 Kinio Station（需要拥有者或管理员）。没有网关的场所请加一台 NVR 或 AI box。",
    "gateway": "网关",
    "discover": "探索",
    "discovering": "探索中…",
    "group_managed": "已纳管",
    "group_own": "Kinio 自家设备",
    "group_suspect": "疑似 Kinio 设备",
    "group_third_party": "第三方 ONVIF",
    "none": "没有",
    "on_channel": "已是 CH{{ch}}",
    "pair_kinio": "用 Kinio 方式配对（不经 ONVIF）",
    "suspect_help": "默认用 Kinio 方式配对；旧机型要以 ONVIF 加入需要拥有者填理由。",
    "suspect_help_owner": "默认用 Kinio 方式配对；确定要以 ONVIF 加入可以勾选并填理由（会写审计）。",
    "duplicates": "{{n}} 笔重复响应已合并（同一台从不同网络接口响应）",
    "creds_help": "摄像头账号密码（只送到网关，平台不保存；会用在勾选的每一台）",
    "user": "账号",
    "password": "密码",
    "add": "加入 {{n}} 台",
    "reason": "为什么不用 Kinio 配对？（例：旧 Swann 机型不支持私有协议）",
    "force_add": "仍以 ONVIF 加入 {{n}} 台",
    "result_ok": "已加入",
    "result_auth_failed": "账号密码错误",
    "result_timeout": "超时",
    "result_unreachable": "连不上",
    "result_unsupported": "不支持",
    "h265_only": "只有 H.265"
  },
  "ptz": {
    "title": "云台控制",
    "home": "回原点",
    "speed": "速度",
    "zoom_in": "放大",
    "zoom_out": "缩小",
    "presets": "预置点",
    "pick_preset": "选择预置点",
    "no_presets": "没有预置点",
    "loading": "读取中…",
    "goto": "前往",
    "save_preset": "保存当前位置",
    "preset_name": "预置点名称",
    "held": "{{role}}正在控制（{{n}} 秒后释放）",
    "preempted": "控制权已被{{role}}取走",
    "take_over": "抢控",
    "role_owner": "拥有者",
    "role_admin": "管理员",
    "role_member": "成员",
    "role_operator": "操作员",
    "role_partner": "服务伙伴",
    "dir_up": "上",
    "dir_down": "下",
    "dir_left": "左",
    "dir_right": "右",
    "dir_upleft": "左上",
    "dir_upright": "右上",
    "dir_downleft": "左下",
    "dir_downright": "右下",
    "err_GATEWAY_OFFLINE": "网关不在线",
    "err_GATEWAY_TIMEOUT": "网关没有响应",
    "err_FORBIDDEN": "没有控制这台设备的权限",
    "cruise_start": "开始巡航",
    "cruise_stop": "停止巡航",
    "cruise_dwell": "每点停留（秒）",
    "cruise_at": "巡航中：{{name}}",
    "presets_count": "预置点　{{n}} / {{max}}",
    "presets_count_a11y": "预置点，已存 {{n}} 个，最多 {{max}} 个",
    "preset_n": "位置 {{n}}",
    "preset_add": "＋ 新增",
    "preset_full": "已满",
    "preset_manage": "管理",
    "preset_manage_a11y": "管理预置点",
    "preset_done": "完成",
    "preset_done_a11y": "完成管理",
    "preset_rename": "改名",
    "preset_name_it": "命名",
    "preset_update": "用目前位置更新",
    "preset_delete": "删除",
    "preset_delete_confirm": "删除“{{name}}”？",
    "preset_here": "目前所在",
    "preset_going": "正在转到{{name}}",
    "preset_arrived": "已转到{{name}}",
    "preset_card_a11y": "{{name}}，预置点",
    "preset_card_unnamed_a11y": "{{name}}，预置点，未命名",
    "preset_menu": "预置点选项",
    "preset_name_label": "名称",
    "preset_name_hint": "最多 12 个字，看得到这台的人都看得到",
    "preset_save": "保存",
    "preset_unreachable": "摄像头离线，显示最后一次的预置点",
    "preset_conflict": "别人刚改过预置点，已更新",
    "preset_err_BUSY": "云台正在忙，请稍后再试",
    "preset_err_NOT_FOUND": "位置已失效",
    "preset_err_NOT_CALIBRATED": "云台还在校正",
    "preset_err_TIMEOUT": "没有转到{{name}}",
    "preset_err_OFFLINE": "摄像头离线，没有更新 / 删除",
    "preset_err_ASLEEP": "摄像头在休眠，请稍后再试",
    "preset_err_LIMIT": "预置点已满",
    "preset_err_INVALID_NAME": "请输入 1–12 个字的名称",
    "preset_err_OTHER": "没有完成，请再试一次",
    "lens_note": "左右：两颗一起转，上下：只有{{name}}",
    "lens_none": "方向盘，这颗镜头不会转"
  },
  "ai": {
    "title": "AI 运算",
    "help": "AI box、有 AI 芯片的 NVR 与 Kinio Station 在现场替同一个$t(leaf.cur)的摄像头跑 AI 分析；侦测事件记在来源摄像头上。现场 AI 随硬件，不需要订阅。",
    "no_provider": "这个范围里还没有能跑 AI 的设备（AI box、有 AI 芯片的 NVR 或 Kinio Station）。",
    "assign": "指派摄像头",
    "assign_title": "指派摄像头给 {{name}}",
    "assign_submit": "确认指派",
    "probing": "正在请提供者测试串流…",
    "capacity": "已用 {{used}} / {{total}} 路",
    "capacity_title": "已用 {{used}} 路，共 {{total}} 路",
    "load": "负载 {{n}}%",
    "fps": "{{n}} fps",
    "none": "还没有指派",
    "move": "改派到…",
    "unassign": "解除",
    "drag_help": "把摄像头拖到上面的提供者，或按「指派摄像头」",
    "camera": "摄像头",
    "models": "模型",
    "sensitivity": "灵敏度 {{n}}",
    "st_pending": "应用中",
    "st_running": "运行中",
    "st_degraded": "降载",
    "detail_viewer_limit": "这台设备的观看名额被实时观看占满，AI 分析先让位，名额空出来会自动恢复",
    "detail_lan_unreachable": "局域网连不到来源设备，事件分析暂停",
    "st_unreachable": "不可达",
    "st_rejected": "被拒绝",
    "err_AI_SOURCE_UNREACHABLE": "提供者连不到这台摄像头：{{message}}",
    "err_AI_SOURCE_UNSUPPORTED": "这台摄像头（或它的 NVR / Station / 基站）的固件还不能把视频代理给 AI 运算提供者",
    "err_AI_CAPACITY_FULL": "容量已满（{{used}} / {{channels}} 路）",
    "err_AI_ALREADY_ASSIGNED": "这台摄像头已经指派给某个提供者",
    "err_AI_MODEL_UNSUPPORTED": "提供者不支持模型 {{model}}",
    "err_PROVIDER_OFFLINE": "提供者不在线",
    "err_NOT_AI_PROVIDER": "这台设备不是 AI 运算提供者",
    "err_FORBIDDEN": "需要$t(leaf.cur)拥有者或管理员",
    "err_VERSION_CONFLICT": "数据已被别人修改，请刷新",
    "err_GATEWAY_OFFLINE": "网关不在线",
    "err_GATEWAY_TIMEOUT": "网关没有响应",
    "model": {
      "kinio": {
        "person_vehicle@2": "人车检测",
        "line_cross@1": "越线检测",
        "intrusion@1": "区域入侵"
      }
    },
    "delivery": "取流方式",
    "delivery_auto": "自动（能持续就持续）",
    "delivery_continuous": "持续串流",
    "delivery_event": "事件快照",
    "delivery_help": "视频由摄像头或它的 NVR / Station / 基站代理给提供者，提供者不需要摄像头账号密码。持续串流占那台设备一个观看名额；电池型摄像头只能事件快照。",
    "err_AI_DELIVERY_UNSUPPORTED": "这台摄像头不支持这种取流方式（电池型只能事件快照）",
    "err_AI_VIEWER_LIMIT": "设备的观看名额已满（上限 {{limit}}：观看中 {{viewers}}、AI 持续串流 {{ai}}），请改用事件快照或稍后再试",
    "err_BAD_DELIVERY": "取流方式不对",
    "tab_local": "本地 AI",
    "tab_cloud": "云端 AI",
    "stations_without_one": "{{count}} 台 Kinio Station 没有 AI 运算能力（例：Windows 版），所以不在上面的清单。",
    "stations_without_other": "{{count}} 台 Kinio Station 没有 AI 运算能力（例：Windows 版），所以不在上面的清单。",
    "move_confirm": "把 {{cam}} 改派到 {{to}}？",
    "move_body": "原本的分析会停止，改由新的提供者分析；几秒内生效。",
    "move_action": "改派",
    "moved": "已把 {{cam}} 改派到 {{to}}。",
    "move_undo": "撤销",
    "subject": {
      "person": "人",
      "vehicle": "车",
      "animal": "动物",
      "face": "人脸",
      "plate": "车牌",
      "package": "包裹",
      "fire": "火焰",
      "smoke": "烟"
    },
    "subject_sep": "／",
    "model_detect": "{{what}}检测",
    "model_detect_light": "{{what}}检测（轻量）",
    "model_generic": "AI 检测模型 v{{v}}",
    "stations_without_named": "{{names}} 没有 AI 运算能力（这版 Kinio Station 没有推理后端），所以不在上面的清单。",
    "unassign_confirm": "解除 {{cam}} 的 AI 分析？",
    "unassign_body": "这台的 AI 检测会停止，之后不会再有 AI 事件；解除后可以按〔复原〕用同样的设置重新指派。",
    "unassign_action": "解除指派",
    "unassigned": "已解除 {{cam}} 的 AI 分析。",
    "tab_byo": "自带 AI"
  },
  "search": {
    "placeholder": "搜索事件：红色 摩托车 device:大门 class:person tag:helmet after:2026-09-01",
    "sort": "排序",
    "sort_time": "按时间",
    "sort_relevance": "按相关度",
    "suggest": "提示",
    "syntax": "语法：自由文本（中英混合）、\"短语\"、-排除、class: level: device:（设备名称，例 device:\"NVR631 / CH5\"）site:（场所，含子场所）node: view: group:（组织树的节点 / 布局 / 群组，输入名称挑选）tag: after: before: on: has:clip；逗号 = 或",
    "warnings": "看不懂的条件已忽略：{{list}}",
    "histogram": "每小时事件数",
    "more": "加载更多",
    "producer": "由 {{id}} 检测",
    "bm_add": "加书签",
    "bm_title": "书签标题",
    "bm_note": "注记（选填）",
    "bm_private": "只有我看得到",
    "bm_saved": "已加书签",
    "bm_delete": "删除书签",
    "bookmarks": "书签",
    "site_unknown": "找不到场所：{{list}}（这些条件不会有结果）",
    "saved": "已存搜索",
    "saved_none": "还没有已存搜索",
    "saved_shared": "共用",
    "saved_name": "名称",
    "saved_scope": "存在哪里",
    "saved_personal": "只有我",
    "saved_org": "{{name}} 共用",
    "saved_save": "保存当前的搜索",
    "saved_delete": "删除“{{name}}”",
    "saved_help": "只保存查询条件；应用时按你现在的权限重新搜索。",
    "saved_err_SAVED_SEARCH_LIMIT": "已存搜索最多 100 条，请先删掉不用的",
    "saved_err_BAD_NAME": "名称要 1–80 字",
    "saved_err_FORBIDDEN": "共用的已存搜索需要组织管理员",
    "to_map": "在地图上看这些结果",
    "src_edge_box": "AI box",
    "src_device": "设备端 AI",
    "node_none": "找不到符合“{{q}}”的节点",
    "tree_filters": "筛选中：{{list}}",
    "tree_field_node": "节点“{{name}}”",
    "tree_field_view": "布局“{{name}}”",
    "tree_field_group": "群组“{{name}}”",
    "node_error": "节点搜索失败，请稍后再试（不是找不到）",
    "node_partial": "有一个区域的节点搜索失败，下面只列查得到的",
    "tree_name_unknown": "{{id}}（名称未知）",
    "range": "时间范围",
    "range_any": "全部时间",
    "range_today": "今天",
    "range_yesterday": "昨天",
    "range_24h": "过去 24 小时",
    "range_custom": "自定义…",
    "range_from": "从",
    "range_to": "到",
    "syntax_btn": "ⓘ 语法",
    "syntax_dates": "日期（YYYY-MM-DD，按你的时区）：after:D 从 D 当天起（含当天）、before:D 到 D 当天 00:00 为止（不含当天）、on:D 只有 D 那一天。",
    "range_7d": "过去 7 天",
    "hist_tip": "{{at}} · {{n}} 条",
    "hist_hint": "在柱状图上拖选可以设时间范围；点一格 = 只看那一个小时。",
    "term_as_class": "{{terms}} 按事件种类找：「{{cls}}」类（含视频信号中断、设备被拆除或遮挡）"
  },
  "exports": {
    "title": "导出与证据",
    "help": "将录像导出成 MP4 证据包（含每个文件的 SHA-256 与平台签名）；来源可选云端、NVR / Station 硬盘或异地备份。每次下载都重新验证权限；完成的免费保存 30 天，要更久可改成长期保管。",
    "new": "新建导出",
    "none": "还没有导出",
    "st_queued": "排队中",
    "st_running": "处理中",
    "st_done": "完成",
    "st_failed": "失败",
    "st_expired": "已过期",
    "signed": "已签名",
    "unsigned": "未签名",
    "reason": "原因",
    "download": "下载证据包",
    "share": "分享",
    "home": "$t(leaf.cur) / 场所",
    "cameras": "摄像头（最多 {{max}} 路）",
    "from": "开始时间",
    "minutes": "长度",
    "n_min": "{{n}} 分钟",
    "reason_ph": "例如：警方调阅、案号…（必填，会写进审计与证据包）",
    "create": "创建导出",
    "export_this": "导出这段",
    "share_title": "分享链接",
    "ttl": "有效期限",
    "ttl_3600": "1 小时",
    "ttl_86400": "1 天",
    "ttl_604800": "7 天",
    "ttl_2592000": "30 天",
    "max_views": "观看次数上限",
    "unlimited": "不限",
    "share_password": "密码",
    "share_password2": "确认密码",
    "optional": "选填",
    "share_create": "创建链接",
    "share_once": "这个链接只会显示这一次，请现在复制。",
    "expires": "{{at}} 到期",
    "views": "已看 {{n}} / {{max}}",
    "has_password": "有密码",
    "revoked": "已撤销",
    "expired": "已到期",
    "revoke": "撤销",
    "err_REASON_REQUIRED": "导出原因必填（4 字以上）",
    "err_BAD_RANGE": "时段不对：每路一段、结束晚于开始、最长 1 小时、不能是未来",
    "err_BAD_SOURCES": "选 1–4 路摄像头",
    "err_FORBIDDEN": "没有导出这台摄像头的权限",
    "err_EXPORT_NOT_READY": "导出还没完成",
    "err_BAD_TTL": "期限要在 1 小时到 30 天之间",
    "source": "来源",
    "src_cloud": "云端录像",
    "src_local": "NVR / Station 硬盘",
    "src_backup": "异地备份",
    "src_cloud_help": "从云端录像的片段导出。",
    "src_local_help": "请 NVR / Kinio Station 把这段本地录像上传后导出（只给这次导出，不算云端录像、不占席位）；设备要在线，摄像头的 SD 卡还不支持。",
    "src_backup_help": "从异地备份的已验证副本导出（读取时再验一次完整性）。",
    "local_waiting": "等设备上传本地录像（最多 30 分钟）…",
    "fail_local_export_unsupported": "这台设备的固件还不支持本地录像导出",
    "fail_local_upload_timeout": "设备没有在时限内传完本地录像（可能离线或上传太慢）",
    "fail_local_export_failed": "设备没有收下导出请求（可能离线）",
    "fail_no_recording": "这个时段没有本地录像",
    "fail_codec_not_supported": "这个时段的视频编码不支持导出（只支持 H.264 / H.265）",
    "tab_jobs": "导出任务",
    "no_rec_in_source": "这段时间没有{{src}}",
    "recipient": "收件人",
    "recipient_ph": "例：田中专员 / tanaka@example.jp",
    "recipient_help": "一个收件人一条链接；会以遮罩后的形式出现在对方画面的水印上。",
    "ttl_until_export": "到导出包到期（{{at}}）",
    "share_export_expiry": "导出包保存到 {{at}}，分享链接最晚也到那时。",
    "share_clamped": "期限已截到导出包到期（{{at}}）。",
    "no_recipient": "（没有填收件人）",
    "err_EXPORT_EXPIRES_SOON": "导出包保存剩不到 1 小时，请重新导出再分享。",
    "err_RECIPIENT_REQUIRED": "要填收件人（名字或 email，最多 100 字）",
    "fail_signing_failed": "证据包签名失败，没有产生未签名的包；请稍后重新导出或联系平台",
    "block_not_enabled": "这个组织还没开通证据导出，请联系服务商开通。",
    "block_worker_disabled": "这个环境目前不能创建导出。",
    "block_tmp_space_low": "导出服务繁忙，请稍后再试。",
    "block_gateway_unreachable": "暂时无法创建导出，请稍后再试。",
    "max_views_help": "默认 {{n}} 次；对方每打开一次分享页算一次。",
    "fail_queue_timeout": "排队太久没有开始（当时导出服务没开或繁忙），请重新创建导出。",
    "st_deleted": "已删除",
    "archived": "长期保管",
    "kept_free": "免费保存到 {{at}}",
    "kept_archive": "长期保管到 {{at}}",
    "quota_line": "免费保存空间（组织共用）：已用 {{used}} / {{limit}}",
    "block_quota_exceeded": "这个组织的免费导出空间已用完：删除不需要的导出包，或把要留的改成长期保管。",
    "delete": "删除…",
    "delete_title": "删除导出包",
    "delete_help": "删除后证据包与它的分享链接立即失效，文件会从云端删除，无法恢复。",
    "delete_no_refund": "这个导出包在长期保管中：提前删除，已付的保管费用不退。",
    "delete_reason": "删除原因（必填，会写进审计）",
    "delete_confirm": "删除",
    "deleted_reason": "删除原因",
    "err_EXPORT_BUSY": "导出还在进行中，完成后才能删除。",
    "err_EXPORT_GONE": "导出包已到期或已删除。",
    "archive": "长期保管…",
    "archive_extend": "延长保管…",
    "archive_title": "改成长期保管",
    "archive_extend_title": "延长长期保管",
    "archive_help": "这个导出包 {{size}}（{{cls}}）。长期保管期间照常可下载、验证、建分享链接（每条仍最长 30 天）；到期后删除。延长会接在当前到期日后面。",
    "archive_size_5gb": "≤ 5 GB",
    "archive_size_20gb": "≤ 20 GB",
    "archive_size_50gb": "≤ 50 GB",
    "archive_period": "保管期间",
    "archive_p_90d": "90 天",
    "archive_p_1y": "1 年",
    "archive_p_3y": "3 年",
    "archive_after": "付款后保存到 {{at}}",
    "archive_reason": "原因（必填，会写进审计）",
    "archive_no_refund": "一次性付款、价格不含税；提前删除或删除$t(leaf.cur)时，已付的费用不退。",
    "archive_pay": "前往付款",
    "archive_processing": "付款处理中，完成后这里会更新…",
    "archive_done": "长期保管已生效。",
    "archive_failed": "付款没有完成，导出包维持原本的保存期限。",
    "archive_canceled": "已取消付款，导出包维持原本的保存期限。",
    "archive_slow": "付款结果还没回来，请稍后刷新。",
    "err_ARCHIVE_TOO_LONG": "延长后的到期日不能晚于今天起 3 年。",
    "err_ARCHIVE_TOO_LARGE": "超过 50 GB 的导出包不提供长期保管。",
    "err_ARCHIVE_PENDING": "这个导出包已有结账中的长期保管，请先完成或等它过期（23 小时）。",
    "err_EXPORT_NOT_DONE": "导出完成后才能改成长期保管。",
    "err_STORE_NOT_CONFIGURED": "这个品牌目前不能在线付款，请联系服务商。",
    "err_BAD_PERIOD": "保管期间只能是 90 天、1 年或 3 年。"
  },
  "shares": {
    "tab": "分享链接",
    "help": "所有对外的分享链接：给了谁、谁建的、什么时候到期、看了几次。识别码就是对方画面水印上的 6 码。",
    "filter": "显示范围",
    "f_active": "有效的",
    "f_all": "全部",
    "revoke_picked": "撤销选取的 {{n}} 条",
    "none_active": "目前没有对外开着的分享链接",
    "none_all": "还没有建过分享链接",
    "pick_all": "选取全部有效的",
    "pick": "选取 {{code}}",
    "col_video": "视频",
    "col_recipient": "收件人",
    "col_code": "识别码",
    "col_by": "创建者",
    "col_created": "创建时间",
    "col_expires": "到期",
    "col_views": "观看",
    "col_password": "密码",
    "col_status": "状态",
    "col_actions": "操作",
    "by_me": "我",
    "by_other": "其他成员",
    "st_active": "有效",
    "st_expired": "已到期",
    "st_revoked": "已撤销",
    "st_used_up": "次数用完",
    "revoke_one_title": "撤销后对方就打不开这条链接",
    "revoke_body": "收件人：{{who}}（识别码 {{code}}）。30 秒内生效，不能恢复；要再给就重新建一条。",
    "revoke_many_title": "撤销 {{n}} 条分享链接",
    "revoke_many_body": "这些收件人 30 秒内就打不开，不能恢复。撤销失败的会留在表上并写原因。"
  },
  "share": {
    "title": "分享的视频",
    "need_password": "这段视频有密码保护",
    "password": "密码",
    "wrong_password": "密码错误",
    "open": "打开",
    "gone": "这个分享链接已失效（到期、被撤销或观看次数用完）。",
    "not_found": "找不到这个分享链接。",
    "error": "暂时无法加载，请稍后再试。",
    "expires": "链接于 {{at}} 到期",
    "clip_n": "片段 {{n}}"
  },
  "verify": {
    "title": "证据包验证",
    "help": "在浏览器里检查证据包：每个文件的 SHA-256 是否跟 manifest 一致、manifest 的平台签名是否有效。文件不会上传。",
    "drop": "把证据包 ZIP 拖到这里，或点一下选文件",
    "checking": "检查中…",
    "v_pass": "验证通过：文件完整、签名有效",
    "v_fail": "验证失败：内容被改过或签名无效",
    "v_unsigned": "文件完整，但这份证据包没有签名",
    "job": "导出工作",
    "exported_by": "导出者",
    "reason": "原因",
    "generated": "生成时间",
    "signature": "签名",
    "sig_valid": "有效",
    "sig_invalid": "无效（manifest 被改过或不是平台签的）",
    "sig_unsigned": "没有签名",
    "sig_no_key": "找不到对应的平台密钥",
    "missing": "缺少这个文件",
    "mismatch": "SHA-256 不一致（被改过）",
    "extra": "manifest 没列的多余文件",
    "err_bad_zip": "不是有效的 ZIP",
    "err_no_manifest": "ZIP 里没有 manifest.json",
    "err_bad_manifest": "manifest.json 格式错误",
    "tab": "验证证据包",
    "key": "签名密钥",
    "fp_short": "指纹 {{fp}}",
    "key_current": "使用中",
    "key_retired": "已停用",
    "keys_title": "平台的验签密钥（{{n}} 把）",
    "keys_help": "换过密钥后，旧的证据包仍用当时那把验。可以拿下面的指纹跟平台公开说明页比对。"
  },
  "billing": {
    "subject": "付费主体",
    "subject_org": "组织：{{name}}",
    "subject_home": "$t(leaf.cur)：{{name}}",
    "no_subject": "你没有可以管理方案的组织或$t(leaf.cur)。",
    "notice_ok": "完成",
    "notice_warn": "注意",
    "notice_err": "错误",
    "checkout_canceled": "已取消付款，没有扣款。",
    "checkout_processing": "付款完成，正在确认（通常几秒内）…",
    "checkout_done": "购买完成，席位与额度已生效。",
    "checkout_failed": "付款没有完成或已过期。",
    "checkout_slow": "付款确认比平常久，请稍后刷新；如果已扣款，席位会自动出现。",
    "subscriptions": "订阅",
    "no_subscriptions": "还没有订阅。",
    "items": "内容",
    "state": "状态",
    "period_end": "下次续订 / 到期",
    "grace_until": "宽限到 {{at}}",
    "manage": "管理付款与订阅",
    "manage_hint": "在 Stripe 的管理页可以改席位数、换卡、取消（变更会在一分钟内同步回来）。",
    "buy": "购买",
    "draft_prices": "价格暂定",
    "store_not_configured": "这个品牌还没设置付款账号，暂时不能购买。",
    "need_org_billing": "购买需要组织管理员或「账单」权限；你可以查看，但不能购买。",
    "need_owner": "只有$t(leaf.cur)的所有者可以购买。",
    "product": "商品",
    "price": "价格",
    "quantity": "数量",
    "per_month": "月",
    "per_year": "年",
    "per_seat": "每席",
    "buy_btn": "购买（{{total}}）",
    "seat_name": "云端录像席位：{{mode}}、保存 {{days}} 天",
    "ai_name": "云端 AI：每月 {{n}} 次分析",
    "pack_name": "云端 AI 加购：{{n}} 次",
    "pack_hint": "本月（UTC）有效",
    "ai_already": "已有云端 AI 订阅；额度不够请加购",
    "mode_event": "事件录像",
    "mode_continuous": "全天录像",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "seats": "云端录像席位",
    "seats_summary": "共 {{total}} 席、{{free}} 席未分配",
    "no_seats": "还没有席位。购买后在这里分配到设备或通道。",
    "seat": "席位",
    "source": "来源",
    "source_subscription": "订阅",
    "source_grant": "合同",
    "contract_until": "合同到 {{at}}",
    "assigned_to": "分配到",
    "unassigned": "未分配",
    "has_seat": "已有席位",
    "usage_month": "本月上传",
    "usage": "{{clips}} 段 · {{mb}} MB",
    "assigned": "已分配到 {{name}}，{{within}} 秒内开始用这一席上云。",
    "covered_by_plan": "{{name}} 原本就在$t(leaf.cur)方案内；分配后改用这一席的保存天数与模式。",
    "seats_hint": "一台设备（或 NVR 的一个通道）同时只能有一席；改派后原设备最迟 60 秒停止上云，已存的片段按原保存天数保留。",
    "ai": "云端 AI 额度",
    "ai_usage": "{{period}} 已用 {{used}} / {{limit}} 次",
    "ai_packs": "（含加购 {{n}} 次）",
    "ai_limit_reached": "本月额度已用完：分析已暂停，录像与事件不受影响。可以加购。",
    "ai_near_limit": "本月额度已用超过 80%。",
    "ai_feature_detect": "物体检测补位",
    "ai_feature_attributes": "属性标签",
    "ai_feature_caption": "场景描述",
    "ai_feature_lpr": "车牌识别",
    "state_pending": "待付款",
    "state_active": "有效",
    "state_cancel_pending": "期末取消",
    "state_grace": "宽限中",
    "state_on_hold": "暂停（付款失败）",
    "state_expired": "已到期",
    "state_revoked": "已撤销",
    "state_ended": "已结束",
    "err_generic": "操作失败（{{code}}）",
    "err_FEATURE_DISABLED": "全天录像即将开放，目前不能购买全天席位。",
    "coming_soon": "即将开放",
    "err_STORE_NOT_CONFIGURED": "这个品牌还没设置付款账号。",
    "err_ALREADY_ENTITLED": "已经有云端 AI 订阅；额度不够请加购。",
    "err_REF_HAS_SEAT": "这台设备已经有席位，先解除那一席。",
    "err_SEAT_ENDED": "这一席已经结束。",
    "err_PRODUCT_NOT_PURCHASABLE": "这个商品目前不能购买（可能已改版），请刷新。",
    "err_BAD_RETURN_URL": "回传网址不被允许。",
    "err_DEVICE_NOT_FOUND": "这台设备不在这个主体的$t(leaf.cur)里。",
    "err_FORBIDDEN": "你没有这个操作的权限。",
    "err_USE_ORG_BILLING": "团体组织$t(leaf.cur)的席位与 AI 由组织购买。",
    "err_NO_CUSTOMER": "还没买过，没有可管理的付款资料。",
    "err_STORE_ERROR": "付款服务暂时无法使用，请稍后再试。",
    "rate": "最近 1 小时 {{kbps}} kbps",
    "uplink_title": "全天录像的实测上行（最近 1 小时，按场所）：",
    "uplink_home": "{{mbps}} Mbps；请确认场所的上行带宽足够",
    "pick_title": "要看哪一个的方案与账单？",
    "capsule": "付费主体：{{name}}",
    "home_plan_item": "{{name}}（{{where}}）",
    "home_plan_cams_one": "另外由$t(leaf.cur)方案提供云录的摄像头：{{names}}",
    "home_plan_cams_other": "另外由$t(leaf.cur)方案提供云录的摄像头（{{count}} 台）：{{names}}",
    "archives": "证据包长期保管",
    "archives_help": "导出包免费保存 30 天；要更久，在「导出与证据」对每个包选〔长期保管…〕，一次性付款（美元、不含税）。",
    "archive_size": "导出包大小",
    "no_archives": "目前没有长期保管中的导出包。",
    "archive_job": "导出任务",
    "archive_period": "期间",
    "archive_ends": "保管到",
    "archive_days": "{{n}} 天",
    "archive_st_active": "保管中",
    "archive_st_pending": "结账中",
    "archive_st_expired": "结账过期",
    "archive_st_revoked": "已退款"
  },
  "backup": {
    "title": "异地备份",
    "help": "把 NVR 的录像加密后送到 NAS 或另一台 NVR。目的地只存加密后的文件、拿不到密钥；覆盖率看的是“已确认送达并验证的最后时间点”。",
    "add_target": "新增目的地",
    "new_policy": "新增备份策略",
    "targets": "目的地",
    "no_targets": "还没有备份目的地。",
    "policies": "备份策略",
    "no_policies": "还没有备份策略。",
    "delete": "删除",
    "test": "测试连接",
    "test_ok": "连接正常",
    "test_first": "先测试",
    "save_target": "登记",
    "rotate": "更换凭据",
    "rotate_title": "更换 {{name}} 的写入凭据",
    "rotate_help": "新凭据送到平台后托管；旧的立即退役。更换后会回到“未测试”，请再测一次。",
    "in_use": "还有策略在用，先撤销策略",
    "confirm_delete_target": "删除目的地“{{name}}”？凭据会一并退役。",
    "via_device": "经 Kinio 设备",
    "quota_used": "已用 {{used}} / 额度 {{quota}}",
    "cred_hint": "写入 {{write}}、读取 {{read}}",
    "policies_n": "{{n}} 个策略",
    "cat_ok": "正常",
    "cat_auth": "认证失败",
    "cat_network": "网络问题",
    "cat_permission": "权限不足",
    "cat_space": "空间不足",
    "cat_config": "设置错误",
    "cat_integrity": "内容不一致",
    "cat_unsupported": "要设备代测",
    "cat_unknown": "无法识别",
    "step_quota": "额度",
    "step_put": "写入",
    "step_head": "检查",
    "step_get": "读回",
    "step_delete": "删除",
    "kind_nas_s3": "NAS（S3 兼容）",
    "kind_nas_smb": "NAS（SMB）",
    "kind_nas_nfs": "NAS（NFS）",
    "kind_nvr": "另一台 NVR",
    "kind_help_nas_s3": "Synology / QNAP 内置的 S3 服务或 MinIO；同站或异地都可。NVR 用 S3 API 直推密文并验证 checksum。",
    "kind_help_nas_smb": "只限与来源 NVR 同站局域网，一律经同站的 Kinio 设备访问。",
    "kind_help_nas_nfs": "同 SMB：只限同站局域网（Linux / macOS NAS）。",
    "kind_help_nvr": "同一个组织的另一台 Kinio NVR（团体组织的$t(leaf.cur)）；两端拥有者都要核准，必须不同故障域。",
    "home": "$t(leaf.cur)",
    "kind": "类型",
    "name": "名称",
    "target_nvr": "目的 NVR",
    "endpoint_s3": "S3 端点",
    "endpoint_smb": "SMB 路径",
    "endpoint_nfs": "NFS 路径",
    "bucket": "Bucket",
    "prefix": "前缀",
    "region": "Region",
    "path_style": "Path-style（多数 NAS 要勾）",
    "access_path": "回放时怎么读",
    "ap_public": "NAS 有公网 HTTPS 端点（VMS 直接读）",
    "ap_via_device": "经同站另一台 Kinio 设备代理",
    "proxy_device": "代理设备",
    "quota_gb": "额度（GB）",
    "quota_help": "NAS 回报不了剩余空间，平台照这个额度挡；超过就停止新备份，不删未到期的副本。",
    "credentials": "凭据",
    "cred_help": "凭据只送这一次，由平台托管（加密）；写入的只发给来源 NVR，读取的只给回放。建议写入 / 读取用两组、权限只到这个 bucket / prefix。",
    "separate_read": "读取用另一组",
    "read_prefix": "读取",
    "username": "账号",
    "password": "密码",
    "access_key": "Access key",
    "secret_key": "Secret key",
    "fault_domain": "故障域",
    "fd_site": "场所",
    "fd_facility": "机房 / 建筑",
    "fd_power": "供电 / UPS",
    "fd_network": "对外网络",
    "fd_help": "共用机房或供电 = 同一个故障域（一次火灾 / 停电两边一起没）。IP 不同不算异地。",
    "fd_required_nvr": "NVR 互备要填两端的场所、机房、供电、对外网络并确认现场。",
    "site_confirmed": "已到现场确认上面的故障域",
    "wz1": "来源 NVR 与通道",
    "wz2": "目的地",
    "wz3": "保留天数、速率、额度",
    "wz4": "容量试算",
    "wz5": "故障域",
    "wz6": "提交核准",
    "source_nvr": "来源 NVR",
    "no_nvr": "你拥有的$t(leaf.cur)里没有多通道的 NVR。",
    "channels": "通道",
    "stream_main": "主码流",
    "stream_sub": "子码流",
    "target": "目的地",
    "needs_target_approval": "目的地在别的$t(leaf.cur)，提交后要那个$t(leaf.cur)的拥有者核准。",
    "retention_days": "保留天数",
    "rate_limit": "速率上限（Mbps）",
    "unlimited": "不限",
    "policy_quota": "策略额度（GB）",
    "auto": "= 估算值",
    "estimate": "试算",
    "submit": "提交并核准来源方",
    "est_line": "码率合计 {{bps}} × {{days}} 天 ≈ {{raw}}，加 {{oh}}% 开销与 {{margin}}% 余量 = {{total}}",
    "est_assumed": "{{n}} 路没有回报码率，用假设值（主码流 2 Mbps、子码流 512 kbps）估。",
    "est_note": "以全时录像的上限估算；上行与目的端写入都要持续有这个带宽。",
    "target_free": "目的地还可配 {{free}}",
    "not_offsite": "非异地",
    "incoming": "（别的$t(leaf.cur)送来的备份）",
    "pst_draft": "草稿",
    "pst_pending_approval": "待核准",
    "pst_validating": "检查中",
    "pst_active": "运行中",
    "pst_degraded": "落后",
    "pst_paused": "已暂停",
    "pst_revoked": "已撤销",
    "cov_ok": "已保护",
    "cov_degraded": "落后 > 120 秒",
    "cov_not_recording": "来源没在录",
    "cov_partial": "来源失联，只到已知的位置",
    "cov_unknown": "未知",
    "tst_untested": "未测试",
    "tst_ok": "连接正常",
    "tst_failed": "测试失败",
    "tst_disabled": "已停用",
    "policy_line": "{{ch}} 路 · 保留 {{days}} 天 · 额度 {{quota}} · 速率 {{rate}} · 版本 {{v}}",
    "target_view": "这里只存对方的密文：{{n}} 个对象、{{bytes}}（没有视频入口）",
    "cov_line": "最慢的通道已保护到 {{until}} · 最大落后 {{lag}} · 待传 {{pending}} · 缺口 {{missing}} 段",
    "col_channel": "通道",
    "col_state": "状态",
    "col_protected": "已保护到",
    "col_lag": "落后",
    "col_pending": "待传",
    "col_missing": "缺口",
    "col_verified": "最后验证",
    "approve_source": "核准（来源方）",
    "approve_target": "核准（目的方）",
    "pause": "暂停",
    "resume": "恢复",
    "revoke": "撤销",
    "confirm_revoke": "撤销这个策略？停止新备份；已存的副本依原保留期处理（不是删除数据）。",
    "v_name": "名称必填",
    "v_quota": "额度必填",
    "v_endpoint_s3": "端点写成 https://主机[:端口]",
    "v_bucket": "bucket 名称不对（小写英数、点、减号）",
    "v_creds": "要填凭据",
    "v_proxy": "要选同站的代理设备",
    "v_endpoint_smb": "SMB 路径写成 //主机/共享名称",
    "v_endpoint_nfs": "NFS 路径写成 主机:/export",
    "v_nvr": "要选目的 NVR",
    "v_kind": "类型不对",
    "err_ESCROW_UNAVAILABLE": "这个环境还没设置密钥托管，暂时不能保存 NAS 凭据。",
    "err_OWNER_REQUIRED": "只有$t(leaf.cur)拥有者能设置异地备份",
    "err_SOURCE_UNSUPPORTED": "这台 NVR 的固件还不能做异地备份",
    "err_TARGET_UNSUPPORTED": "目的 NVR 的固件还不能接收异地备份",
    "err_CAPACITY_INSUFFICIENT": "容量不足：{{message}}",
    "err_SAME_FAULT_DOMAIN": "同一个故障域：{{message}}",
    "err_FAULT_DOMAIN_REQUIRED": "{{message}}",
    "err_TARGET_IN_USE": "还有策略在用这个目的地",
    "err_POLICY_VERSION_MISMATCH": "策略内容已经改过，请刷新后再核准",
    "err_VERSION_CONFLICT": "别人刚改过，请刷新",
    "err_PERSONAL_NVR_BACKUP_UNSUPPORTED": "NVR 互备只给团体组织的$t(leaf.cur)",
    "err_SMB_LAN_ONLY": "SMB 只限同站局域网",
    "err_RATE_LIMIT_TOO_LOW": "{{message}}",
    "restore": "恢复",
    "restore_help": "把已验证的备份副本写回这个$t(leaf.cur)的一台 NVR（修好或替换的那台）。逐段验证，可取消；写回的片段仍属于原本的摄像头，不会自动恢复摄像头账号或网络设置。",
    "restore_target": "写回哪台 NVR",
    "restore_start": "开始恢复",
    "restore_line": "恢复到 {{nvr}}：{{status}}（{{done}} / {{total}}，失败 {{failed}}）",
    "rst_queued": "排队中",
    "rst_running": "进行中",
    "rst_done": "完成",
    "rst_failed": "有失败",
    "rst_canceled": "已取消",
    "from": "从",
    "to": "到",
    "purge": "清除备份数据",
    "confirm_purge": "清除这个策略在目的地上的所有副本？策略会一并撤销。NVR 会逐一删除对象，目的地离线时会显示“等待删除”。这个动作无法恢复。",
    "rs_deleting": "删除中 {{n}}",
    "rs_deletion_pending": "等待删除 {{n}}（目的地未确认）",
    "rs_deleted": "已删除 {{n}}",
    "rs_corrupt": "损坏 {{n}}",
    "rs_lost": "丢失 {{n}}",
    "err_RESTORE_UNSUPPORTED": "这台 NVR 的固件还不能写回备份",
    "err_NOTHING_TO_RESTORE": "这段时间没有已验证的副本",
    "need_target": "先新增目的地",
    "no_policies_need_target": "还没有备份策略。先在上面新增目的地，才能建立备份策略。"
  },
  "aiCloud": {
    "title": "云端 AI",
    "no_subscription": "还没有云端 AI 订阅。",
    "go_billing": "到方案与账单购买 →",
    "consented": "已同意",
    "consented_at": "{{at}} 同意",
    "excluded_help": "逐台排除（例如卫生间附近、住户区）：勾选的摄像头不会送云端分析。",
    "exclude": "排除",
    "revoke": "撤回同意",
    "revoke_help": "撤回后 60 秒内停止发送；已产生的分析按事件保存期处理。",
    "outdated": "同意书已更新，请重新阅读并同意。",
    "consent_body": "云端 AI 会把移动事件发生时的云端录像片段画面（事件当下与之后 2 秒共 3 张）送去分析：\n・用途：识别画面中的人、车、动物、包裹，过滤误报；（选择时）生成一句场景描述与衣着 / 车辆等属性，供搜索。\n・处理者：Kinio 自建的物体检测模型（YOLOX）；场景描述由 Anthropic 的 Claude 生成。\n・保存：分析结果与事件一起保存（30 天，有片段的按片段保存天数）；发送的画面不另外保存。\n・不做：人脸识别、身份推测；分析结果只是建议，不会控制任何设备。\n・只有已有云端录像的设备能分析；可以逐台排除，也可以随时撤回。",
    "agree": "我已阅读并同意以上内容",
    "grant": "同意并启用",
    "grant_help": "需要重新验证身份。",
    "need_org_admin": "需要组织管理员才能同意。",
    "need_owner": "需要$t(leaf.cur)所有者才能同意。",
    "badge_confirmed": "云端 AI 确认：{{what}}",
    "badge_no_target": "云端 AI 判定非人车",
    "label_person": "人",
    "label_vehicle": "车",
    "label_animal": "动物",
    "label_package": "包裹",
    "err_CONSENT_TEXT_OUTDATED": "同意书已更新，请刷新后再同意。",
    "err_NO_CONSENT": "目前没有同意。",
    "err_VERSION_CONFLICT": "别人刚改过，已重新加载。",
    "err_USE_ORG_CONSENT": "团体组织$t(leaf.cur)的云端 AI 同意由组织管理员给。",
    "err_FORBIDDEN": "你没有这个操作的权限。",
    "pick_subject": "选一个组织或$t(leaf.cur)，看它的云端 AI 同意与用量（会切换页首范围）。",
    "no_subject": "目前的范围没有可以订阅云端 AI 的组织或$t(leaf.cur)。",
    "consent_summary": "云端 AI 会把事件当下的云端录像画面送去分析（识别人、车、动物、包裹，过滤误报）；不做人脸识别，可以逐台排除、随时撤回。",
    "consent_more": "查看完整说明"
  },
  "dset": {
    "confirm_streams": "这项设置会影响现有录像与观看（码流 / 画质会重新协商），确定要改吗？",
    "timeout": "设备 25 秒内没有确认",
    "load_offline": "设备离线或暂时无法读取设置",
    "load_error": "读取设置失败",
    "none": "这台设备没有可在网页调整的设置",
    "use_app": "请用设备 App 操作",
    "owner_only": "仅拥有者",
    "pending": "应用中",
    "applied": "已应用",
    "adjusted": "设备采用了不同的值",
    "failed": "失败",
    "unknown": "未上报",
    "streams_title": "会影响现有录像与观看",
    "streams_body": "码流 / 画质会重新协商，正在观看与录像的画面会中断几秒。",
    "tech_title": "技术设置改错可能让设备断线或停止录像",
    "tech_body": "这是安装商 / 工程用的设置；修改前请确认你了解这个值的影响。",
    "tech_help": "安装商 / 工程用的设置：改错可能断线、停止录像或违反法规。每次修改都会先确认。",
    "tech_none": "这台设备没有技术设置",
    "change_body": "「{{label}}」改为 {{value}}",
    "apply_change": "修改「{{label}}」",
    "segment_switch": "切换为「{{label}}」",
    "depends_on": "先开启「{{parent}}」才能调整",
    "depends_value": "「{{parent}}」设为 {{values}} 时才能调整",
    "advanced_n": "高级（{{n}}）",
    "sections": "设置分区",
    "val_free": "（可用 {{v}}）",
    "val_none": "没有",
    "val_locked": "未设置",
    "val_unknown": "未知",
    "val_never": "不会过期",
    "vendor_fw": "原厂固件版本",
    "auto_apply": "改了就会套用到设备，不用按保存。",
    "ch_summary": "{{online}} 路在线 / 共 {{total}} 路",
    "ch_summary_label": "通道",
    "val_on": "开",
    "val_off": "关",
    "val_present": "有",
    "val_absent": "没有",
    "read_only_section": "这些是设备回报的信息，不能在这里改。",
    "ttl_dut_model": "{{label}}（{{model}}）",
    "ttl_dut_aid": "AID {{aid}}",
    "ttl_token_set_label": "UART（TTL）密钥已设置",
    "ttl_rx_at_label": "UART（TTL）最后有输出",
    "quality_res_named": "{{name}}（{{dims}}）"
  },
  "ddev": {
    "not_found": "找不到这台设备，或你没有权限。",
    "back": "返回设备列表",
    "tab_overview": "概览",
    "tab_live": "实时与回放",
    "tab_channels": "通道",
    "tab_settings": "设置",
    "tab_recording": "录像与存储",
    "tab_events": "事件",
    "tab_health": "健康与固件",
    "tab_links": "关联",
    "status": "状态",
    "media_status": "媒体状态",
    "capabilities": "能力",
    "storage": "存储",
    "no_events": "过去 24 小时没有事件",
    "links_hint": "把这个传感器关联到摄像头：事件卡片与弹窗会带出关联摄像头同一时刻的画面。",
    "tab_site": "现场设备",
    "tab_ai": "AI",
    "tab_firmware": "固件",
    "tab_location": "位置",
    "tab_audit": "审计",
    "ai_unavailable": "AI 运算信息暂时读不到",
    "ai_none": "这台摄像头还没指派 AI 分析",
    "ai_open": "到 AI 分析页",
    "fw_unavailable": "固件状态暂时读不到（或这台不经平台更新）",
    "fw_available": "可用更新",
    "fw_latest": "已是最新",
    "fw_auto": "自动更新",
    "fw_update_now": "立即更新",
    "fw_confirm": "现在更新固件 {{v}}？更新中设备会重启。",
    "fw_started": "已发出更新，设备会在下载完成后重启",
    "fw_via_app": "这台由 App 转交更新，请用 App 完成",
    "site": "场所",
    "geo": "地图坐标",
    "floorplan": "平面图",
    "open_map": "到地图",
    "tab_analytics": "智能分析",
    "tab_technical": "技术",
    "tab_nodes": "节点",
    "tab_advanced": "高级",
    "maintenance": "维护",
    "open_playback": "在回放页打开",
    "last_seen": "最后上线",
    "fw_short": "固件 {{v}}",
    "fw_has_update": "（有新版）",
    "fw_is_latest": "（最新）",
    "fw_all": "查看全部设备的固件 →",
    "path": "所在位置",
    "reboot_hint": "设备会离线约 1–2 分钟，期间不会录像。",
    "support_title": "复制给客服",
    "support_hint": "客服需要时再复制；这些代码不会出现在一般画面。",
    "support_copy": "复制",
    "support_copied": "已复制",
    "ai_provider_unnamed": "未命名的 AI 运算设备",
    "maintenance_sub": "重新启动、解除绑定",
    "rec_settings": "录像与存储的设置",
    "ch_summary_one": "{{count}} 路",
    "ch_summary_other": "{{count}} 路",
    "ch_summary_off_one": "{{count}} 路离线",
    "ch_summary_off_other": "{{count}} 路离线",
    "ch_view": "看通道",
    "adv_diag": "诊断",
    "adv_diag_sub": "串口终端，供安装与开发使用",
    "adv_diag_dut": "接的是 {{name}}",
    "ev_recording": "录像片段",
    "ev_open_in_events": "在事件页打开",
    "ev_only_recording": "这 24 小时只有录像片段，没有事件；勾「录像片段」可以看。",
    "sd_no_capacity": "SD 卡 · 读不到容量（设备没有回报）",
    "sd_no_capacity_tip": "插着 SD 卡，但设备没有回报容量；可以到「录像与存储」看录像状态。",
    "no_snapshot": "还没有快照",
    "watch_live": "看实时",
    "rec_settings_fold_one": "录像与存储的设置（{{count}} 项）",
    "rec_settings_fold_other": "录像与存储的设置（{{count}} 项）",
    "ev_system_hint": "「系统」是设备自己的状态变化（上线 / 离线、重新开机、串流或录像开始 / 结束），不是侦测到的事；平常不用处理。这些状态记录只在这里列，不进事件页的搜索与统计（所以事件页的「系统」可能比这里少）。",
    "ev_system_generic": "设备状态变化",
    "recent_events": "最近事件",
    "recent_none": "最近 7 天没有事件。",
    "recent_all": "看这台的全部事件 ▸",
    "ev_lasted": "（持续 {{dur}}）",
    "ev_window": "过去 24 小时",
    "change_wifi": "更换 Wi-Fi",
    "change_wifi_app": "请用手机 App 更换：手机要在设备旁边，用蓝牙或设备的热点把新的 Wi-Fi 交给它。"
  },
  "health": {
    "title": "健康",
    "level_ok": "正常",
    "level_warn": "注意",
    "level_alert": "异常",
    "level_unknown": "未上报",
    "free": "可用",
    "retention_days_one": "预计可保存 {{count}} 天",
    "retention_days_other": "预计可保存 {{count}} 天",
    "reason_smart": "SMART 异常",
    "reason_disk_error": "硬盘错误",
    "reason_disk_full": "硬盘已满",
    "reason_no_disk": "没有检测到硬盘",
    "reason_almost_full": "空间不足 5%（未开覆盖）",
    "rate": "当前录像码率 {{kbps}} kbps",
    "no_rate": "设备没有上报录像码率，无法估算保存天数",
    "disk_model": "型号 / 序列号",
    "disk_state": "状态",
    "capacity": "可用 / 总容量",
    "no_disks": "设备没有上报单块硬盘信息",
    "online_rate": "设备在线率",
    "recorders": "录像主机",
    "recorders_bad": "异常 / 总数",
    "min_retention": "最短预计保存",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "offline_list": "离线设备（{{n}}）",
    "smart_ok": "正常",
    "smart_warn": "注意",
    "smart_fail": "异常",
    "smart_unknown": "未知",
    "smart_temp": "{{c}} °C",
    "smart_poh": "通电 {{h}} 小时",
    "smart_sectors": "重新分配 {{realloc}}、待处理 {{pending}}、无法修正 {{uncorr}} 个扇区",
    "smart_test_run": "自检",
    "smart_test_sent": "已发送自检（约 2 分钟）",
    "smart_test_running": "自检进行中",
    "smart_test_pass": "上次自检：通过",
    "smart_test_fail": "上次自检：未通过",
    "smart_test_aborted": "上次自检：已中止",
    "smart_test_weekly": "每周自动",
    "reason_smart_warn": "SMART 需注意",
    "overwrite": "录像覆盖",
    "overwrite_auto": "自动覆盖",
    "overwrite_off": "不覆盖（满了会停录）",
    "overwrite_days_one": "保留 {{count}} 天",
    "overwrite_days_other": "保留 {{count}} 天",
    "rec_space": "录像空间",
    "disk_space": "磁盘空间",
    "kind_hdd": "HDD",
    "kind_ssd": "SSD",
    "kind_sd": "SD 卡",
    "kind_usb": "USB",
    "kind_flash": "内置 flash",
    "kind_disk": "硬盘",
    "disks_title": "物理硬盘",
    "volume_title": "录像卷",
    "legacy_note": "这台设备上报的是录像卷（旧格式），没有单块物理硬盘与存储池信息",
    "disk_kind": "类型",
    "disk_record": "录像盘",
    "record_yes": "是",
    "record_no": "否",
    "physical_capacity": "物理容量",
    "pools_title": "存储池",
    "no_pools": "设备没有上报存储池",
    "pool_role": "用途",
    "role_record": "录像",
    "role_system": "系统",
    "role_index": "索引",
    "pool_disk": "所在硬盘",
    "pool_part": "分区",
    "pool_capacity": "容量",
    "pool_used": "用量",
    "pool_in_use": "使用中",
    "pool_idle": "尚未启用",
    "retention_basis": "预计保存天数按录像空间 {{total}} 计算，不是物理硬盘容量",
    "cert": "证书到期",
    "cert_note_one": "已过期或 {{count}} 天内到期",
    "cert_note_other": "已过期或 {{count}} 天内到期",
    "cert_expired": "证书已过期（{{date}}）",
    "cert_soon": "证书 {{date}} 到期",
    "firmware": "固件合规",
    "firmware_note": "已是可用的最新版 / 全部",
    "fw_update": "有新固件（当前 {{v}}）",
    "seats": "云录席位",
    "seats_note": "已指派 / 生效中",
    "ai": "AI 额度（本月）",
    "backup": "备份覆盖",
    "backup_note": "正常 / 启用中的策略",
    "backup_degraded": "{{n}} 个策略落后或中断",
    "rec_gaps": "24 小时录像缺口",
    "rec_gaps_note": "有缺口 / 全时录像的摄像头",
    "rec_gap_item": "过去 24 小时有录像缺口",
    "attention": "需要注意",
    "not_enabled": "未启用",
    "setup": "设置",
    "unknown": "读不到",
    "unknown_n_one": "读不到（{{count}} 台没回报）",
    "unknown_n_other": "读不到（{{count}} 台没回报）",
    "dstate_normal": "正常",
    "dstate_ok": "正常",
    "dstate_degraded": "降级",
    "dstate_error": "错误",
    "dstate_failed": "故障",
    "dstate_missing": "找不到",
    "dstate_readonly": "只读",
    "dstate_full": "已满",
    "dstate_unformatted": "未格式化",
    "seats_home_plan_one": "另有 {{count}} 台由$t(leaf.cur)方案提供云录",
    "seats_home_plan_other": "另有 {{count}} 台由$t(leaf.cur)方案提供云录",
    "watch_playback": "看回放",
    "rec_gaps_off": "只检查全时云录的摄像头；目前没有",
    "space_unknown": "读不到容量",
    "usb_stick": "USB 闪存盘",
    "cap_used_total_free": "已用 {{used}} / 共 {{total}}（可用 {{free}}）",
    "cap_total": "共 {{total}}",
    "reason_other": "存储状态异常",
    "reason_sd_abnormal": "存储卡异常",
    "reason_sd_no_space": "存储卡已满，已停止录像",
    "reason_sd_needs_format": "存储卡需要格式化",
    "days_lt1": "不到 1 天（约 {{h}} 小时）",
    "retention_lt1": "预计可保存不到 1 天（约 {{h}} 小时）",
    "sd_looping": "共 {{total}} · 循环录像中",
    "sd_looping_note": "卡满后会自动覆盖最旧的录像，不会停止录像",
    "rec_gaps_off2": "目前没有全时云录或本地录像的摄像头",
    "rec_gaps_note2": "过去 24 小时 · 云端 {{cloud}} 台、本地 {{local}} 路",
    "gap_reason_source_unreachable": "收不到影像",
    "gap_reason_storage_full": "硬盘满了",
    "gap_reason_storage_error": "录像硬盘异常",
    "gap_reason_recorder_restart": "录像主机重启",
    "gap_reason_unknown": "原因不明",
    "rec_gaps_unreported_one": "另有 {{count}} 路本地录像没回报",
    "rec_gaps_unreported_other": "另有 {{count}} 路本地录像没回报"
  },
  "rpol": {
    "device_mode": "设备",
    "mode_continuous": "全时录像",
    "mode_event": "有动静才录",
    "mode_unknown": "未上报",
    "cloud": "云端录像",
    "cloud_on": "生效中（{{mode}}）",
    "cloud_off": "未生效",
    "retention": "云端保存",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "follows_plan": "按套餐 / 席位",
    "owner_only": "录像策略只有$t(leaf.cur)拥有者能改。",
    "mode_scheduled": "按排程",
    "mode_off": "不录像",
    "cloud_policy_note": "云端全时录像中，本机也全天录；关闭云录后回到此排程。",
    "cloud_mode": "云端什么时候录",
    "continuous_coming_soon": "全时录像即将开放",
    "err_FEATURE_DISABLED": "全时录像即将开放，目前只提供事件录像。",
    "capplied_applied": "设备已套用",
    "capplied_not_applied": "设备尚未套用",
    "capplied_unknown": "等待设备回报",
    "capplied_days_one": "（设备端保存 {{count}} 天）",
    "capplied_days_other": "（设备端保存 {{count}} 天）",
    "src_seat": "由「{{name}}」的云录席位提供",
    "src_seat_plain": "由云录席位提供",
    "src_home_plan": "由$t(leaf.cur)方案「{{plan}}」提供",
    "src_home_plan_plain": "由$t(leaf.cur)方案提供",
    "src_grant": "由合约「{{plan}}」提供",
    "src_grant_plain": "由合约提供",
    "src_until": "，到 {{date}}",
    "src_exempt": "未套用方案（开发环境豁免）",
    "src_none": "没有指派云录席位",
    "assign_seat": "指派席位",
    "cloud_on_exempt": "录像中（{{mode}}）· 未套用方案（开发环境豁免）",
    "cloud_on_plain": "生效中",
    "cloud_unsupported": "这台摄像头不支持云端录像（机型限制）",
    "reason_not_supported": "这台摄像头不支持云端录像（机型限制）",
    "reason_plan_no_cloud": "$t(leaf.cur)的方案不含云端录像",
    "reason_home_disabled": "这个$t(leaf.cur)的云端录像已暂停（请联系服务商）",
    "reason_disabled": "这台的云端录像已关闭",
    "reason_mode_not_in_plan": "选的录像方式不在方案内，改用事件录像",
    "reason_camera_limit": "方案的摄像头台数已满",
    "reason_continuous_paused": "全时录像即将开放，目前用事件录像",
    "reason_other": "云端录像目前没有生效",
    "col_where": "录到哪里",
    "col_when": "什么时候录",
    "where_sd": "存储卡",
    "where_recorder": "录像主机",
    "cloud_switch": "开启",
    "status_label": "状态：",
    "platform_state": "平台{{state}}"
  },
  "evd": {
    "open": "详情",
    "back": "返回事件",
    "time": "时间",
    "class": "分类",
    "device": "设备",
    "ai": "AI 分析",
    "phase_started": "开始",
    "phase_ended": "结束",
    "phase_instant": "单次",
    "fields": "原始字段",
    "clip": "前后片段",
    "no_cloud_clip": "这段时间没有云端片段；可到回放页看设备本地录像。",
    "open_playback": "在回放页打开",
    "related": "关联摄像头（同一时刻）",
    "cycle": "这次事件的开始与结束",
    "not_found": "这则事件找不到了：可能超过保存期限或已删除。",
    "back_list": "回事件列表",
    "looking": "正在读取这则事件…",
    "cycle_dur": "这次{{name}}持续 {{dur}}",
    "cycle_open": "这次{{name}}还没有结束（或结束的记录还没进来）",
    "cycle_no_end": "还没结束",
    "cycle_this": "这一条",
    "dur_s": "{{s}} 秒",
    "dur_ms": "{{m}} 分 {{s}} 秒",
    "dur_hm": "{{h}} 小时 {{m}} 分",
    "clip_suspect": "这段云端片段可能不完整（片段长度跟事件对不上），画面可能是绿色或停住；只播事件前后 30 秒。可以在回放页改看其他来源。",
    "clip_suspect_local": "改看{{src}}",
    "cycle_no_end_record": "没有收到这次{{name}}的结束记录（开始后超过 10 分钟），持续多久不知道",
    "cycle_end_only": "这是{{name}}的结束记录；开始的记录不在前后 15 分钟内",
    "cycle_open_start": "看开始那笔 ▸",
    "clip_checking": "正在查这段时间有没有云端片段…",
    "clip_unreadable": "读不到这段片段。",
    "dur_lt1": "不到 1 秒"
  },
  "unbind": {
    "title": "解除绑定",
    "explain": "把这台设备从$t(leaf.cur)移除。",
    "reset": "设备会收到重置指令，回到可重新配对的状态（离线时下次连线才会重置）。",
    "history": "历史录像与事件留在原$t(leaf.cur)，不会跟着设备走。",
    "children_one": "下面 {{count}} 个通道 / 子设备一起移除。",
    "children_other": "下面 {{count}} 个通道 / 子设备一起移除。",
    "button": "解除绑定",
    "confirm": "确定要解除绑定「{{name}}」？请输入设备 ID 最后 4 位「{{code}}」确认。",
    "type_code": "设备 ID 最后 4 位"
  },
  "pair": {
    "open": "添加设备",
    "title": "添加 Kinio 设备",
    "no_home": "你没有可以添加设备的$t(leaf.cur)（需要拥有者或管理员）。",
    "method": "配对方式",
    "method_lan": "有线（输入配对码）：NVR、Kinio Station、AI box 在本机界面输入配对码",
    "method_qr": "扫 QR：让摄像头镜头扫这个页面上的 Wi-Fi 与配对码",
    "method_app": "蓝牙或设备热点（用手机 App）：App 扫这个 QR 后再扫设备标签",
    "aid_hint": "在设备底部标签或 NVR 本机界面的“设备信息”，格式 CNV-XXXXXXXXXXXXXXXX-X",
    "err_BAD_DEVICE_REF": "设备 ID 格式不对",
    "err_MODEL_NOT_AVAILABLE_FOR_BRAND": "此品牌目前不提供 Kinio Station / Kinio Node",
    "start": "生成配对码",
    "bound": "{{aid}} 已加入$t(leaf.cur)。",
    "open_device": "打开设备",
    "status_failed": "配对失败",
    "status_canceled": "已取消",
    "status_expired": "配对码已过期",
    "status_pending": "等待设备兑换",
    "status_connected": "设备已连上，正在完成绑定",
    "again": "重新配对",
    "enter_on_device": "在设备本机的「云端配对」界面输入以下配对码：",
    "code": "配对码",
    "url": "兑换地址",
    "expires_in": "{{m}}:{{s}} 后过期",
    "cancel": "取消配对",
    "method_app_unavailable": "（这个品牌没有 App 门户网站，无法生成 App 链接）",
    "wifi_ssid": "Wi-Fi 名称",
    "wifi_psk": "Wi-Fi 密码（开放网络留空）",
    "wifi_note": "Wi-Fi 密码只放进这个页面上的 QR，不会发送到云端或被保存。",
    "err_SSID_REQUIRED": "请输入 Wi-Fi 名称",
    "err_SSID_TOO_LONG": "Wi-Fi 名称超过 32 字节",
    "err_PSK_LENGTH": "Wi-Fi 密码要 8–63 个字符（或 64 位十六进制）",
    "err_BAD_SESSION": "配对数据不完整，请重新配对",
    "show_qr": "显示 QR",
    "show_qr_again": "再显示 QR",
    "hide_qr": "隐藏 QR",
    "qr_hidden": "QR 已隐藏（显示 5 分钟后自动隐藏）。",
    "qr_auto_hide": "{{m}}:{{s}} 后自动隐藏",
    "scan_with_camera": "让摄像头处于配对状态，把 QR 对着镜头（约 20–40 厘米），听到提示音后等它连接。",
    "scan_with_app": "用手机 App 的「添加设备」扫这个 QR，再按提示扫设备标签。App 不必是这个$t(leaf.cur)的成员。",
    "qr_alt_kwf": "给摄像头扫的 Wi-Fi 与配对码 QR",
    "qr_alt_app": "交给 App 的配对链接 QR",
    "kind_camera": "摄像头",
    "kind_doorbell": "门铃",
    "kind_nvr": "NVR",
    "kind_station": "Station",
    "kind_sensor": "传感器",
    "kind_light": "灯",
    "kind_lock": "门锁",
    "kind_plug": "插座",
    "kind_frame": "相框",
    "kind_other": "设备",
    "bound_name_title": "已加入$t(leaf.cur)。给这台设备取个名字",
    "name_label": "设备名称",
    "name_hint": "推送、App 与 VMS 都会显示这个名字（1–32 字）。跳过就用预填的名字。",
    "err_INVALID_NAME": "名称要 1–32 字、不能有控制字符",
    "name_failed": "名称没有保存成功，请再试一次",
    "name_forbidden": "你不能改这台设备的名字（需要$t(leaf.cur)拥有者或管理员），之后可以请他们改。",
    "name_skip": "跳过",
    "name_save": "保存名称",
    "aid_label": "设备编号",
    "aid_demo_title": "标签上的“设备编号”"
  },
  "layouts": {
    "pick": "布局…",
    "save": "保存布局",
    "save_as": "另存布局",
    "delete": "删除布局",
    "delete_confirm": "删除布局「{{name}}」？",
    "name": "名称",
    "scope": "谁能看到",
    "scope_user": "只有我",
    "scope_org": "组织共享：{{org}}",
    "denied_dropped": "没有权限的格子不会存进新布局。",
    "no_permission": "无权限",
    "err_CELL_FORBIDDEN": "有格子是你没有观看权限的摄像头",
    "err_VERSION_CONFLICT": "布局已被别人修改，请重新加载",
    "none": "还没有保存过布局",
    "manage": "管理版面…"
  },
  "bm": {
    "add": "书签",
    "need_time": "先播放或选一个时间点",
    "title": "标题",
    "note": "备注",
    "length": "长度",
    "len_s": "{{n}} 秒",
    "len_point": "时间点",
    "visibility": "谁能看到",
    "vis_private": "只有我",
    "vis_home": "$t(leaf.cur)成员",
    "list": "书签"
  },
  "subg": {
    "panel_hint": "已加入 {{n}} 台（上限 {{max}}）。贴 QR 的子设备要扫 QR 才能加入。",
    "region": "地区 {{r}}",
    "add": "加入子设备",
    "need_admin": "加入子设备需要$t(leaf.cur)所有者或管理员。",
    "none": "还没有子设备。",
    "col_slot": "槽位",
    "col_mode": "加入方式",
    "mode_qr": "QR 白名单",
    "mode_permit": "限时开放（未认证）",
    "title": "加入子设备",
    "method": "加入方式",
    "method_scan": "用摄影机扫子设备上的 QR",
    "method_manual": "手动输入（QR 内容或 EUI + 安装码）",
    "method_permit": "不需 QR 的子设备：限时开放加入",
    "qr_text": "QR 内容",
    "or_fields": "或输入标签上的 EUI 与安装码：",
    "is_code": "安装码（IS）",
    "is_hint": "26 位字母数字（A–Z、2–7），标签上 QR 旁边印的那一串。",
    "smartstart": "SmartStart：子设备上电就自动加入（窗口 24 小时）",
    "permit_explain": "网关会开放 120 秒，期间按下子设备的配对键。只给不需要 QR 的子设备；贴 QR 的子设备请扫 QR。",
    "permit_warn": "这条路没有安装码认证，只挡被动窃听、挡不了主动冒充。",
    "start": "开始加入",
    "permit_start": "开放 120 秒",
    "wait_qr": "网关已把 {{eui}} 加入白名单。请长按子设备的按键 5 秒（或装上电池）。",
    "wait_qr_smart": "网关已把 {{eui}} 加入白名单（SmartStart）。子设备上电就会自动加入。",
    "wait_permit": "网关正在开放加入。请按下不需 QR 的子设备的配对键。",
    "left": "剩 {{m}}:{{s}}",
    "closed_found": "加入窗口已关闭，这次加入了 {{n}} 台。",
    "closed_none": "加入窗口已关闭，没有子设备加入。确认子设备在网关附近、已长按 5 秒，再试一次。",
    "stop": "停止加入",
    "again": "再加一台",
    "joined": "新子设备：CH{{slot}}",
    "name_for": "CH{{slot}} 的名称",
    "location": "位置（场所）",
    "location_keep": "（不指定）",
    "location_personal": "这个$t(leaf.cur)的组织只有一个场所，不用指定位置；可以在地图页摆放。",
    "to_map": "前往地图",
    "saved": "已保存「{{name}}」",
    "scan_unsupported": "这个浏览器不支持摄影机扫描（需要 Chrome / Edge），请改用手动输入。",
    "scan_denied": "无法使用摄影机（没有权限或没有摄影机），请改用手动输入。",
    "scan_hint": "把子设备上的 QR 对准镜头。",
    "scan_start": "打开摄影机",
    "err_other": "加入失败（{{code}}）",
    "err_qr_not_subg": "这不是 Kinio 子设备的 QR（要 KSG:1 开头）。",
    "err_qr_version": "不支持这个版本的 QR。",
    "err_qr_format": "QR 内容格式不对。",
    "err_qr_eui": "EUI 要 16 个十六进制字符。",
    "err_qr_is": "安装码不对（26 位，A–Z 与 2–7）。",
    "err_INVALID_QR": "QR 内容或安装码不对。",
    "err_QR_DEVICE_NOT_ALLOWED": "贴 QR 的子设备不能用限时开放加入，请扫 QR。",
    "err_CAPABILITY_NOT_SUPPORTED": "这台设备不能加入子设备。",
    "err_GATEWAY_OFFLINE": "网关不在线。",
    "err_GATEWAY_TIMEOUT": "网关没有响应。",
    "err_GATEWAY_ERROR": "网关拒绝了（允许列表满了或正在忙），稍后再试。",
    "err_FORBIDDEN": "没有权限。",
    "err_INVALID_NAME": "名称要 1–64 字。",
    "remove": "移除",
    "removing": "移除中（等网关确认）",
    "remove_confirm": "要移除「{{name}}」吗？子设备下次上报时会解除配对，之后要重新扫 QR 才能再加入。"
  },
  "inbox": {
    "title": "通知",
    "title_n": "通知（未读 {{n}}）",
    "mark_all": "全部标为已读",
    "mark_read": "标为已读",
    "empty": "没有通知",
    "failed": "通知收件箱暂时读不到",
    "mfa_alarm_title": "{{from}}有一则警报",
    "mfa_alarm_body": "开启两步验证并重新登录后才能查看内容。",
    "mfa_alarm_back": "我已设置，回到这则警报",
    "mfa_alarm_someone": "委派方",
    "alarm_title": "警报 · {{name}}",
    "untitled": "通知",
    "view": "查看",
    "open": "打开",
    "dismiss_tip": "关闭（不标为已读）",
    "more_n_one": "还有 {{count}} 条通知",
    "more_n_other": "还有 {{count}} 条通知",
    "bell_tip": "未读通知 {{n}} 条（跟菜单“事件与警报”旁的未处理警报数不同）",
    "times_n": "× {{n}} 次（最早 {{since}}）",
    "times_only": "× {{n}} 次",
    "empty_alarms": "没有新通知；还有 {{count}} 则警报没处理。",
    "go_alarms": "去处理"
  },
  "devpolicy": {
    "title": "MyCam 设备与 AI 策略",
    "hint": "应用到这个组织所有场所的手机摄像头与电脑端。每一项改了就保存（需要重新验证）。",
    "k_soft_device_require_attestation": "只收通过完整性检查（verified）的设备",
    "k_soft_device_lock_settings": "锁定设置（手机用户不能改被锁定的设置）",
    "k_soft_device_allow_audio_record": "允许录音",
    "k_ai_byo_cloud_allowed": "允许自带云端 AI",
    "k_soft_device_allow_personal_account": "允许个人账号加入设备",
    "by_platform": "平台在启用时检查",
    "by_app": "由 MyCam App 执行",
    "by_pending": "成员能不能把个人手机当这个组织的 MyCam 设备，怎么判断尚未决定，暂不能改"
  },
  "dhealth": {
    "cert": "证书到期",
    "cert_expired": "已过期",
    "cert_soon": "30 天内到期",
    "wifi": "Wi-Fi 信号",
    "temperature": "机体温度",
    "mac": "MAC 地址",
    "netifs": "网络接口",
    "if_name": "接口",
    "if_kind": "类型",
    "if_kind_wifi": "Wi-Fi",
    "if_kind_wired": "有线",
    "if_kind_cellular": "移动网络",
    "if_up": "连接",
    "if_up_yes": "已连接",
    "if_up_no": "未连接"
  },
  "tour": {
    "open": "轮巡",
    "title": "轮巡设置",
    "interval": "每页停留",
    "seconds": "{{n}} 秒",
    "mode": "轮巡内容",
    "mode_cameras": "摄像头清单",
    "mode_layouts": "布局",
    "cameras_hint": "按当前 {{size}} 格分页，共 {{pages}} 页",
    "no_layouts": "还没有保存过布局",
    "start": "开始轮巡",
    "running": "轮巡中：第 {{i}} / {{n}} 页",
    "next_in": "{{s}} 秒后换页",
    "pause": "暂停",
    "resume": "继续",
    "stop": "停止"
  },
  "nset": {
    "global_title": "通知（我的）",
    "home_title": "$t(leaf.cur)的通知",
    "home": "$t(leaf.cur)",
    "no_home": "没有可以设置通知的$t(leaf.cur)",
    "unavailable": "通知设置暂时读不到",
    "quiet": "勿扰时段",
    "quiet_start": "开始",
    "quiet_end": "结束",
    "quiet_clear": "取消勿扰",
    "quiet_hint": "时区 {{tz}}；勿扰时只进收件箱，警报照发",
    "email_alerts": "事件通知也发 email",
    "hide_details": "锁屏隐藏细节",
    "thumbnails": "通知附缩略图",
    "category": "类别",
    "ch_inbox": "收件箱",
    "ch_push": "App 推送",
    "ch_email": "Email",
    "forced": "不可关闭",
    "per_device": "个别摄像头的侦测通知",
    "follow_home": "跟$t(leaf.cur)设置",
    "cat": {
      "security_alarm": "警报（布防中）",
      "device_detection": "侦测（人、车、动作…）",
      "device_doorbell": "门铃",
      "device_call": "设备呼叫",
      "device_status": "设备状态（离线、存储、录像中断、备份）",
      "device_ota": "固件更新",
      "security_mode": "布撤防变更",
      "home_access": "$t(leaf.cur)成员与绑定",
      "account_security": "账号安全",
      "billing_subscription": "订阅与付款",
      "support_reply": "客服回复",
      "care_service": "关怀提醒",
      "andrew_insight": "AI 管家的提醒与建议",
      "automation_notify": "自动化规则",
      "hw_review": "硬件审核",
      "org_notice": "组织公告",
      "account_privacy": "隐私与数据请求",
      "sleep_report_ready": "睡眠报告"
    },
    "ai_confirmed_only": "只通知云端 AI 确认的侦测（该摄像头有开云端 AI 时；60 秒没结果照常发）",
    "cat_other": "其他通知",
    "part_local": "浮动通知与弹窗（这台电脑）",
    "part_receive": "我要收哪些通知",
    "part_subs": "订阅的场所与群组",
    "float_intro": "右下角的浮动通知：警报一律用警报卡（先显示快照、可直接处理，按〔看实时〕才开影像）；其他通知照下面的档位弹出。同一则只弹一次，20 秒没动就收成一条细条。"
  },
  "rules": {
    "no_home": "没有可以设置规则的$t(leaf.cur)",
    "home": "$t(leaf.cur)",
    "unavailable": "规则暂时读不到",
    "from_template": "从模板建立",
    "new_json": "高级：用 JSON 编辑",
    "enabled": "启用",
    "kind_automation": "自动化",
    "kind_scene": "场景",
    "placement_cloud": "云端执行",
    "placement_local": "本地执行",
    "pending_sync": "设备还没同步",
    "never": "还没执行过",
    "result_ok": "上次成功",
    "result_failed": "上次失败",
    "result_skipped": "上次跳过",
    "fires": "共 {{n}} 次",
    "run": "执行",
    "runs": "执行记录",
    "edit": "编辑",
    "delete": "删除",
    "delete_confirm": "删除规则「{{name}}」？",
    "last_error": "第 {{n}} 个动作失败：{{reason}}",
    "runs_local": "本地执行的规则记录在设备上，这里只显示上次结果",
    "run_time": "时间",
    "run_trigger": "触发",
    "run_status": "结果",
    "run_error": "失败原因",
    "trigger_manual": "手动",
    "run_error_at": "第 {{n}} 个动作：{{reason}}",
    "runs_empty": "7 天内没有执行",
    "status_pending": "等待中",
    "status_running": "执行中",
    "status_done": "完成",
    "status_failed": "失败",
    "status_canceled": "取消",
    "reason_device_offline": "设备离线",
    "reason_running": "前一次还在跑",
    "reason_forbidden": "权限不足",
    "template": "模板",
    "tpl_door_record_notify": "门磁开 → 录像 + 通知",
    "tpl_door_record_notify_text": "门被打开了",
    "tpl_door_record_notify_hint": "门窗传感器打开时，关联摄像头开始录像并发通知（弹窗在设备「关联」设置）",
    "tpl_armed_pir_siren": "布防中 PIR → 警报器 + 通知",
    "tpl_armed_pir_siren_text": "布防中侦测到有人",
    "tpl_armed_pir_siren_hint": "外出 / 夜间布防时 PIR 触发：警报器响并发通知",
    "tpl_ai_person_notify": "AI 侦测到人 → 通知",
    "tpl_ai_person_notify_text": "侦测到人",
    "tpl_ai_person_notify_hint": "摄像头的 AI 侦测到人时发通知",
    "role_sensor": "传感器",
    "role_camera": "摄像头",
    "role_siren": "警报器",
    "optional": "（可不选）",
    "pick": "请选择",
    "none_capable": "这个$t(leaf.cur)没有符合的设备",
    "name": "名称",
    "notify_text": "通知内容",
    "notify_off": "这个环境不提供规则通知，模板只会建立设备动作",
    "create": "建立",
    "edit_title": "编辑「{{name}}」",
    "json_hint": "规则分三段：触发（triggers）、条件（conditions）、动作（actions）。保存前会先检查格式；规则在设备上还是云端执行由系统决定。",
    "json": "规则 JSON",
    "bad_json": "JSON 格式不对",
    "valid": "验证通过：{{placement}}",
    "validate": "验证",
    "err_RULE_INVALID": "规则不合法，请看问题清单",
    "err_RULE_RUNNING": "前一次还在跑",
    "err_RULE_DISABLED": "规则已停用",
    "err_VERSION_CONFLICT": "别人刚改过，请重新打开",
    "handoff_old_device": "原执行设备",
    "handoff_pending": "交接中：{{from}} 上线后停用旧设置，之后才由 {{to}} 执行",
    "handoff_disabled": "已停用（{{from}} 离线，上线后生效）",
    "handoff_deleting": "删除中（{{from}} 上线后停止）",
    "shared_devices_note": "分享给你的设备不能用在自动化",
    "err_RULE_HANDOFF_PENDING": "规则交接中，旧的执行设备上线停用旧设置后才能执行",
    "handoff_cloud": "云端",
    "more": "更多规则操作",
    "empty_intro": "还没有规则。规则让设备自己反应：门被打开就录像并通知你、布防时有人就响警报器。从下面的模板开始：",
    "use_template": "用这个模板",
    "tpl_door_record_notify_needs": "这个模板需要门磁传感器，这个$t(leaf.cur)还没有",
    "tpl_armed_pir_siren_needs": "这个模板需要人体传感器（PIR），这个$t(leaf.cur)还没有",
    "tpl_ai_person_notify_needs": "这个模板需要有人形侦测的摄像头，这个$t(leaf.cur)还没有",
    "reason_other": "系统没有说明原因",
    "tpl_cannot_create": "{{what}}，所以还不能创建。先在「设备」加入需要的设备，或换一个模板。",
    "tpl_pick_first": "先选{{what}}"
  },
  "armed": {
    "label": "布防模式",
    "home": "在家",
    "night": "夜间",
    "away": "外出",
    "unsynced_one": "{{count}} 台设备还没同步（上线后补推）",
    "unsynced_other": "{{count}} 台设备还没同步（上线后补推）"
  },
  "dctl": {
    "siren_on": "🔔 响警报器",
    "siren_off": "停止警报",
    "light_on": "💡 开补光灯",
    "light_off": "关补光灯",
    "reboot": "重启",
    "reboot_confirm": "重启「{{name}}」？期间会断线一两分钟。",
    "sent": "已发出",
    "err_FORBIDDEN": "没有权限",
    "err_DEVICE_OFFLINE": "设备离线",
    "err_DEVICE_WAKING": "设备正在唤醒，请稍后再试",
    "err_DEVICE_ASLEEP": "设备正在休眠",
    "err_COMMAND_TIMEOUT": "设备没有在时间内响应",
    "err_RENEW_ONLY": "设备证书已过期，只能换证",
    "siren_confirm": "让 {{name}} 的警报器响 30 秒？",
    "siren_confirm_body": "现场会发出警报声；要提早停可以按〔停止警报〕。",
    "siren_action": "响警报器",
    "more": "更多"
  },
  "alarm": {
    "section": "警报处理",
    "state_open": "未处理",
    "state_acknowledged": "已看到",
    "state_claimed": "处理中",
    "state_resolved": "已处理",
    "state_false_alarm": "误报",
    "act_acknowledged": "已看到",
    "act_claimed": "我来处理",
    "act_take_over": "我来接手",
    "act_resolved": "已处理",
    "act_false_alarm": "误报",
    "act_open": "重开",
    "claimed_by": "{{name}} 处理中",
    "claimed_by_me": "你处理中",
    "someone": "有人",
    "note_btn": "备注",
    "note_label": "备注",
    "note_placeholder": "备注（一行，最多 {{max}} 字）",
    "note_invalid": "备注只能一行、最多 {{max}} 字",
    "last_note": "备注：{{note}}",
    "conflict": "已被 {{name}} 处理，画面已更新",
    "conflict_anon": "已被别人处理，画面已更新",
    "failed": "更新失败：{{msg}}",
    "history": "处理记录",
    "history_empty": "还没有人处理",
    "read_only": "你只能查看，不能改处理状态",
    "unhandled_n": "{{n}} 条未处理的警报",
    "handle_menu": "处理",
    "note_add": "加备注",
    "also_done": "这一波 {{n}} 条一起处理了",
    "more_actions": "其他处理（误报、备注）",
    "unhandled_counting": "正在计算还没处理的警报",
    "age_just_now": "刚发生",
    "age_min_one": "已开 {{count}} 分钟",
    "age_min_other": "已开 {{count}} 分钟",
    "age_hour_one": "已开 {{count}} 小时",
    "age_hour_other": "已开 {{count}} 小时",
    "age_day_one": "已开 {{count}} 天",
    "age_day_other": "已开 {{count}} 天",
    "recovered_dur": "↺ 已恢复 {{at}}（中断了 {{dur}}）",
    "act_resolve_recovered": "已恢复，结案",
    "resolve_recovered_tip": "状况已经解除，标成“已处理”",
    "recovered_lt1": "↺ 已恢复 {{at}}（中断不到 1 秒）"
  },
  "popup": {
    "title": "警报弹窗",
    "help": "事件发生时自动把画面带出来。这是这台电脑（浏览器）的设置，不跟账号走。",
    "sensor": "传感器触发",
    "sensor_help": "门磁 / PIR 触发时带出关联的摄像头（在设备页设置关联）",
    "alarm": "警报",
    "alarm_help": "烟雾、拆除，或布防中设置了警报的检测 → 带出来源摄像头",
    "detection": "AI 检测",
    "detection_help": "人、车等一般检测也带出来源摄像头（事件多的场所会很频繁）",
    "target": "带到哪里",
    "target_float": "右下角浮窗",
    "target_cell": "视频墙的指定格位",
    "cell": "第几格",
    "cell_help": "人在视频墙时，来源摄像头会换到这一格（已经在墙上就跟那一格交换）；不在视频墙时用浮窗。"
  },
  "sync": {
    "title": "多路同步回放",
    "open": "多路同步",
    "help": "最多 {{max}} 路，用同一个时间对齐播放：有云端录像的播云端，没有的播本地录像（NVR / Station 硬盘、SD 卡）；某一路那个时间没有录像会显示空档。",
    "cameras": "摄像头（{{n}} / {{max}}）",
    "load": "加载",
    "play": "播放",
    "pause": "暂停",
    "speed": "速度",
    "position": "时间位置",
    "gap": "这个时间没有云端录像",
    "end": "这个时间之后没有云端片段（云端只存事件片段）",
    "no_cloud_scope": "这个范围的摄像头最近两个月都没有云端录像，也没有本地录像（NVR / Station 硬盘、SD 卡），多路同步没有可播的录像。",
    "no_cloud_cam": "这台没有云端录像，也没有本地录像（硬盘 / SD 卡）",
    "aligned": "{{at}} 这几路都还没有录像，从最早有录像的 {{from}} 开始。",
    "no_cloud_legend": "带锁头的摄像头最近两个月没有云端录像（不支持云端录像，或没有云录席位 / 方案），也没有本地录像（NVR / Station 硬盘、SD 卡）。",
    "skip_to": "跳到 {{time}}",
    "jump_all": "同步回放用同一个时间：全部画面一起移到那个时间",
    "jumped": "已把全部画面移到 {{name}} 的下一段（{{at}}）。",
    "none_later": "之后 {{h}} 小时内都没有云端片段",
    "event_only": "只存事件片段",
    "event_only_hint": "这台的云端只存事件片段，多路同步里大部分时间会是空格（可以用〔跳过去〕到下一段）",
    "clip_suspect": "⚠ 这段云端片段可能不完整，画面可能是绿色或卡住",
    "open_single": "用单路看其他来源",
    "gap_next": "这个时间没有云端录像（下一段 {{time}}）",
    "src_cloud": "云端",
    "src_nvr": "硬盘",
    "src_sd": "SD 卡",
    "gap_local": "这个时间没有本地录像",
    "gap_next_local": "这个时间没有本地录像（下一段 {{time}}）",
    "end_local": "这个时间之后没有本地录像"
  },
  "chcopy": {
    "title": "复制设置到其他通道",
    "help": "把一路的设置写到其他通道，再逐路回读确认。只复制两边都有、而且你有权限改的项目；日程、检测区这类自定义编辑器与指令不在内。",
    "source": "来源通道",
    "targets": "目标通道",
    "all": "全选其他通道",
    "compare": "比对",
    "items": "要复制的项目",
    "nothing": "来源通道没有可以复制的设置",
    "col_channel": "通道",
    "col_diff": "不同的项目",
    "col_result": "结果",
    "diff_n": "{{n}} 项",
    "copy": "复制",
    "retry": "重试失败的（{{n}}）",
    "same": "已经一样",
    "applied_n": "已应用 {{n}} 项",
    "not_applied": "没有应用：{{list}}"
  },
  "aiset": {
    "open": "设置",
    "title": "AI 设置：{{name}}",
    "zone_help": "在画面上点出检测区域（最多 {{max}} 点，拖动顶点可调整）；不画 = 整个画面。",
    "line_help": "在画面上点两下拉出越线（A → B）。",
    "zone_points": "区域 {{n}} 点",
    "zone_full": "整个画面",
    "undo": "退回一点",
    "clear": "清除",
    "line_first": "点画面设置起点 A",
    "line_second": "再点一下设置终点 B",
    "line_set": "越线已设置（再点画面可重画）",
    "direction": "方向",
    "dir_both": "双向",
    "dir_a_to_b": "A 的左侧 → 右侧",
    "dir_b_to_a": "A 的右侧 → 左侧",
    "schedule": "日程",
    "always": "全天",
    "start": "开始",
    "end": "结束",
    "schedule_help": "设备当地时间；结束早于开始 = 跨午夜",
    "day_0": "日",
    "day_1": "一",
    "day_2": "二",
    "day_3": "三",
    "day_4": "四",
    "day_5": "五",
    "day_6": "六",
    "err_sensitivity": "灵敏度要在 10–100",
    "err_zone_points": "区域要 3–16 个点",
    "err_line_required": "这个模型要先画越线",
    "err_line_short": "越线太短",
    "err_schedule_days": "日程至少选一天",
    "err_schedule_time": "日程时间不对（开始与结束不能一样）"
  },
  "diag": {
    "title": "远程诊断授权",
    "help": "客服要对这台设备做只读远程检测（状态、设置摘要、最近的设备记录）时，需要所有者或管理员同意；同意有时限，可随时撤回。原始日志不提供下载。",
    "none": "目前没有诊断请求",
    "st_requested": "等待同意",
    "st_granted": "已同意",
    "st_denied": "已拒绝",
    "st_revoked": "已撤回",
    "st_expired": "已过期",
    "by_brand": "{{brand}} 客服",
    "until": "到 {{at}}",
    "runs": "已检测 {{n}} 次",
    "minutes": "同意多久",
    "approve": "同意",
    "deny": "拒绝",
    "revoke": "撤回"
  },
  "batch": {
    "open": "批量操作（{{n}}）",
    "title_one": "批量操作：{{count}} 台",
    "title_other": "批量操作：{{count}} 台",
    "pick": "选取 {{name}}",
    "pick_all": "全选",
    "mode_rename": "改名",
    "mode_firmware": "更新固件",
    "rule": "命名规则",
    "start": "序号起点",
    "rule_help": "{name} = 原本的名称、{n} = 序号、{n:02} = 补零到 2 位。例：1F-{n:02} {name}",
    "fw_help_one": "对 {{count}} 台设备本体检查并开始固件更新（通道跟着它的 NVR）；没有可用更新的会跳过，需要所有者权限。",
    "fw_help_other": "对 {{count}} 台设备本体检查并开始固件更新（通道跟着它的 NVR）；没有可用更新的会跳过，需要所有者权限。",
    "fw_confirm_one": "要对 {{count}} 台设备开始固件更新吗？更新期间设备会短暂离线。",
    "fw_confirm_other": "要对 {{count}} 台设备开始固件更新吗？更新期间设备会短暂离线。",
    "col_new": "新名称",
    "col_result": "结果",
    "run": "开始（{{n}} 台）",
    "same": "名称没变",
    "st_pending": "等待中",
    "st_running": "进行中…",
    "summary": "成功 {{ok}}、跳过 {{skipped}}、失败 {{failed}}、还没做 {{left}}",
    "err_BAD_NAME": "名称不合规（空的或超过 64 字）",
    "err_FORBIDDEN": "没有权限",
    "mode_settings": "套用设置",
    "settings_source": "以这台为模板",
    "settings_help": "把模板那台的设置写到其他选取的同型号设备，再逐台回读确认。只复制两边都有、而且你有权限改的项目；排程、侦测区这类自定义编辑器与指令不在内。型号不同的会跳过。",
    "settings_confirm_one": "要把“{{name}}”的设置套到 {{count}} 台设备吗？码流类设置会影响既有的录像与观看。",
    "settings_confirm_other": "要把“{{name}}”的设置套到 {{count}} 台设备吗？码流类设置会影响既有的录像与观看。",
    "skip_model": "型号不同",
    "skip_same": "设置相同",
    "mode_location": "指派位置",
    "loc_site": "位置",
    "loc_pick": "选择场所…",
    "loc_help": "把选取的设备 / 通道指派到这个场所（要在$t(leaf.cur)的场所锚点之下）。同一个$t(leaf.cur)的设备一次送出：有一台不行，这个$t(leaf.cur)整批都不改。",
    "loc_need_org": "指派位置只用在同一个团体组织的$t(leaf.cur)设备，而且你要能管理那些设备。",
    "err_BATCH_REJECTED": "同一批有一台不行，整批没改",
    "err_VERSION_CONFLICT": "位置刚被别人改过，重新整理后再试",
    "err_OUT_OF_ANCHOR": "这个场所不在$t(leaf.cur)的锚点之下",
    "err_BAD_TARGET": "设备不在这个$t(leaf.cur)",
    "no_manage": "你不能管理这台（只有$t(leaf.cur)拥有者或管理员可以；分享来的设备不能管理）",
    "no_maintain": "你不能维护这台（要$t(leaf.cur)拥有者 / 管理员，或节点管理员 / 运维员；分享来的设备不行）",
    "denied": "没有权限，不执行：{{why}}",
    "denied_n_one": "{{count}} 台没有权限，不会执行。",
    "denied_n_other": "{{count}} 台没有权限，不会执行。",
    "mode_reboot": "重新启动",
    "reboot_help": "对 {{n}} 台有连接的设备本体下重新启动；服务器逐台确认权限，没权限的列出原因、不影响其他台。",
    "reboot_confirm_one": "重新启动 {{count}} 台设备？重启期间会中断录像与实时视频。",
    "reboot_confirm_other": "重新启动 {{count}} 台设备？重启期间会中断录像与实时视频。",
    "picked_one": "已选 {{count}} 台",
    "picked_other": "已选 {{count}} 台",
    "clear": "取消选择"
  },
  "fwm": {
    "open": "固件管理",
    "title": "固件管理",
    "back": "返回设备",
    "help": "每台设备的固件版本与更新排程。开启自动更新的设备，会在它的维护时段（设备当地时间）内安装新版；推送哪一版、分批与暂停由平台的发布设置决定。只有所有者能改设置。",
    "st_latest": "已是最新",
    "st_available": "有新版",
    "st_updating": "更新中",
    "st_unknown": "读不到",
    "count_one": "{{count}} 台设备",
    "count_other": "{{count}} 台设备",
    "empty": "这个范围里没有可管理固件的设备。",
    "home_failed": "{{home}} 的固件状态读不到",
    "col_model": "机型",
    "col_state": "状态",
    "col_window": "维护时段",
    "updating": "更新到 {{v}}（{{p}}%）",
    "available": "可更新到 {{v}}",
    "critical": "重大更新",
    "auto_of": "{{name}} 的自动更新",
    "window_of": "{{name}} 的维护时段",
    "saved": "已保存",
    "batch_schedule": "套用排程（{{n}}）",
    "batch_update": "立即更新（{{n}}）",
    "batch_schedule_help": "把自动更新与维护时段写到选取的设备。维护时段格式 HH:MM-HH:MM（可跨午夜）；留空 = 不改。",
    "batch_update_help": "对选取的设备开始更新；没有新版或正在更新的会跳过。更新期间设备会短暂离线。",
    "keep": "不改",
    "skip_updating": "正在更新",
    "retry": "重试失败的（{{n}}）",
    "err_FORBIDDEN": "没有权限（需要所有者）",
    "err_FIRMWARE_NOT_CONFIGURED": "这个环境没有开启固件服务",
    "err_daily_cap": "今天的更新数量已达上限，明天再试",
    "err_offline": "设备离线",
    "report": "更新报表",
    "period": "期间",
    "period_1": "最近 24 小时",
    "period_7": "最近 7 天",
    "period_30": "最近 30 天",
    "report_build": "生成报表",
    "report_csv": "下载 CSV",
    "report_summary": "最近 {{days}} 天：成功 {{success}}、失败 {{failed}}、其他 {{other}}",
    "report_unread_one": "（{{count}} 台的历史读不到）",
    "report_unread_other": "（{{count}} 台的历史读不到）",
    "report_empty": "这段期间没有更新记录。",
    "csv_at": "时间",
    "csv_home": "场所",
    "csv_device": "设备",
    "csv_aid": "设备 ID",
    "csv_from": "原版本",
    "csv_to": "版本",
    "csv_status": "结果",
    "csv_reason": "原因",
    "csv_trigger": "触发",
    "csv_finished": "完成时间",
    "job_success": "成功",
    "job_failed": "失败",
    "job_rolled_back": "已回滚",
    "job_deferred": "延后",
    "job_canceled": "已取消",
    "job_pending": "等待中",
    "job_sent": "已发出",
    "job_accepted": "设备已接受",
    "job_downloading": "下载中",
    "job_installing": "安装中",
    "job_rebooting": "重启中",
    "trigger_auto": "排程（自动更新）",
    "trigger_user_now": "立即更新",
    "trigger_admin_push": "管理员推送",
    "trigger_legacy_check": "设备检查更新",
    "trigger_dev_pin": "开发指定",
    "reason_timeout": "超时",
    "reason_download_failed": "下载失败",
    "reason_verify_failed": "校验失败",
    "reason_suspected_brick": "安装后没有上报",
    "reason_outside_window": "不在维护时段",
    "reason_battery_low": "电量不足",
    "reason_busy": "设备忙碌中",
    "st_unknown_offline": "读不到（离线）",
    "only_outdated": "只看有新版的",
    "how_saved": "「自动更新」一切换就保存；「维护时段」改完按〔保存〕或 Enter。设备在维护时段内才会自己更新；要马上更新请勾选后按〔立即更新〕。"
  },
  "chmx": {
    "title": "比较各通道设置",
    "help": "每一路的设置并排比较，跟多数通道不同的格子会标出来。能改的格子可以直接改（写到那一路、回读确认）；要整批对齐用下面的“复制设置到其他通道”。排程、侦测区这类请到该通道的设置页。",
    "load_one": "比较 {{count}} 路的设置",
    "load_other": "比较 {{count}} 路的设置",
    "reload": "重新加载",
    "only_diff": "只看不一致的项目",
    "diff_count": "{{n}} 个项目各路不一致",
    "unread": "读不到设置：{{list}}",
    "col_setting": "设置项目",
    "custom": "到设置页",
    "save_cell": "保存 {{name}}"
  },
  "tier": {
    "filter": "显示",
    "common": "常用",
    "advanced": "高级",
    "technical": "技术"
  },
  "scope": {
    "src_own": "我自己的",
    "src_org": "组织授权给我",
    "src_shared": "别人分享给我",
    "external": "外部分享",
    "personal_org": "我的家",
    "sharer_unknown": "分享者",
    "notice_mfa_required": "需要开启两步验证",
    "notice_org_suspended": "组织已停用",
    "notice_ip_not_allowed": "不允许从这个网络访问",
    "notice_session_reauth": "需要重新登录",
    "notice_body_mfa_required": "这个组织要求两步验证。开启两步验证并重新登录后，就看得到这个组织的设备；你自己的与其他组织的设备不受影响。",
    "notice_body_org_suspended": "这个组织已被平台停用，暂时看不到它的设备。",
    "notice_body_ip_not_allowed": "这个组织只允许从指定的网络访问，目前的网络看不到它的设备。",
    "notice_body_session_reauth": "这个组织要求重新登录才能继续使用它的设备。",
    "go_settings": "前往设置",
    "load_failed": "设备列表暂时无法加载，请稍后再试。",
    "notice_delegator_mfa_required": "委派方要求两步验证",
    "hint_all": "全部",
    "hint_device": "这台设备在 {{path}}，不在当前的范围（{{scope}}）。",
    "hint_event": "这则事件在 {{path}}，不在当前的范围（{{scope}}）。",
    "hint_switch": "把范围切到 {{name}}",
    "switched_to": "已把范围切到 {{name}}",
    "all_n_orgs_one": "全部（{{count}} 个组织）",
    "all_n_orgs_other": "全部（{{count}} 个组织）",
    "count_one": "{{count}} 台",
    "count_other": "{{count}} 台",
    "count_tip": "你可访问的设备数（不含 NVR 通道）",
    "search": "搜索组织、场所、$t(leaf.cur)",
    "create_org": "＋ 创建组织",
    "loading": "范围加载中…",
    "all_n_orgs_homes_one": "全部（{{count}} 个组织、{{homes}} 个家）",
    "all_n_orgs_homes_other": "全部（{{count}} 个组织、{{homes}} 个家）",
    "notice_sso_required": "需要以公司账号验证",
    "go_sso": "以公司账号验证"
  },
  "access": {
    "shared_by": "{{name}} 分享",
    "expires": "{{date}} 到期",
    "also_via": "也可经：{{list}}"
  },
  "deny": {
    "not_granted": "没有这项权限",
    "org_mfa_required": "需要开启两步验证",
    "org_suspended": "组织已停用",
    "ip_not_allowed": "组织不允许从这个网络访问",
    "session_reauth": "需要重新登录",
    "share_expired": "分享已于 {{date}} 到期",
    "share_expired_nodate": "分享已到期",
    "share_suspended": "分享暂停中",
    "alarm_window": "只在警报后 {{n}} 分钟内可看",
    "armed": "只在布防时可用",
    "schedule": "不在授权的时段内",
    "before_share_start": "分享开始前的数据看不到",
    "org_unverified": "服务商的审核已失效",
    "parent_restricted": "只开放部分通道",
    "duty_no_export": "值班账号不能导出",
    "action_not_available": "这个环境不提供这项功能",
    "device_offline": "设备离线"
  },
  "shr": {
    "tab": "分享",
    "title": "{{name}} 的分享",
    "hint": "把这个$t(leaf.cur)的设备逐台分享给个人或组织（安装商、保全、监控中心…）。分享只能缩小或撤销，撤销后 30 秒内停止对方的视频；收到分享的人不能再分享出去。",
    "to_person": "分享给个人",
    "to_org": "分享给组织",
    "people": "分享给个人",
    "orgs": "分享给组织",
    "none": "目前没有分享。",
    "no_homes": "你没有可以管理分享的$t(leaf.cur)（要是$t(leaf.cur)的拥有者或管理员）。",
    "no_expiry": "不到期",
    "renew": "续约",
    "renew_of": "续约「{{name}}」",
    "renew_hint": "输入组织给你的续约代码：范围不变、期限延长。范围有变的请用「分享给组织」重新同意。",
    "revoke_confirm": "撤销分享给「{{name}}」？30 秒内生效。",
    "someone": "对方",
    "an_org": "一个组织",
    "person_hint": "输入对方的 email（同一个账号池）。对方已有账号会立即看到、收到通知；还没有账号会收到邀请信，注册后生效。不用对方接受，对方可以随时移除。",
    "no_reshare": "默认只开「看」；收到的人不能再分享出去。",
    "expires": "到期日（选填）",
    "expires_hint": "不设 = 一直有效，直到你撤销。",
    "send": "发送",
    "sent": "已发送给 {{email}}。",
    "unverified": "尚未通过审核",
    "is_renewal": "这是续约请求：范围不变、期限延长。",
    "access_log": "分享访问记录",
    "access_log_hint": "经分享看视频、回放、控制设备都会记在这里，$t(leaf.cur)成员都看得到，无法修改。",
    "grantee": "分享对象",
    "grantee_user": "个人",
    "grantee_org": "组织",
    "wrong_env": "这个代码属于另一个环境（{{env}}），这个$t(leaf.cur)不能同意。",
    "requested_devices": "对方要求的设备",
    "unknown_device": "已移除的设备"
  },
  "mine": {
    "shared_tab": "分享给我",
    "shared_title": "别人分享给我的",
    "shared_hint": "别人逐台分享给你个人的设备。不用接受，你可以随时移除；分享给你所属组织的设备不在这里。",
    "shared_none": "目前没有人分享设备给你。",
    "remove": "移除",
    "remove_confirm": "移除 {{name}} 分享给你的设备？",
    "remove_body": "移除后就看不到这些设备；要再看得请对方重新分享。",
    "access_log": "访问记录",
    "access_log_hint": "你经别人分享看视频、回放、控制设备的记录；分享给你的人也看得到。",
    "access_log_empty": "还没有记录。",
    "result": "结果",
    "result_ok": "成功",
    "result_denied": "被拒"
  },
  "inv": {
    "tab_unassigned": "未归户设备",
    "tab_detected": "检测到的设备",
    "title": "{{name}} 的设备库存",
    "hint": "组织拥有、还没加入$t(leaf.cur)的设备：认领、预先指派到场所的$t(leaf.cur)，设备上线后自动加入。库存不会让任何人看到视频。",
    "detected_hint": "场所现场发现、还没加入的设备（附近的新设备、要地址的 PoE 摄像头、ONVIF 探索）；库存内的可一键加入。",
    "coming_soon": "这个功能即将推出。",
    "no_org": "你没有可以管理设备库存的组织。",
    "claim": "认领设备",
    "col_name": "名称",
    "col_serial": "序列号",
    "col_status": "状态",
    "col_target": "指派 / 所在$t(leaf.cur)",
    "empty": "库存里没有设备。",
    "status_offline": "未上线",
    "status_online_unpaired": "在线、未加入",
    "status_assigned": "已指派、等设备上线",
    "status_joined": "已加入",
    "claim_help": "输入序列号与订单号（粘贴出货单也可以）：每行一台，序列号和订单号之间用空格或逗号分开。对不上的行一律显示“对不上”，不会说是哪一项错。",
    "claim_lines": "序列号　订单号（每行一台）",
    "claim_placeholder": "SN2505A0012 PO-20261009-01",
    "claim_bad_lines": "第 {{lines}} 行格式不对（要“序列号 订单号”两栏）",
    "claim_over": "一次最多 {{n}} 行，多的这次不发送",
    "claim_run": "认领 {{n}} 台",
    "claim_st_pending": "处理中…",
    "claim_st_ok": "✓ 已加入库存（{{model}}）",
    "claim_st_already": "✓ 已经在库存（{{model}}）",
    "claim_st_not_found": "序列号或订单号对不上",
    "claim_st_rate_limited": "失败太多次，请一小时后再试",
    "claim_st_error": "暂时无法认领（{{code}}）",
    "assign_to": "指派到…（{{n}}）",
    "assign_title": "指派 {{n}} 台到$t(leaf.cur)",
    "assign_help": "选要装的$t(leaf.cur)：设备上线后自动加入；已在线的会马上加入。指派不会让任何人看到影像。",
    "assign_search": "找$t(leaf.cur)",
    "assign_home": "$t(leaf.cur)",
    "assign_no_home": "没有符合的$t(leaf.cur)（$t(leaf.cur)要挂在节点下面）",
    "assign_run": "指派",
    "assign_st_assigned": "✓ 已指派，等设备上线",
    "assign_st_joined": "✓ 已在这个$t(leaf.cur)",
    "err_NOT_FOUND": "不在这个组织的设备库存",
    "err_DEVICE_ALREADY_BOUND": "已在本组织别的$t(leaf.cur)；要换$t(leaf.cur)先解绑",
    "err_ECOSYSTEM_MISMATCH": "生态系统不符",
    "err_UNAVAILABLE": "暂时无法处理，稍后再试",
    "err_INTERNAL": "处理失败，稍后再试",
    "unassign": "取消指派",
    "unassign_n": "取消指派（{{n}}）",
    "unassign_confirm": "取消 {{n}} 台的预先指派？设备会留在库存，之后可以再指派。",
    "filter_all_status": "全部状态",
    "filter_all_models": "全部机种",
    "search_serial": "搜索序列号",
    "filter_node": "只看：{{name}}",
    "filter_node_clear": "看整个组织",
    "select_all": "全选",
    "col_source": "入库来源",
    "more": "还有更多，请用筛选缩小范围。",
    "source_admin": "平台配发",
    "source_shop": "商城订单",
    "source_claim": "序列号认领",
    "source_dealer": "经销出货",
    "source_org_link": "开发者组织交付",
    "source_transfer": "组织转移",
    "det_node": "范围节点",
    "det_scope_node": "当前范围的节点",
    "det_scan": "扫描 ONVIF",
    "det_scanning": "扫描中…（最多约 15 秒）",
    "det_nearby_pending": "这里列出向 Station / NVR 要网络地址的设备，以及 ONVIF 扫描找到的摄像头。",
    "det_scan_result": "扫了 {{gateways}} 台网关，找到 {{found}} 台（{{failed}} 台网关没响应）",
    "det_col_kind": "类型",
    "det_col_what": "机种 / 厂商",
    "det_col_seen_by": "在哪里看到",
    "det_col_sources": "来源",
    "det_col_seen_at": "最后看到",
    "det_kind_kinio": "Kinio 设备",
    "det_kind_third_party": "第三方 ONVIF",
    "det_kind_address_request": "要地址的设备",
    "det_in_inventory": "在库存",
    "det_gateway": "网关",
    "det_src_onvif": "ONVIF 发现",
    "det_src_station_dhcp": "要地址",
    "det_src_nearby_wifi": "附近（Wi-Fi）",
    "det_src_nearby_lan": "附近（局域网）",
    "det_add": "加入",
    "det_add_onvif": "用 ONVIF 加入",
    "det_approve": "批准地址",
    "det_suspect": "可能是上行网段的设备，批准前先确认",
    "det_empty": "没有侦测到新设备。按〔扫描 ONVIF〕找网络上的摄像头。",
    "det_col_ident": "尾码 / MAC",
    "det_lease_error": "侦测没有开始（列表可能不是实时的）：",
    "det_adopt_title": "把库存里的设备加入$t(leaf.cur)",
    "det_adopt_help": "选要加入的$t(leaf.cur)（要在这个节点下面）。设备已经在线就马上加入，还没上线的话，设备一上线就自动加入。",
    "det_adopt_joined": "已加入。",
    "det_adopt_assigned": "已指派，设备上线后自动加入。"
  },
  "ot": {
    "dot": "・",
    "you": "你",
    "reauth_suffix": "（需要重新验证）",
    "optional": "（选填）",
    "reason": "理由",
    "next": "下一步",
    "next_preview": "下一步：看影响",
    "name": "名称",
    "owner": "拥有者",
    "personal": "个人",
    "org_owned": "组织",
    "add": "加入",
    "clear": "清除",
    "details": "详情",
    "now": "现在",
    "forever": "永久",
    "until": "至 {{date}}",
    "window": "{{from}}–{{to}}",
    "until_date": "到期日",
    "term": "期限",
    "only_window": "只在这个时段",
    "window_from": "开始",
    "window_to": "结束",
    "expand": "展开",
    "collapse": "收合",
    "no_results": "没有符合的项目",
    "n_people": "{{n}} 人",
    "n_people_paren": "（{{n}} 人）",
    "n_people_link": "{{n}} 人 ›",
    "n_assignments": "{{n}} 笔指派",
    "n_homes_devices": "{{homes}} 个户・{{devices}} 台",
    "n_grantees": "{{n}} 位被指派者",
    "member_group_n": "成员群组 · {{n}} 人",
    "member_group_paren": "（成员群组・{{n}} 人）",
    "delegation": "委派",
    "delegations": "委派",
    "verified": "已审核：{{kinds}}",
    "org_code": "组织代号 {{code}}",
    "org_code_line": "本组织代号：{{code}}（对方创建委派时看得到同一组，可以口头核对）",
    "whole_org": "整个组织",
    "whole_org_name": "{{org}}（整个组织）",
    "whole_org_short": "{{org}}",
    "whole_org_of": "{{org}}（整个组织）",
    "whole_org_now_later": "（现在与之后的节点、户）",
    "whole_org_check": "整个组织（现在与之后的节点、户）",
    "leaf_default": "地点",
    "leaf_personal": "家庭",
    "leaf_default_lc": "地点",
    "leaf_default_pl": "地点",
    "leaf_default_lc_pl": "地点",
    "leaf_personal_lc": "家庭",
    "leaf_personal_pl": "家庭",
    "leaf_personal_lc_pl": "家庭",
    "unassigned": "未指派",
    "scope_custom": "（目前范围）",
    "level": "层级名称",
    "not_in_list": "已不在清单",
    "lvl_site": "场所",
    "lvl_building": "建筑",
    "lvl_floor": "楼层",
    "lvl_zone": "区域",
    "act_view": "看",
    "act_playback": "回放",
    "act_events": "事件",
    "act_alarm": "警报",
    "act_talk": "对讲",
    "act_control": "控制",
    "act_arm": "布防",
    "act_disarm": "撤防",
    "act_maintain": "维运",
    "act_export": "导出",
    "act_profile": "$t(leaf.cur)数据",
    "role": "角色",
    "role_node_admin": "节点管理员",
    "role_operator": "操作员",
    "role_viewer": "观看者",
    "role_installer": "安装技师",
    "role_maintainer": "运维员",
    "role_custom": "自订",
    "role_owner": "拥有者",
    "role_admin": "管理员",
    "role_member": "成员",
    "role_desc_node_admin": "全部数据动作（含布防 / 撤防）+ 维运 + 子节点与指派；不含分享、$t(leaf.cur)角色、录像设置、解绑、格式化",
    "role_desc_operator": "看、对讲、回放、事件、控制、处理警报",
    "role_desc_viewer": "看、事件；不处理警报、警报不推播",
    "role_desc_installer": "看、控制",
    "role_desc_node_admin_d_tail": " + 在这个子树指派本组织成员；撤防、维运要另勾；不能改 {{from}} 的节点结构",
    "role_node_admin_excl": "（不含分享、$t(leaf.cur)角色、录像设置、解绑、格式化）",
    "role_effective_title": "角色・实际生效 = 角色 ∩ 委派范围（{{scope}}）",
    "extra_recording_export": "另加：下载 / 导出录像",
    "extra_alarm_receive": "另加：处理警报",
    "extra_security_arm": "另加：远程布防",
    "extra_security_disarm": "另加：远程撤防",
    "extra_device_maintain": "另加：维运（固件更新、重新开机、改名）",
    "tab_tree": "组织树",
    "tab_views": "布局",
    "tab_groups": "群组",
    "panel_collapse": "收起面板",
    "panel_expand": "展开组织树 / 布局 / 群组",
    "tree_dlg_changed": "{{from}} 已调整委派范围",
    "auth_changed": "权限已更新",
    "dlg_ended_short": "{{from}} 已结束委派",
    "tree_search": "搜索节点、$t(leaf.cur)、设备",
    "search_min": "至少输入 2 个字",
    "search_more": "还有更多，请缩小范围",
    "tree_empty": "还没有任何设备。",
    "count_tip": "你可访问的设备数",
    "dlg_label": "委派：{{from}}",
    "dlg_label_whole": "委派：{{from}}（整个组织）",
    "dlg_tip": "{{from}} 委派，{{until}}",
    "mfa_needed": "{{from}} 要求两步验证，打开后才看得到这些设备。",
    "setup_mfa": "设置两步验证",
    "dlg_ended_line": "{{from}} 已于 {{time}} 结束委派",
    "no_assignment_yet": "你在 {{org}} 还没有被指派任何节点，请洽 {{org}} 的管理员",
    "more_actions": "{{name}} 的更多动作",
    "notify_me_node": "通知我这个节点",
    "notify_me_group": "通知我这个群组",
    "add_to_view": "加到布局…",
    "add_to_group": "加到群组…",
    "open_in_wall": "在视频墙打开",
    "no_devices": "没有你看得到的设备",
    "place_on_wall": "放进视频墙",
    "you_can_view_hint": "画面 = 摄像头或通道；一台 NVR 有几个通道就算几个画面（树上每行数的是设备）",
    "live_empty": "这个范围没有你看得到的摄像头。",
    "live_dlg_ended": "{{from}} 已于 {{time}} 结束委派，这个画面已停止",
    "live_dlg_changed": "{{from}} 已调整委派范围，你已不能看这台",
    "prev_page": "上一页",
    "next_page": "下一页",
    "page_n": "第 {{n}} / {{total}} 页",
    "views_hint": "布局只是整理方式，不会让任何人看到他原本没有权限的设备",
    "groups_hint": "群组不授予任何权限；每个人只看到自己有权限的设备",
    "view_new": "添加布局",
    "group_dev_new": "添加设备群组",
    "no_views": "还没有布局。",
    "no_dev_groups": "还没有设备群组。",
    "view_label": "布局：{{name}}",
    "group_prefix": "群组：{{name}}",
    "edit_named": "编辑 {{name}}",
    "unavailable_n_one": "{{count}} 个项目已无法参照",
    "unavailable_n_other": "{{count}} 个项目已无法参照",
    "group_batch": "批量作业",
    "view_edit_title": "编辑布局：{{name}}",
    "group_edit_dev_title": "编辑设备群组：{{name}}",
    "org_view_of": "组织：{{org}}",
    "source_personal": "来源（我看得到的）",
    "source_org": "来源（本组织的结构与委派来的节点；只有名称）",
    "source_structure": "本组织的结构",
    "view_content": "布局内容",
    "group_content": "群组内容",
    "add_folder": "添加文件夹",
    "new_folder": "新文件夹",
    "folder": "文件夹",
    "top_level": "最上层",
    "editor_empty": "从左边的来源按〔＋〕加入。",
    "ref_folder": "文件夹",
    "ref_node": "节点",
    "ref_home": "$t(leaf.cur)",
    "ref_device": "设备",
    "ref_group": "群组",
    "add_ref": "加入 {{name}}",
    "items_from_ended_one": "来自已结束的委派：{{from}}（{{count}} 个项目）",
    "items_from_ended_other": "来自已结束的委派：{{from}}（{{count}} 个项目）",
    "items_gone_one": "{{count}} 个项目已无法参照",
    "items_gone_other": "{{count}} 个项目已无法参照",
    "add_to_view_title": "把「{{name}}」加到布局",
    "add_to_group_title": "把「{{name}}」加到群组",
    "no_editable_views": "没有你能编辑的布局，先在〔布局〕分页添加一个。",
    "no_editable_groups": "没有你能编辑的群组，先在〔群组〕分页添加一个。",
    "subs_title": "节点与群组",
    "subs_hint": "组织树上的节点缺省不推一般侦测；订阅后才推播 / 进收件匣。没订阅的只在「事件」清单看得到。",
    "subs_mine": "我订阅的",
    "subs_none": "还没有订阅任何节点或群组。",
    "subs_target": "节点 / 群组",
    "subs_detection": "一般侦测",
    "subs_inactive": "目前不生效",
    "subs_add": "＋ 订阅节点或群组",
    "subscribe": "订阅",
    "unsubscribe": "取消订阅",
    "ch_push": "推播",
    "ch_inbox": "收件匣",
    "ch_email": "Email",
    "implicit_title": "不用订阅就会收到",
    "implicit_alarm": "警报",
    "implicit_device_status": "设备异常",
    "implicit_alarm_push": "照一般偏好推播",
    "implicit_alarm_feed": "不推，事件清单看得到",
    "implicit_alarm_generic": "角色能处理警报的地方照一般偏好推播；观看者的地方不推，事件清单看得到",
    "implicit_status": "节点管理员或负责维运的地方：脱机、录像中断、保存异常推播；OTA 等其他进收件匣",
    "implicit_mfa": "委派方要求两步验证、你没开时：警报照样推播，内容只写「<委派方> 有一则警报，打开两步验证后才看得到」",
    "structure_title": "组织结构",
    "structure_moved": "节点、$t(leaf.cur)、指派与中断继承在「组织结构」管理。",
    "open_structure": "前往组织结构",
    "no_structure_access": "你没有可以管理的节点。",
    "level_settings": "层级名称设置",
    "struct_tree_head": "结构树（数字 = 结构总数）",
    "struct_tree": "结构树",
    "struct_search": "搜索节点、{{leaf}}",
    "struct_count_tip": "结构总数（设备）",
    "blocked_tip": "已中断继承：上层的指派与委派不适用",
    "select_home": "选取 {{name}}",
    "pick_node": "在左边选一个节点。",
    "struct_totals": "底下 {{nodes}} 个节点、{{homes}} 个户、{{devices}} 台（结构总数）",
    "add_child": "＋ 子节点",
    "add_home": "＋ {{leaf}}",
    "rename_level": "改名 / 层级",
    "move": "移动",
    "archive": "停用",
    "archive_title": "停用「{{name}}」？",
    "archive_body": "节点底下要先没有$t(leaf.cur)与子节点；这个节点上的指派会结束，委派只移除这个节点。",
    "archived": "已停用「{{name}}」",
    "block_label": "中断继承（上层的指派与委派不再适用于这个节点以下）",
    "this_node_assignments": "本节点的指派",
    "no_assignments": "这个节点没有指派。",
    "add_assignment": "＋ 指派",
    "inherited_title": "从上层继承（唯读）",
    "delegated_out_title": "委派给其他组织（唯读）",
    "col_who": "对象",
    "col_role": "角色",
    "col_role_before": "原本的角色",
    "col_term": "期限 / 时段",
    "col_from": "来自",
    "col_to_org": "受托组织",
    "col_from_org": "委派方",
    "col_scope": "范围",
    "col_how": "怎么来的",
    "col_granted_by": "授予者",
    "col_lost_actions": "失去的动作",
    "col_effective": "实际生效",
    "col_effective_now": "目前生效",
    "col_after_apply": "套用后多出",
    "col_node": "节点",
    "col_grantees": "被指派人",
    "col_assigned": "已指派",
    "n_selected": "已选 {{n}} 个{{leaf}}",
    "move_to": "移到…",
    "assign_manager": "指定管理人…",
    "only_unassigned": "只能选未指派的户",
    "batch_max": "一次最多 {{n}} 户",
    "node_name": "节点名称",
    "level_hint": "层级名称只用于显示与筛选，不决定权限。",
    "create": "创建",
    "add_child_of": "在「{{name}}」底下添加节点",
    "rename_title": "改名 / 层级：{{name}}",
    "node_created": "已创建「{{name}}」",
    "node_saved": "已保存",
    "add_home_at": "在「{{name}}」添加{{leaf}}",
    "manager": "管理人",
    "manager_none": "未指派（之后再指定）",
    "manager_member": "指定成员",
    "manager_me": "指定我为管理人",
    "home_name": "{{leaf}}名称",
    "creator_not_manager": "创建者不会成为这一户的管理人；谁能看由节点指派决定。",
    "cover_summary": "目前会涵盖这一户的指派：{{list}}",
    "cover_part": "{{node}}：{{n}} 人",
    "cover_dlg": "委派：{{org}}",
    "no_one_covers": "目前没有人能看这一户的影像",
    "whole_org_hint": "每开一个点都要自己看？在「整个组织」指派自己一次（自我授权），之后添加的都会涵盖",
    "unassigned_install": "未指派也能先装机：组织管理员与设备库存权限的成员可以预先指派、收编、配对设备（绑定不给任何人数据权）；录像用设备默认值（依机种，连续或事件）；要改录像设置、分享、解绑，先指定管理人（可以之后一次指定多户）。",
    "self_manager_yellow": "你会成为这个{{leaf}}的管理人并取得全部录像与事件。",
    "create_home": "创建{{leaf}}",
    "home_created": "已创建{{leaf}}「{{name}}」",
    "pick_target_hint": "选要移到哪个节点（只列你能管理、可以放下的节点）。",
    "move_node_title": "移动「{{name}}」",
    "move_node_confirm": "把「{{name}}」移到「{{to}}」？",
    "move_node_intro": "移动会改变这个子树被哪些指派与委派涵盖。",
    "move_action": "移动",
    "move_self_action": "搬移并取得访问",
    "moved": "已移动「{{name}}」",
    "move_homes_title_one": "把 {{count}} 户移到…",
    "move_homes_title_other": "把 {{count}} 户移到…",
    "move_homes_confirm_one": "把 {{count}} 户移到「{{to}}」？",
    "move_homes_confirm_other": "把 {{count}} 户移到「{{to}}」？",
    "move_homes_intro": "一次预览、一次确认；全部成功或全部不动。",
    "move_homes_action_one": "搬移 {{count}} 户",
    "move_homes_action_other": "搬移 {{count}} 户",
    "homes_moved_one": "已搬移 {{count}} 户",
    "homes_moved_other": "已搬移 {{count}} 户",
    "manager_dialog_title_one": "指定 {{count}} 户的管理人",
    "manager_dialog_title_other": "指定 {{count}} 户的管理人",
    "manager_pick": "新管理人（本组织成员）",
    "manager_effect_one": "{{name}} 会成为这 {{count}} 户的管理人（$t(leaf.cur)拥有者）：看得到全部录像与事件（$t(leaf.cur)角色不受涵盖起点限制，含指定之前的）、可以改录像设置、分享、解绑；现有的节点指派不变",
    "manager_effect_other": "{{name}} 会成为这 {{count}} 户的管理人（$t(leaf.cur)拥有者）：看得到全部录像与事件（$t(leaf.cur)角色不受涵盖起点限制，含指定之前的）、可以改录像设置、分享、解绑；现有的节点指派不变",
    "all_or_nothing": "全部成功或全部不动。",
    "self_manager_batch_one": "你选了自己：这是一次自我授权，会取得这 {{count}} 户的全部录像；其他管理员会收到一则通知，并记入审计。",
    "self_manager_batch_other": "你选了自己：这是一次自我授权，会取得这 {{count}} 户的全部录像；其他管理员会收到一则通知，并记入审计。",
    "manager_submit_one": "指定 {{count}} 户的管理人",
    "manager_submit_other": "指定 {{count}} 户的管理人",
    "managers_done_one": "{{name}} 已成为 {{count}} 户的管理人",
    "managers_done_other": "{{name}} 已成为 {{count}} 户的管理人",
    "levels_hint": "组织维护一份层级名称清单，每个节点自己选；同一层可以不同名称。最多 12 个，每个 1–20 字。",
    "level_n": "层级名称 {{n}}",
    "from_builtin": "原本的内置名称",
    "add_level": "＋ 层级名称",
    "leaf_label": "$t(leaf.cur)的名称（例：户、点、店）",
    "levels_preview": "预览",
    "levels_no_perm": "名称不决定权限。",
    "levels_builtin_warn": "内置名称会改成目前语系的文本，其他语系的成员也会看到这段文本；用这些内置名称的节点会一起改。",
    "levels_saved": "层级名称已保存",
    "levels_err_too_many": "最多 12 个层级名称",
    "levels_err_length": "每个名称 1–20 字",
    "levels_err_at_prefix": "自订名称不能以 @ 开头",
    "levels_err_duplicate": "名称不能重复",
    "previewing": "正在计算影响…",
    "preview_again": "重新预览",
    "preview_restaled": "预览后数据有变动，已重新预览并标出变了的列，请再确认一次。",
    "losing_title": "会失去经组织树的访问（{{n}} 人，含群组展开 · {{orgs}} 个受托组织）",
    "gaining_title": "会得到访问（{{n}} 人）",
    "history_from": "新得到访问的人从 {{time}} 起算，看不到之前的录像与事件。",
    "remaining_title": "之后仍有访问（不是经组织树来的，中断继承挡不到）",
    "other_paths": "仍经其他路径看得到（见下）",
    "target_still": "{{name}} 仍经这条看得到",
    "granter_still": "授予者仍经{{path}}看得到",
    "keep": "保留",
    "also_revoke": "一并撤销",
    "path_home_role": "$t(leaf.cur)角色",
    "path_site_grant": "场所授权",
    "path_share_user": "分享给个人",
    "path_share_org": "分享给组织",
    "path_assignment": "子树内的指派",
    "path_delegation": "子树内的委派",
    "granted_by_target_title": "他授出、仍有效的指派",
    "still_visible": "之后仍有 {{n}} 人看得到 {{target}}：{{who}}",
    "more_rows": "还有 {{n}} 人",
    "impact_scope": "受影响：{{homes}} 个户、{{devices}} 台",
    "active_streams": "目前 {{n}} 人正在看影像（30 秒内停止）",
    "dlg_gained": "{{org}} 的委派会因此多涵盖 {{n}} 个户；送出后会通知委派方的拥有者与所有管理员，以及受托方。",
    "dlg_lost": "{{org}} 的委派会因此少涵盖 {{n}} 个户（立即生效，双方都会收到通知）。",
    "self_gain_generic": "这次写入会让你自己新得到数据权（自我授权）：理由必填，其他组织管理员与拥有者会收到通知，并记入审计。",
    "block_on_title": "在「{{name}}」打开中断继承？",
    "block_off_title": "在「{{name}}」关闭中断继承？",
    "block_on_intro": "打开后，更上层的指派与委派不再适用于 {{name}} 以下（{{homes}} 个户、{{devices}} 台）；{{name}} 自己的指派照常。上层的节点管理员之后看不到 {{name}}（计数、访问、审计都不列）。",
    "block_off_intro": "关闭后，上层的指派与委派会重新涵盖 {{name}} 以下；重新得到访问的人从现在起算。",
    "block_on_action": "打开中断继承",
    "block_on_action_revoke": "打开中断继承并撤销 {{n}} 笔",
    "block_off_action": "关闭中断继承",
    "block_off_self_action": "关闭并取得访问",
    "block_on_note": "之后如果关闭中断继承，重新得到访问的人从关闭的时间起算，看不到中断期间的录像。",
    "blocked_done": "已在「{{name}}」打开中断继承",
    "unblocked_done": "已在「{{name}}」关闭中断继承",
    "revoke_assign_title": "撤销 {{who}} 在「{{node}}」的指派？",
    "revoke_assign_body": "会失去：{{what}}（新请求立即拒、正在看的影像 30 秒内停止）",
    "revoke_assign": "撤销指派",
    "revoke_node_admin_intro": "撤销节点管理员前，先看他授出、仍有效的指派，可一并撤销；没勾的照旧有效。",
    "revoked": "已撤销",
    "steps": "步骤",
    "step_who": "对象",
    "step_role": "角色",
    "step_term": "期限 / 时段",
    "step_confirm": "确认",
    "assign_title": "在「{{node}}」指派",
    "assign_edit_title": "编辑 {{name}} 的指派",
    "assign_d_title": "指派「{{path}}」给本组织成员",
    "who": "人员或成员群组",
    "who_search": "搜索人员、成员群组",
    "d_node_label": "节点（委派子树内，可以选子节点；只有名称与结构数）",
    "covers_now": "涵盖目前 {{homes}} 个户、{{devices}} 台（结构总数）；",
    "covers_subtree": "涵盖这个节点子树内的全部户；",
    "covers_tail": "之后添加的也会涵盖；开了中断继承的子节点不涵盖。",
    "effective_now": "实际生效：{{what}}",
    "not_effective": "不会生效：{{what}}",
    "not_effective_paren": "（不会生效：{{what}}）",
    "out_of_scope": "超出委派范围：{{what}}",
    "ignored_box": "「{{role}}」含「{{what}}」，{{from}} 没有委派这一项：这部分不会生效。",
    "pick_template": "选一个范本（范本勾了什么就是什么）",
    "assign_done": "已指派。",
    "assign": "指派",
    "assign_self": "指派自己",
    "self_yellow": "你会因此取得「{{scope}}」的影像（含录像）。",
    "self_notify_others": "其他组织管理员与拥有者会收到通知，并记入审计。",
    "self_notify_owner": "会通知拥有者并记入审计。",
    "self_notify_audit_only": "会记入审计。",
    "self_notify_d": "{{from}} 的拥有者与管理员也会收到通知。",
    "self_suggest_term": "建议设期限。",
    "reason_needed_self": "这次会让你自己取得访问（自我授权），请填理由。",
    "d_visible_to_delegator": "{{from}} 看得到被指派人的显示名称、角色与操作纪录。",
    "member_groups": "成员群组",
    "member_groups_hint": "成员群组只用在节点角色指派的对象（例：夜班保全）；一层、不嵌套。改成员要重新验证；把自己加进已有指派的群组会让你取得访问（自我授权）。",
    "group_new": "添加成员群组",
    "no_groups": "还没有成员群组。",
    "group_name": "群组名称",
    "group_members": "成员",
    "group_used": "使用中",
    "group_edit_title": "编辑成员群组：{{name}}",
    "group_delete_title": "删除成员群组「{{name}}」？",
    "group_delete_body": "用这个群组的 {{n}} 笔指派会一起失效，群组成员 30 秒内停止经这些指派看影像。",
    "group_delete": "删除群组",
    "self_group_yellow": "你把自己加进有 {{n}} 笔指派的群组，会因此取得这些节点的影像。",
    "dlg_out": "委派出去",
    "dlg_in": "委派给本组织",
    "dlg_out_of": "委派出去（{{org}}）",
    "dlg_in_of": "委派给本组织（{{org}}）",
    "no_dlg_out": "还没有委派给其他组织。",
    "no_dlg_in": "还没有其他组织委派给本组织。",
    "dlg_scope": "范围",
    "dlg_forever_short": "永久",
    "dlg_new_by_code": "用对方的委派代码添加",
    "still_needed": "仍需要",
    "reviewed": "已覆核：对 {{org}} 的委派仍需要",
    "tag_review": "待覆核",
    "tag_expiring": "即将到期",
    "tag_suspended": "暂停",
    "tag_ended": "已结束",
    "delegator_paren": "（委派人：{{name}}）",
    "dlg_mfa_note": "{{from}} 要求两步验证：被指派的成员也要开",
    "expandable": "范围已扩大：{{n}} 笔指派可扩大",
    "apply_ellipsis": "套用…",
    "assign_members": "指派成员",
    "gen_code": "产生委派代码",
    "gen_code_hint": "把代码、QR 或链接交给要委派给你的组织；7 天内有效、用一次就失效。",
    "code_note": "备注",
    "code": "委派代码",
    "code_qr": "委派代码 QR",
    "code_valid": "有效到 {{date}}",
    "my_codes": "我产生的代码",
    "code_expires": "{{date}} 失效",
    "code_cancel": "撤回",
    "dlg_new_title": "添加委派",
    "wz_code": "代码",
    "wz_nodes": "节点",
    "wz_scope": "范围与期限",
    "wz_confirm": "确认",
    "dlg_code_input": "对方的委派代码",
    "dlg_code_hint": "对方在「委派给本组织」产生的代码；请确认来自你认识的对象。",
    "requested_by": "请求人：{{name}}（{{domain}}）",
    "unverified_warn": "此组织未经平台审核，请确认代码来自你认识的对象",
    "single_home_hint": "只要委派单一户：先建一个节点、把户搬进去，再委派那个节点。",
    "scope_view": "看（即时影像）",
    "scope_event_read": "事件",
    "scope_recording_read": "回放",
    "scope_alarm_receive": "处理警报",
    "scope_media_talk": "对讲",
    "scope_device_control": "控制",
    "scope_security_arm": "远程布防",
    "scope_security_disarm": "远程撤防",
    "scope_device_maintain": "维运（固件更新、重新开机、改名）",
    "scope_home_profile_read": "$t(leaf.cur)数据（地址、时区、地图、平面图）",
    "scope_recording_export": "下载 / 导出录像",
    "dlg_fixed_1": "解绑、格式化、权限、节点结构永远留在委派方。",
    "dlg_fixed_2": "对方的 API / webhook 不会取得这些设备（只有对方的成员帐号）。",
    "dlg_fixed_3": "你要求的两步验证会套用到对方成员；你的 IP 允许清单、闲置逾时不套用。",
    "dlg_forever": "永久（每 12 个月提醒双方覆核）",
    "dlg_until": "到期日（到期前 30 / 7 天提醒）",
    "dlg_history": "历史",
    "dlg_history_now": "只从委派开始之后",
    "dlg_history_back": "往前追溯（最多 30 天）",
    "days_back": "天前起",
    "history_days_one": "往前 {{count}} 天",
    "history_days_other": "往前 {{count}} 天",
    "history_since": "从 {{date}} 起",
    "dlg_notify": "创建后会通知：{{from}} 的拥有者与所有组织管理员，以及 {{to}} 的拥有者与管理员",
    "dlg_self_related": "你也是 {{to}} 的成员：这次委派比照自我授权，理由必填、审计会标记。",
    "dlg_create": "创建委派",
    "dlg_created": "已委派给 {{org}}",
    "dlg_detail_out": "委派给 {{org}}",
    "dlg_detail_in": "{{org}} 委派给本组织",
    "edit_scope": "编辑范围",
    "extend_term": "延长 / 设期限",
    "revoke_dlg": "撤销委派",
    "end_dlg": "结束委派",
    "end_dlg_title": "结束 {{from}} 委派给本组织的节点？",
    "end_dlg_body": "本组织成员经这笔委派的访问立即停止（影像 30 秒内停止），本组织在这笔委派下的指派一并失效；双方审计各记一笔。",
    "created_reviewed": "创建 / 覆核",
    "expanded_at": "{{date}} 扩大",
    "reviewed_at": "上次覆核 {{date}}",
    "created_by": "创建人 {{name}}",
    "policy": "套用的政策",
    "policy_mfa": "{{from}} 要求两步验证（IP 允许清单、闲置逾时不套用）",
    "policy_none": "没有额外要求",
    "grantees_title": "{{org}} 的被指派人（唯读）",
    "no_grantees": "对方还没有指派任何成员。",
    "via_group": "经群组 {{ref}}",
    "recent_ops": "最近 30 天经这笔委派的操作：{{n}} 笔",
    "open_audit": "看审计",
    "my_assignments_title": "本组织的指派",
    "no_d_assignments": "还没有指派任何成员。",
    "can_expand": "可扩大",
    "delegator_sees_list": "{{from}} 看得到这份名单（显示名称、角色、实际生效、节点、期限；不含 email）",
    "revoke_dlg_title": "撤销对 {{org}} 的委派？",
    "will_lose": "{{org}} 会失去（{{n}} 位被指派人）",
    "revoke_dlg_note": "送出后通知 {{org}} 的拥有者与管理员；他们的成员看到「已结束委派」，不只是「权限已更新」。",
    "dlg_revoked": "已撤销对 {{org}} 的委派",
    "edit_scope_title": "编辑对 {{org}} 的委派范围",
    "extend_term_title": "对 {{org}} 的委派期限",
    "edit_dlg_hint": "缩小立即生效、通知对方；扩大不用对方同意，对方既有的指派要按〔套用〕才会扩大。",
    "save_scope": "保存范围",
    "save_term": "保存期限",
    "dlg_updated": "已更新委派",
    "apply_title": "套用 {{from}} 扩大的范围",
    "apply_hint": "{{from}} 扩大了委派范围；没套用前照旧。勾要扩大的指派。",
    "apply_n": "套用 {{n}} 笔",
    "applied": "已套用 {{n}} 笔指派",
    "d_revoke_title": "撤销 {{who}} 在「{{where}}」的指派？",
    "d_revoke_lose": "会失去：{{what}}",
    "d_revoke_streams": "此刻经这笔指派在看影像：{{n}} 人（30 秒内停止）",
    "d_revoke_notify": "设备异常通知下一则起不再送。",
    "d_revoke_yellow": "{{from}} 的委派详情名单会拿掉他；双方审计各记一笔。",
    "err_rate_limited_one": "预览太频繁，{{count}} 秒后再试",
    "err_rate_limited_other": "预览太频繁，{{count}} 秒后再试",
    "err_depth": "节点最多 {{n}} 层",
    "err_limit": "已达上限 {{n}}",
    "err_busy": "组织树正在更新，请稍后再试",
    "err_not_empty": "节点底下还有 {{homes}} 个户、{{nodes}} 个子节点，先移走才能停用",
    "err_team_org": "只有团体组织能用节点指派与委派",
    "err_use_node_assignment": "「场所管理员」范本已停用，请改用节点指派",
    "err_code_gone": "委派代码已过期、撤回或用过，请对方重新产生",
    "err_scope_exceeded": "这个角色跟委派范围没有交集，指派不会有任何作用",
    "err_cycle": "不能把节点移到自己底下",
    "err_out_of_anchor": "有设备的位置不在新的节点范围内，先调整设备位置",
    "err_exceeds_actions": "不能给出超过你自己的动作",
    "err_exceeds_expires_at": "期限不能超过你自己的指派",
    "err_exceeds_schedule": "时段不能超过你自己的指派",
    "err_preview_stale": "预览之后数据有变动，请重新预览",
    "err_home_assigned": "选取里有已指定管理人的户，只能选未指派的户",
    "err_conflict": "已经有一笔相同的委派或设置",
    "err_history_max_one": "最多往前追溯 {{count}} 天",
    "err_history_max_other": "最多往前追溯 {{count}} 天",
    "err_root_node": "「整个组织」不能这样做",
    "err_invalid": "输入的内容不正确",
    "err_forbidden_self_modify": "不能改或撤自己的指派",
    "err_forbidden_inheritance_boundary": "搬进或搬出中断继承的子树只限拥有者与组织管理员",
    "err_forbidden_orgtree_not_open": "节点指派与委派尚未对这个组织开放",
    "pair_joined_no_access": "已加入；你没有这一户的影像权",
    "batch_mode": "批量移动 / 指定管理人",
    "batch_mode_move": "批量移动",
    "select_done": "完成选择",
    "select_hint": "勾选要处理的{{leaf}}",
    "struct_count_head": "数字 = 这一层以下的设备总数（含你没有视频权限的）",
    "site_tab_devices": "设备",
    "site_tab_access": "谁能访问",
    "site_tab_settings": "场所设置",
    "site_access_hint": "本节点指派、从上层继承（只读）、委派出去（只读）、$t(leaf.cur)角色与分享都在这里。",
    "maint_title": "维护",
    "block_short": "中断继承",
    "block_is_on": "已开启",
    "block_is_off": "未开启",
    "archive_desc": "停用后这个节点不再出现在树上；下面还有家庭或子节点时不能停用。",
    "site_dev_count": "你看得到 {{n}} 台（这里以下共 {{homes}} 个家庭）",
    "site_dev_name": "名称",
    "site_dev_model": "机型",
    "site_dev_status": "状态",
    "site_dev_home": "家庭",
    "site_dev_online": "在线",
    "site_dev_offline": "离线",
    "site_dev_channels_one": "（{{count}} 个通道）",
    "site_dev_channels_other": "（{{count}} 个通道）",
    "site_dev_empty": "这里以下还没有设备。",
    "site_dev_hidden": "另有 {{n}} 个家庭你没有视频权限，不列设备：{{names}}",
    "set_name": "名称与层级",
    "set_tz": "时区",
    "set_tz_inherit": "跟上层（没设置）",
    "set_tz_hint": "时段限制、排程与报表用这个时区；没设置时跟上层。",
    "set_geo": "地址与坐标",
    "set_address": "地址",
    "set_lat": "纬度",
    "set_lng": "经度",
    "set_geo_bad": "纬度与经度要一起填，而且是数字。",
    "set_saved": "已保存。",
    "set_offline": "断网可用（本地 VMS）",
    "set_offline_on": "外网断了，这个场所的电脑仍可用本地 VMS 看 Kinio Station 的摄像头",
    "set_offline_hours": "最长可以断网（小时）",
    "set_offline_hint": "开启后，这个场所的成员可以在“我的账号 › 本地 VMS”登记电脑；团队组织最长 72 小时。",
    "set_offline_saved_on": "已开启断网可用。",
    "set_offline_saved_off": "已关闭断网可用。",
    "set_computers": "登记过本地 VMS 的电脑",
    "set_computer_updated": "最后更新 {{date}}",
    "views_empty": "这里放存过的视频墙布局，以及你自己整理的摄像头清单；在视频墙〔另存布局〕或按〔添加布局〕都会存到这里。",
    "groups_empty": "群组是一组摄像头的名单，可以用来轮巡、订阅通知、一次开到视频墙。",
    "layout_cells_one": "布局 · {{count}} 格",
    "layout_cells_other": "布局 · {{count}} 格",
    "layout_open_tip": "开到视频墙并载入这个布局",
    "struct_totals2": "底下 {{nodes}} 个节点、{{homes}} 个户、{{dev}}（结构总数）",
    "struct_dev_incl_one": "{{count}} 台（含通道）",
    "struct_dev_incl_other": "{{count}} 台（含通道）",
    "struct_dev_split": "{{devices}} 台设备、{{channels}} 个通道",
    "struct_count_tip_incl": "结构总数（台，目前含 NVR 通道）",
    "struct_count_tip_split": "结构总数（台，不含通道；另有 {{channels}} 个通道）",
    "struct_count_head_incl": "；目前含 NVR 通道",
    "set_autosave": "改了会自动保存（离开栏位就存），不用按保存。",
    "you_can_view_wall": "这个范围有 {{n}} 个画面，墙上放了其中 {{x}} 个",
    "tree_btn": "组织树",
    "you_can_view_wall_paged": "这个范围有 {{n}} 个画面：这一页 {{x}} 个，下一页还有 {{rest}} 个",
    "home_devices": "{{count}} 台设备（结构总数）",
    "home_delete": "删除这个{{leaf}}",
    "home_delete_desc": "设备会一起移除并恢复出厂设置，录像与事件会删除，无法恢复。",
    "home_delete_title": "删除「{{name}}」？",
    "home_delete_warn_n": "这个{{leaf}}的 {{count}} 台设备会一起移除，并恢复出厂设置。",
    "home_delete_warn_empty": "这个{{leaf}}没有设备。",
    "home_delete_tail": "录像与事件会删除，成员会收到通知。删除后无法恢复。",
    "home_delete_archives_n": "这个{{leaf}}有 {{count}} 个长期保管中的导出包（最晚保管到 {{date}}），删除后会一起删掉，已付的保管费用不退。",
    "home_delete_archives_n_nodate": "这个{{leaf}}有 {{count}} 个长期保管中的导出包，删除后会一起删掉，已付的保管费用不退。",
    "home_delete_archives_unknown": "如果这个{{leaf}}有长期保管中的导出包，会一起删掉，已付的保管费用不退。",
    "home_delete_action": "删除这个{{leaf}}（需要重新验证）",
    "home_deleting": "删除中…",
    "home_deleted": "已删除「{{name}}」",
    "err_home_unbind_failed": "有设备解除绑定失败，这个{{leaf}}没有删除，请稍后再试。",
    "err_home_not_found": "这个{{leaf}}已经不存在，或你看不到。",
    "err_home_delete_forbidden": "要组织所有者 / 管理员或这个{{leaf}}的管理人才能删除。",
    "high_risk_badge": "高风险：要填理由",
    "high_risk_reason_note": "（高风险委派：要填理由，提交后立即生效）",
    "reason_required_body": "这次会扩大高风险委派（整个组织、导出或解除警戒）：要填理由，提交后立即生效，并通知双方的拥有者与管理员。",
    "err_high_risk_reason": "高风险委派要填理由",
    "dlg_notify_high_risk": "高风险委派：提交后立即生效。会通知 {{from}} 的拥有者与所有组织管理员，以及 {{to}} 的拥有者与管理员（通知带创建者与理由）",
    "local_playback_full": "可回放本机录像（SD 卡 / 硬盘，含分享 / 指派之前录的）",
    "local_playback_full_hint": "打开后，这个人可以回放设备里所有的本机录像，包含分享 / 指派之前录的；云端录像与事件照常只到开始的时间之后。只有组织所有者或管理员能设置。",
    "lpf_on": "可以",
    "lpf_off": "不可以",
    "hm_title": "成员",
    "hm_you": "（你）",
    "hm_default_role": "跟随组织角色",
    "hm_add": "加入成员",
    "hm_pick": "选一位组织成员",
    "hm_add_submit": "加入",
    "hm_no_candidates": "组织里没有可以加入的成员",
    "hm_added": "已把 {{name}} 加为{{role}}",
    "hm_role_changed": "已把 {{name}} 改为{{role}}",
    "hm_remove": "移出",
    "hm_remove_title": "把 {{name}} 移出“{{home}}”？",
    "hm_remove_body": "{{name}} 将看不到这一户的设备，仍是组织成员。",
    "hm_removed": "已移出 {{name}}"
  },
  "aiLocal": {
    "title": "谁在分析",
    "help": "每台摄像头目前由谁做 AI 分析。指派给本地 AI（AI box、NVR、Kinio Station 电脑版）的摄像头，云端 AI 默认跳过、不扣云端额度。",
    "local_too": "本地与云端都分析",
    "local_too_help": "指派给本地 AI 的摄像头也送云端 AI（会扣云端额度；打开要重新验证）",
    "col_camera": "摄像头",
    "col_analyzer": "分析者",
    "col_detail": "说明",
    "who_local": "本地 AI",
    "who_cloud": "云端 AI",
    "who_both": "本地 + 云端",
    "who_none": "无",
    "offline": "本地 AI 离线，事件暂时不分析",
    "excluded": "已排除云端 AI",
    "status_pending": "套用中",
    "status_running": "运行中",
    "status_degraded": "降载",
    "status_unreachable": "取不到影像",
    "status_rejected": "提供者拒收",
    "who_unknown": "无法确认",
    "providers_failed": "读不到这个$t(leaf.cur)的本地 AI 状态",
    "not_queried": "这个$t(leaf.cur)的本地 AI 状态看不到（分享进来的$t(leaf.cur)）",
    "cloud_failed": "读不到云端 AI 的同意或用量",
    "status_starting": "启动中",
    "status_detector_error": "侦测器出错",
    "status_other": "状态：{{status}}"
  },
  "poeports": {
    "intro": "这台 Station 每个 PoE 口的供电与接着的设备。没回报的数值显示“不知道”。",
    "none": "这台没有回报 PoE 口。",
    "unknown": "不知道",
    "col_port": "口",
    "col_power": "供电",
    "col_meas": "测量",
    "col_link": "连接",
    "col_devices": "接着的设备",
    "col_actions": "操作",
    "st_disabled": "已关闭",
    "st_powered": "供电中",
    "st_idle": "未供电",
    "class": "等级",
    "temp": "温度",
    "link_up": "已连接",
    "link_down": "未连接",
    "not_home": "未对到本$t(leaf.cur)通道",
    "macs_more": "还有更多设备（只列前 4 个）",
    "act_on": "开启供电",
    "act_off": "关闭供电",
    "act_cycle": "重新上电",
    "confirm_on": "开启口 {{port}} 的供电？",
    "confirm_off": "关闭口 {{port}} 的供电？",
    "confirm_cycle": "口 {{port}} 重新上电？",
    "confirm_body": "接在这一口的设备会断电；摄像头会停止录像直到重新启动完成。",
    "sending": "发送中…",
    "done": "口 {{port}} 已应用。",
    "not_persistent": "关掉的口在 Station 重新启动后会自动恢复供电。",
    "err_FORBIDDEN": "需要运维权限才能控制 PoE 口。",
    "err_UNSUPPORTED_COMMAND": "这台不支持 PoE 口控制。",
    "err_BAD_PARAMS": "口号不正确。",
    "err_HAL_ERROR": "设备没有应用成功，请再试一次。",
    "err_DEVICE_OFFLINE": "设备离线，无法控制。",
    "err_COMMAND_TIMEOUT": "设备没有响应，请稍后确认口的状态。",
    "err_other": "没有成功（{{code}}）。"
  },
  "apikeys": {
    "title": "API 密钥",
    "count": "{{n}} / {{limit}}",
    "hint": "密钥代表你本人。Claude 用它做的事，跟你自己在这里做的一样，会记在你的名下。不要把密钥贴到聊天、代码或文档里；泄露了请立刻撤销。这里的密钥只能用在 VMS（含 Kinio Node / Station）；develop portal 要在 portal 另建一把。",
    "created": "已创建“{{name}}”——密钥只会显示这一次：",
    "copy": "复制",
    "setup_hint": "打开电脑的终端机（macOS 的“终端”、Windows 的 PowerShell）执行这一行，就会把 Kinio VMS 加进 Claude（不用安装程序）。不要贴进 Claude 的对话框，密钥会留在对话记录里：",
    "saved": "我已保存",
    "name": "名称",
    "name_placeholder": "例：我的笔记本 Claude",
    "scopes": "范围",
    "last_used": "最后使用",
    "expires": "到期",
    "never_used": "还没用过",
    "revoke": "撤销",
    "revoke_confirm": "撤销“{{name}}”？使用这把密钥的 Claude 最迟 5 分钟内就无法再调用。",
    "revoke_all": "全部撤销",
    "revoke_all_confirm": "撤销全部 {{n}} 把密钥？最迟 5 分钟内全部失效。",
    "revoked": "已撤销",
    "expired": "已到期",
    "empty": "创建一把密钥，让 Claude 用你的权限查询设备、事件与报警。",
    "need_mfa": "需要先开启两步验证（验证器 App 或 passkey）才能创建 API 密钥。",
    "create": "创建密钥",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "limit_hint": "能做的永远不超过你此刻的权限；团队组织需要管理员在安全策略中开启“成员可用 API 密钥”。创建、修改范围、轮换、撤销都需要 5 分钟内重新验证。",
    "media_confirm": "我了解：Claude 可以把这些设备的画面与录像片段下载到我的电脑（每次都会记录）",
    "console_confirm": "我了解：AI 助手或工具可以读写接在 Kinio Node 上的设备的串口",
    "control_confirm": "我了解：AI 助手或工具可以用我的身份控制我有权限的设备、改设置，包括 Kinio Node 指令与 Kinio Station 的本机设置",
    "pairing_confirm": "我了解：Claude / 工具可以用我关联的开发者账号额度，替我开“配网时分配 AID”的配对（仅 DEV 云端）",
    "scope_devices_read": "设备",
    "scope_devices_read_hint": "设备、$t(leaf.cur)与组织树、状态与设置、OTA 状态、Kinio Node / Station",
    "scope_events_read": "事件与报警",
    "scope_events_read_hint": "事件列表、报警与处理状态",
    "scope_recordings_read": "录像时间轴",
    "scope_recordings_read_hint": "哪些时段有录像（不含视频）",
    "scope_alarms_handle": "处理报警",
    "scope_alarms_handle_hint": "把报警标记为已看到 / 我来处理 / 已处理 / 误报",
    "scope_devices_console": "Kinio Node console",
    "scope_devices_console_hint": "读写接在 Kinio Node 上的设备的串口（写入要管理角色），含局域网直连 token",
    "scope_devices_control": "对设备下命令、改设置",
    "scope_devices_control_hint": "用我的身份开关设备、PTZ、录像设置、自动化、Kinio Node 指令、Kinio Station 的本机设置（按我的角色）；删除、恢复出厂、格式化等会删数据的操作不行",
    "scope_pairing_allocate": "配网时分配 AID（仅开发环境）",
    "scope_pairing_allocate_hint": "用我关联的开发者账号额度，替我在 DEV $t(leaf.cur)开“配网时分配 AID”的配对；设备端仍要实际配网",
    "scope_media_snapshot_read": "快照",
    "scope_media_snapshot_read_hint": "事件快照、最近一张快照、实时拍照、录像缩略图（每小时最多 60 张）",
    "err_API_KEY_MFA_REQUIRED": "需要先开启两步验证才能创建 API 密钥。",
    "err_API_KEY_LIMIT": "每人最多 5 把使用中的密钥，请先撤销不用的。",
    "err_API_KEY_PROD_WRITE": "这个环境的密钥只能有读取范围。",
    "err_FEATURE_DISABLED": "这个环境不提供 API 密钥。",
    "err_default": "没有成功（{{code}}）",
    "scope_media_clip_read": "录像片段",
    "scope_media_clip_read_hint": "一段最多 60 秒的云端录像下载网址（每天最多 20 次、合计 10 分钟；需要导出权限）",
    "rotate": "轮换",
    "rotate_confirm": "轮换“{{name}}”？会用同样的名称、范围与有效期长度建一把新的密钥（只显示一次）；旧的 24 小时后失效，期间照常能用。",
    "rotated": "已轮换",
    "rotated_until": "{{at}} 失效",
    "rotated_created": "已轮换“{{name}}”——新密钥只会显示这一次：",
    "rotated_old_until": "旧密钥到 {{at}} 前照常能用；把 Claude 换成新密钥后，可以在列表先撤销旧的。",
    "err_API_KEY_ROTATED": "这把密钥已经轮换过，请用新的那把。",
    "edit_scopes": "修改范围",
    "edit_scopes_title": "修改“{{name}}”的范围",
    "edit_scopes_hint": "密钥不变，Claude 不用重新设置；最迟 5 分钟内生效。",
    "save_scopes": "保存范围",
    "scopes_saved": "范围已更新；Claude 不用重新设置，最迟 5 分钟内生效。",
    "err_NOT_FOUND": "没有这把密钥，或已经撤销 / 到期。",
    "err_INVALID_ARGUMENT": "范围不合法，请重新勾选。",
    "scope_devices_maintain": "改名与更新固件",
    "scope_devices_maintain_hint": "改设备名称、立即更新固件、改自动更新设置（要运维权限）",
    "maintain_confirm": "我了解：AI 助手或工具可以替我改设备名称、立即更新固件（更新期间设备会离线几分钟）",
    "scope_vms_organize": "整理 VMS",
    "scope_vms_organize_hint": "我的布局、视图、设备群组、搜索条件、书签与偏好；$t(leaf.cur)的房间、平面图与摆放",
    "group_read": "读取",
    "group_media": "影像（默认不勾）",
    "group_write": "写入（默认不勾）"
  },
  "zed": {
    "snapshot_loading": "正在加载最新快照…",
    "live_connecting": "正在加载实时影像…",
    "no_snapshot": "没有快照，按〔看实时〕加载画面",
    "live_unavailable": "无法加载实时影像，仍可编辑",
    "snapshot_shown": "底图是最新的事件快照",
    "view_live": "看实时",
    "back": "返回",
    "clear_all": "全部清除",
    "saving": "保存中…",
    "saved": "已保存",
    "mode_full": "全画面",
    "mode_zones": "指定区域",
    "kept_hint": "已画的 {{count}} 个区域会保留，切回「指定区域」还在",
    "surface": "侦测区域编辑区",
    "zone_label": "区域 {{n}}",
    "delete": "删除区域 {{n}}",
    "full_frame": "全画面",
    "count_one": "1 个区域",
    "count": "{{count}} 个区域",
    "limit_counter": "{{count}} / {{max}}",
    "read_only": "目前无法更改侦测区域。",
    "limit": "最多 {{max}} 个区域",
    "reported_updated": "已按设备回报更新。",
    "hint": "在画面空白处拖曳画出区域；点选区域可移动、拖四角缩放，选取后按 Delete 删除。",
    "hint_full": "全画面侦测：整个画面都会触发。要限定范围请选「指定区域」。",
    "discard_title": "舍弃未保存的更改？",
    "discard_body": "侦测区域的更改还没有保存，离开后会丢失。",
    "discard_body_schedule": "排程的更改还没有保存，离开后会丢失。",
    "discard": "舍弃",
    "tpl_all_day": "全天",
    "tpl_night": "夜间（18:00–06:00）",
    "tpl_office": "上班时间（周一到周五 09:00–18:00）",
    "tpl_clear": "清除",
    "device_tz": "设备时区：{{tz}}",
    "read_only_schedule": "目前无法更改排程。",
    "hint_schedule": "拖曳涂格：从关的格子开始拖是开启、从开的格子开始拖是关闭；每格半小时。",
    "sum_all_day": "全天",
    "sum_off": "不启用",
    "sum_custom": "自定义",
    "edit": "编辑",
    "view": "查看",
    "offline": "设备离线，暂时不能更改",
    "no_write": "你没有更改这项设置的权限",
    "load_failed": "读不到设备目前的侦测区域设置，暂时只能查看；请稍后再打开一次",
    "layers": "图层",
    "mask_off": "关",
    "mask_count_one": "1 个遮罩",
    "mask_count": "{{count}} 个遮罩",
    "mask_mode_off": "关",
    "mask_mode_on": "开",
    "mask_kept_hint": "已画的 {{count}} 个遮罩会保留，切回“开”还在",
    "mask_warn": "遮罩在设备编码前涂黑：实时画面、录像、快照都看不到，之后也无法解除；遮罩内不会触发侦测。",
    "mask_label": "遮罩 {{n}}",
    "mask_delete": "删除遮罩 {{n}}",
    "mask_limit": "最多 {{max}} 个遮罩",
    "mask_hint": "在画面空白处拖动画出要遮蔽的范围；点选遮罩可移动、拖四角缩放，选中后按 Delete 删除。",
    "mask_hint_off": "隐私遮罩关闭：画面不遮蔽。要遮蔽请选“开”。",
    "read_only_masks": "目前无法更改隐私遮罩。",
    "discard_body_masks": "隐私遮罩的更改还没有保存，离开后会丢失。",
    "grid_full_frame": "全画面",
    "grid_custom": "部分区域",
    "grid_cells": "侦测 {{count}} / {{total}} 格",
    "grid_fill": "全选",
    "grid_clear": "清除",
    "grid_cell": "第 {{row}} 行第 {{col}} 格",
    "grid_hint": "拖动涂格：从未选的格子开始拖是加入、从已选的格子开始拖是移除；全部不选 = 全画面侦测。"
  },
  "poe": {
    "title": "检测到 {{n}} 台新摄像头要地址",
    "new_camera": "检测到新摄像头",
    "port": "PoE 第 {{port}} 口",
    "asked": "要地址 {{count}} 次（第一次 {{first}}、最近 {{last}}）",
    "suspect_uplink_ip": "这台的地址像是上行网段的设备（例如路由器或你家的电脑），不是插在 PoE 口的摄像头。不能一键加入；确定要加入请写原因。",
    "suspect_uplink_arp": "上行网段看得到这台（可能是接在上行的设备）。不能一键加入；确定要加入请写原因。",
    "suspect_other": "这台可能不是插在 PoE 口的摄像头。不能一键加入；确定要加入请写原因。",
    "approve": "加入",
    "ignore": "忽略",
    "force_reason": "强制加入的原因（至少 5 个字）",
    "force": "强制加入",
    "waiting_ip": "已核准，等摄像头拿到地址（最多 2 分钟）…",
    "got_ip": "摄像头已拿到地址 {{ip}}。输入摄像头的账号密码接进通道。",
    "own_camera": "这是 Kinio 摄像头，NVR 会自己接进通道，不用账号密码。",
    "add_channel": "接进通道",
    "added": "已接进通道。",
    "no_ip": "2 分钟内摄像头没有拿到地址：确认网线与供电后再试。",
    "err_SUSPECT_UPLINK": "这台有上行网段嫌疑，要写原因才能强制加入",
    "err_NOT_PENDING": "这台已经不在待核准清单（可能别人处理了）",
    "err_BAD_IP": "地址不能用（不在 PoE 网段或已分配给别台）",
    "err_default": "操作失败（{{code}}）",
    "wait_again": "再等一次",
    "block_title": "PoE 新摄像头（点开检查有没有要核准的）",
    "none": "目前没有要核准的 PoE 摄像头。",
    "unsupported": "这台没有 PoE 自动核准功能；请用“新增 ONVIF 摄像头”接入。"
  },
  "moment": {
    "title": "同一时刻",
    "help": "选一个时间点，看范围内每台摄像头那一刻的画面：那一刻有云端录像用云端的缩略图，没有就用 NVR 硬盘或 SD 卡的画面。点一格从那一刻开始回放。",
    "at": "时间",
    "browser_tz": "时间以浏览器时区（{{tz}}）选；每格下方是该场所的当地时间",
    "filter": "筛选摄像头名称",
    "none": "范围内没有可以回放的摄像头",
    "no_frame": "没有云端画面",
    "more": "还有 {{n}} 台没列出（一次最多 {{max}} 台），请用筛选或切换范围缩小",
    "all_empty": "这一刻这些摄像头都没有画面（云端、NVR 硬盘、SD 卡都没有读到）。可以换个时间，或用单路回放看前后的录像。",
    "go_single": "看单路",
    "clip_suspect": "⚠ 云端片段可能不完整",
    "clip_suspect_hint": "这一刻的云端片段长度不合理，缩略图可能是绿色或卡住；点进回放页会先找其他来源",
    "no_cloud_at": "这个时间没有云端录像",
    "from_local": "{{src}}的画面（这个时间没有云端录像）",
    "no_rec_at": "这个时间没有录像",
    "local_has": "{{src}}有这个时间的录像（没有缩略图）",
    "local_unknown": "没有云端录像；读不到 {{src}}（点开到回放页看）",
    "no_cloud_scope": "这个范围的摄像头最近两个月都没有云端录像；有本地录像（NVR / Station 硬盘、SD 卡）的格子会显示本地画面。"
  },
  "hnodes": {
    "intro": "接在这台 Host 上的 Kinio Node 板子。断电、重置、烧录由持有 Host 的组织管理员操作。",
    "none": "这台 Host 目前没有接节点。",
    "unknown": "不知道",
    "col_node": "节点",
    "col_health": "健康",
    "col_fw": "固件",
    "col_seen": "最后响应",
    "col_thing": "节点设备",
    "h_healthy": "正常",
    "h_busy": "使用中",
    "h_unhealthy": "异常",
    "h_unknown": "不知道",
    "not_visible": "不在这个$t(leaf.cur)或没有权限",
    "no_aid": "还没读到节点 AID"
  },
  "localvms": {
    "tab": "本地 VMS",
    "title": "断网时的本地 VMS",
    "intro": "外网断了，这个场所的 Station 照样能用浏览器看实时、回放硬盘录像。每台电脑要在有网络时先登记一次。",
    "no_stations": "没有可以登记的 Station。经组织分享或委派取得权限的场所只能在云端看。",
    "col_station": "录像主机",
    "col_home": "$t(leaf.cur)",
    "col_offline": "断网可用",
    "not_allowed": "场所没有开“断网可用”",
    "allowed": "已开启",
    "max_hours": "最长 {{n}} 小时",
    "open_here": "在这台电脑开启本地 VMS",
    "ask_admin": "—（请组织管理员到场所设置开启）",
    "not_ready": "本地网址还在准备中（Station 要在线）",
    "fixed_ip_hint": "建议在路由器替 Station 保留固定地址（固定 IP），备援网址才不会失效。",
    "enrolled_title": "已登记的电脑",
    "enrolled_empty": "还没有登记任何电脑。",
    "col_computer": "电脑",
    "col_updated": "最后更新",
    "col_expires": "到期",
    "fallback_update": "备援网址需要更新",
    "expired": "已到期",
    "expires_in": "{{n}} 天后到期",
    "days_left": "还有 {{n}} 天",
    "pin_locked": "PIN 已锁（到 {{until}}）",
    "reset_pin": "重设 PIN",
    "redo": "重新登记",
    "redo_unavailable": "这台 Station 现在不能登记（场所没开断网可用，或本地网址还没准备好）",
    "revoke": "撤销",
    "revoke_confirm": "撤销“{{label}}”？",
    "revoke_body": "这台电脑断网时就不能再开“{{station}}”的本地画面。Station 断线中的话，最晚在它上线或断网可用期限到时停用。",
    "revoked": "已撤销“{{label}}”。",
    "pin_lock_hint": "PIN 连错会暂时锁住；有网络时按〔重设 PIN〕（要重新验证身份）就能马上再用。断网时请店内管理员在 Station 屏幕解锁。",
    "pin_reset_done": "“{{label}}”的 PIN 已重设。",
    "reset_pin_title": "重设“{{label}}”的本地 PIN",
    "reset_pin_body": "新的 PIN 会在 Station 上线时生效，错误次数归零。",
    "pin_label": "这台电脑的本地 PIN（6 位数，断网登录时要输入）",
    "stepup_note": "接着要重新验证身份（密码 + 验证码）。",
    "pin_invalid": "PIN 要刚好 6 位数字。",
    "reset_pin_submit": "验证并重设",
    "err_default": "没有完成（{{code}}），请再试一次。",
    "err_REAUTH_REQUIRED": "要重新验证身份才能完成。",
    "err_OFFLINE_NOT_ALLOWED": "这个场所没有开“断网可用”。",
    "err_CLOUD_REQUIRED": "这个场所只有在云端才能看（你是经组织分享 / 委派取得权限）。",
    "err_NOT_FOUND": "找不到这笔登记。",
    "req_missing_title": "找不到这次登记",
    "req_missing": "链接不完整，请回到“设置 › 本地 VMS”重新开始。",
    "back": "回到本地 VMS 设置",
    "done_title": "这台电脑已登记",
    "done_body": "回到“{{station}}”的本地标签页，它会显示完成。断网时开主网址（已加入书签）；名字打不开再开备援网址（只能看）。",
    "expired_title": "这次登记已过期",
    "expired_body": "登记要在 5 分钟内完成。请回到列表重新开始。",
    "no_tab_title": "新标签页没有打开本地画面？",
    "no_tab_body": "这台电脑要接在“{{station}}”的局域网上（同一个店内网络）才能登记。",
    "no_tab_continue": "如果新标签页有打开，请在那边继续。",
    "waiting_title": "等待本地画面",
    "waiting_body": "已在新标签页打开“{{station}}”的本地画面。在那边完成后，这里会自动切换到确认画面。",
    "popup_blocked": "浏览器拦截了新标签页，请按〔重新打开〕。",
    "reopen": "重新打开",
    "confirm_title": "让这台电脑断网也能看“{{station}}”？",
    "computer_name": "电脑名称",
    "computer_name_ph": "例：监控室 PC-1",
    "confirm_body": "断网时可用多久照场所设置；有网络时平台每天自动更新，这台电脑不用开着。权限照你在这个$t(leaf.cur)的角色。只绑这台电脑，最长 30 天要重新登记。",
    "code_main": "核对码（主网址）：",
    "code_hint": "跟本地标签页显示的一样才继续",
    "fallback_label": "备援网址：",
    "fallback_attached": "已加入（只能看）",
    "fallback_waiting": "等待中",
    "fallback_hint": "名字打不开时用；断网登录一样要输入下面的 PIN。按确认时还是“等待中”就不登记备援网址。",
    "approve": "验证并登记",
    "with_fallback": "含备援网址（只能看）",
    "pin_locked_plain": "PIN 已锁",
    "someone": "用户 …{{id}}",
    "home_title": "这个$t(leaf.cur)的其他登记",
    "home_hint": "你是$t(leaf.cur)的拥有者或管理员：可以撤销别人在这些 Station 登记的电脑（只停那台电脑的本地 VMS，不影响对方的 App）。",
    "col_person": "登记的人",
    "err_LOCAL_VMS_LIMIT": "这台 Station 登记的电脑已达上限（{{limit}} 台），请先撤销不用的电脑。",
    "err_LOCAL_VMS_REQUEST_EXPIRED": "这次登记已过期（5 分钟），请重新开始。",
    "err_LOCAL_VMS_ALREADY_APPROVED": "这次登记已经确认过了。",
    "err_LOCAL_VMS_KEY_PENDING": "本地标签页还没完成这台电脑的设置，请在本地标签页继续。",
    "err_LOCAL_VMS_ENROLLMENT_EXPIRED": "这台电脑的登记已过期，请重新登记。",
    "err_INVALID_ARGUMENT": "电脑名称必填（最多 64 字），PIN 要 6 位数字。",
    "not_allowed_short": "没开",
    "not_allowed_banner_one": "有 {{count}} 台所在的场所没有开「断网可用」，还不能登记；请组织管理员到 组织与场所 › 场所设置 开启。",
    "not_allowed_banner_other": "有 {{count}} 台所在的场所没有开「断网可用」，还不能登记；请组织管理员到 组织与场所 › 场所设置 开启。"
  },
  "nenr": {
    "tab": "Kinio Node 开通",
    "title": "“{{name}}”的 Kinio Node 开通",
    "just_now": "刚刚",
    "min_ago": "{{n}} 分钟前",
    "hour_ago": "{{n}} 小时前",
    "quota_title": "开通额度",
    "no_quota": "本组织还没有 Kinio Node 开通额度。额度由平台配发，请联系你的经销商或平台。",
    "quota_line": "{{type}} 剩 {{n}}",
    "alloc_line": "{{date}} 配发，剩 {{n}}",
    "find_title": "找节点",
    "find_help": "在节点 console 输入 enroll_status，把整行粘贴上来，或只贴 fp= 后面的 16 位。",
    "enroll_url": "本平台的报到网址：{{url}}",
    "find_placeholder": "state=pending url=… keypwd=1 … fp=…",
    "find": "查找",
    "name_hint": "节点的 Wi-Fi / 蓝牙名称只有 MAC 末 6 位，不能用来查找。",
    "bad_fp": "找不到 fp= 后面的 16 个十六进制字符。",
    "wrong_platform": "这块板子报到的是别的平台；请在 console 用 fac_set enroll 改成 {{url}}。",
    "not_found": "找不到可以开通的节点",
    "check_fp": "贴的是 fp= 后面 16 位（或整行 enroll_status）",
    "check_pending": "节点还在报到（enroll_status 是 state=pending）",
    "check_url": "节点的 url= 是本平台的报到网址 {{url}}",
    "check_quota": "这个机种本组织有开通额度",
    "contact": "还是找不到请联系平台，并提供：指纹前 8 位 {{fp8}}、时间 {{at}}。",
    "fw": "固件",
    "last_seen": "最近报到",
    "maybe_offline": "节点可能已离线",
    "mac_conflict": "同一个 MAC 有两笔报到，请联系平台处理。",
    "keypwd_missing": "板子还没设开通密码：先在 console 输入 fac_set keypwd …",
    "identify": "闪灯",
    "identify_waiting": "等节点报到（约 1 分钟内）会闪白灯 30 秒",
    "identify_blinking": "正在闪白灯（30 秒）",
    "identify_missed": "节点 90 秒内没报到，可能已离线",
    "approve": "开通…",
    "approve_title": "开通 Kinio Node",
    "alloc": "用哪笔配发",
    "alloc_pick": "选一笔",
    "note": "备注（选填）",
    "note_placeholder": "一行、200 字内，不写 email、电话、地址",
    "note_bad": "备注只能一行、最多 200 字",
    "approve_explain": "用掉“{{name}}”一个开通额度（之后剩 {{n}}），这块板子归“{{name}}”持有。开通后不能自己撤销，开错要联系平台。",
    "confirm": "我已确认这是本组织的板子（指纹是从板子的 console 读的，或看过闪灯）",
    "approve_do": "开通",
    "wait_online": "已开通，等节点上线（下次报到约 1 分钟内会领到身份）",
    "now_online": "已上线",
    "not_online_long": "节点还没上线：可能是烧录的开通密码（keypwd）跟这笔配发不符，请联系平台。",
    "approved_title": "本组织开通过的",
    "approved_empty": "还没有开通过节点。",
    "col_at": "开通时间",
    "col_model": "机种",
    "col_by": "开通者",
    "col_note": "备注",
    "col_state": "状态",
    "by_member": "本组织成员",
    "by_platform": "平台",
    "online": "在线",
    "last_online": "最后上线 {{at}}",
    "revoked": "已停用",
    "revoked_hint": "平台收回后，板子要在 console 输入 fac_cred clear 再重启才会重新报到。",
    "pair_hint": "要放进$t(leaf.cur)：用 App 的局域网配对把它加进$t(leaf.cur)。",
    "err_gone": "这台现在不能开通了（可能已被开通或被平台处理），请重新查找。",
    "err_lookup_limit": "找不到的次数太多，{{at}} 后再试。",
    "err_daily_cap": "你 24 小时内已开通 100 台，{{at}} 后再试，或请组织管理员开通。",
    "err_no_quota": "这笔配发用完了，请选别笔或向平台申请。",
    "err_alloc": "这笔配发不能用在这台。",
    "err_mac_in_use": "这个 MAC 已经属于另一个有效的设备身份，请联系平台。",
    "err_forbidden": "你的权限已变更，请刷新。",
    "err_unavailable": "暂时无法开通，请稍后再试。"
  },
  "ncon": {
    "close": "关闭",
    "status_idle": "未连接",
    "status_ticket": "获取票据中…",
    "status_connecting": "连接中…",
    "status_opening": "等待设备响应…",
    "status_open": "已连接",
    "status_reconnecting": "设备重新连接中…",
    "status_closed": "已断开",
    "reason_device_offline": "设备离线",
    "reason_data_lost": "中间有数据接不上",
    "reason_session_superseded": "被新的连接取代（设备固件不支持续传）",
    "reason_device_revoked": "设备已撤销",
    "reason_DEVICE_OFFLINE": "设备离线，上线后再试",
    "reason_RATE_LIMITED": "打开太频繁，稍后再试",
    "reason_NOT_FOUND": "没有这台的权限",
    "reason_NOT_SUPPORTED": "这台不支持终端",
    "reason_NETWORK": "连不到 Kinio",
    "role_me": "你可以输入",
    "role_other": "别人正在输入，你只能看",
    "role_none": "目前没人输入",
    "take": "获取写入权",
    "release": "交出写入权",
    "lost": "断线时有 {{n}} 个字节接不上。",
    "rebooted": "设备重启过。",
    "dropped": "网络太慢，丢了 {{n}} 段输出。",
    "in_dropped": "设备来不及接收，{{n}} 个输入字节没送到。",
    "err_NOT_WRITER": "你没有写入权",
    "err_RATE_LIMITED": "输入太快，稍后再发",
    "err_DEVICE_RECONNECTING": "设备重新连接中，稍后再发",
    "input_ro": "取得写入权后才能输入（按键不会发送）",
    "title": "终端",
    "via_platform": "经 Kinio 平台",
    "auto_reconnect": "连接中断，自动重新连接",
    "clear": "清屏",
    "reconnect": "重新连接",
    "popout": "新窗口",
    "tunnel": "复制连接命令",
    "tunnel_hint": "在你电脑原本的终端运行这行，nodectl 会自动选路：跟 Kinio Node 同一个局域网就直连，不同网络经 Kinio 平台中继。Ctrl-] 退出。",
    "tunnel_step_download": "下载 nodectl：develop portal〔平台工具〕的 Kinio Node 套件（macOS、Linux、Windows）。",
    "tunnel_step_key": "密钥：把自己的 VMS 密钥设成环境变量 KINIO_VMS_KEY，密钥范围要勾「Kinio Node 局域网 console」。",
    "tunnel_key_link": "到 API 密钥",
    "tunnel_step_writer": "跟网页终端同时打开时，网页这边的写入权照常运作；nodectl 直连时不经写入权。",
    "copy": "复制",
    "copied": "已复制",
    "direct": "高级：用自己的工具直接连",
    "direct_hint": "只在你要用自己的工具直接连这台 Kinio Node 时用：拿一把短期直连 token 与局域网地址（8788，kttl/2）。平常用网页终端或上面的 nodectl 命令就好，会自动选路。",
    "direct_confirm": "我了解：拿到 token 的人可以读写接在这台 Kinio Node 上的设备的串口",
    "direct_get": "拿直连 token",
    "direct_addr": "局域网地址",
    "direct_token": "token",
    "direct_no_lan": "节点没上报局域网地址，只能经平台连接（nodectl ttl 会自动走中继）",
    "direct_token_once": "只显示这一次（{{id}}），{{at}} 到期",
    "reason_FIRMWARE_UNSUPPORTED": "节点固件太旧（要 1.0.52 以上）",
    "connect_ro": "连接（只读）",
    "intro": "这是 Kinio Node 连接的设备的串口（root shell），供安装与开发使用。连接后看得到别人正在输入的指令与输出；先以只读连接，要输入再取得写入权。",
    "take_ellipsis": "取得写入权…",
    "take_confirm_title": "要在 {{name}} 的串口输入指令？",
    "take_confirm_body": "你输入的会直接送到设备（root）。目前有其他人连接时，他们会变成只读。",
    "take_confirm_others": "现在有其他人连接中；会把写入权从正在输入的人那里拿过来。",
    "others_n_one": "另外 {{count}} 人连接中",
    "others_n_other": "另外 {{count}} 人连接中",
    "need_admin": "需要管理员才能输入（组织管理员、节点管理员、安装技师或$t(leaf.cur)拥有者 / 管理员）；你可以看输出。",
    "write_forbidden": "你的角色不能在这台输入，需要管理员（组织管理员、节点管理员、安装技师或$t(leaf.cur)拥有者 / 管理员）。已回到只读。",
    "reason_FORBIDDEN": "需要管理员才能拿直连 token（它可以在这台输入）"
  },
  "devacct": {
    "tab": "开发者账号",
    "title": "开发者账号",
    "hint": "把开发者入口的开发者账号连到这个账号：输入开发者入口〔App 账号连结〕产生的 8 码。连结后开发者账号可以用名下的 AID 在这个账号配对设备，但看不到你的设备影像、事件或录像。",
    "code_label": "连结码（8 码）",
    "next": "下一步",
    "where": "在开发者入口：账号与安全 › App 账号连结 › 产生连结码。",
    "where_dev": "在 DEV 的开发者入口：账号与安全 › App 账号连结 › 产生连结码（码 10 分钟内有效、只能用一次）。",
    "confirm_title": "要连结这个开发者账号吗？",
    "confirm_who": "{{email}}（开发者账号）要连结你的这个账号。两个账号都是你本人的才确认；别人传给你的连结码请不要确认。",
    "confirm_can_dev": "连结后这个开发者账号可以：用它名下的 AID 额度在这个账号配对没烧 AID 的设备；把云端模拟开发机放进你是拥有者 / 管理员的 DEV 云端家庭；让它所属开发者组织的成员对你 DEV 云端家庭里该组织机种的设备推开发版固件；让这个账号在 DEV 云端可以建家庭。它不能看你的设备影像、事件或录像。你可以随时在「开发者账号」解除。",
    "confirm_can_prod": "连结后这个开发者账号可以：用它名下的 AID 额度在这个账号配对没烧 AID 的设备；让这个账号加入它的产品测试回合。它不能看你的设备影像、事件或录像。你可以随时在「开发者账号」解除。",
    "confirm": "确认连结",
    "linked_done": "已连结 {{email}}。",
    "linked_at": "{{date}} 连结",
    "unlink": "解除",
    "unlink_confirm": "解除后不能再用这个账号配发 AID、开发者不能对它的开发机推固件。",
    "kind_grant": "额度授权",
    "grant_title": "要接受这个开发者账号的 AID 额度授权吗？",
    "grant_who": "{{email}}（开发者账号）要把它名下的 AID 额度授权给你这个 App 账号。这不一定是你本人的账号——只有你认得、且同意让它用你这个账号配设备时才确认；不确定就不要确认、回报给 {{brand}}。",
    "grant_can": "接受后这个开发者账号可以：用它名下的 AID 额度在你这个账号配对没烧 AID 的设备（每天有上限，每次都会通知你）。它不能看你的设备、影像、事件或录像，不能推固件、放模拟器、或在你账号建家庭。你可以随时在「开发者账号」解除。",
    "grant_confirm": "确认授权",
    "grant_done": "已接受 {{email}} 的 AID 额度授权。",
    "grant_linked_at": "{{date}} 接受授权",
    "grant_unlink_confirm": "解除后这个开发者账号不能再用它的额度在你这个账号配设备。已配好的设备留在你这里。",
    "err_LINK_CODE_GONE": "连结码无效或已过期，请回开发者入口重新产生。",
    "err_gone_dev_hint": "这组码如果是在 DEV 的开发者入口产生的，要用 DEV 云端的账号确认。",
    "err_LINK_POOL_MISMATCH": "这组码要用另一个 App 的账号确认。",
    "err_APP_ACCOUNT_LINKED": "这个账号已经连结别的开发者账号，先解除才能连新的。",
    "err_APP_LINK_EXISTS": "这个开发者账号已经连结这个 App 的另一个账号，请先在开发者入口解除。",
    "err_LINK_TARGET_MISMATCH": "这组码不是给这个账号的；请对方用你这个 App 账号的 email 重新产生。",
    "err_RATE_LIMITED": "尝试太多次，请稍后再试。",
    "err_INVALID_ARGUMENT": "连结码是 8 个英数字。",
    "err_REAUTH_REQUIRED": "要先重新验证身份才能确认。",
    "err_WRONG_ACCOUNT_POOL": "开发者账号不能在这里确认，请用 App 账号登录。",
    "err_default": "没有完成（{{code}}）"
  },
  "navg": {
    "watch": "监看",
    "manage": "设备与场所",
    "org": "组织管理"
  },
  "orggate": {
    "capsule": "组织：{{name}}",
    "pick_title": "要管理哪个组织？",
    "pick_body": "当前范围是“全部”。选一个组织，页首的范围也会切到那里。",
    "your_role": "你的角色：{{role}}",
    "devices_one": "{{count}} 台设备",
    "devices_other": "{{count}} 台设备"
  },
  "time": {
    "just_now": "刚刚",
    "min_ago_one": "{{count}} 分钟前",
    "min_ago_other": "{{count}} 分钟前",
    "hour_ago_one": "{{count}} 小时前",
    "hour_ago_other": "{{count}} 小时前",
    "day_ago_one": "{{count}} 天前",
    "day_ago_other": "{{count}} 天前"
  },
  "user": {
    "me": "我",
    "menu": "账号菜单",
    "tz": "时间显示",
    "tz_site": "场所时区",
    "tz_browser": "我的时区",
    "version": "{{brand}} · 版本 {{version}}（网页 {{build}}）",
    "version_copy": "复制版本信息",
    "version_copied": "已复制",
    "map_provider": "地图供应商",
    "map_auto": "按地区自动选"
  },
  "gsearch": {
    "label": "全局搜索",
    "placeholder": "搜索设备、场所、人、功能…  {{key}}",
    "g_pages": "页面",
    "g_devices": "设备",
    "g_places": "场所与$t(leaf.cur)",
    "g_people": "人",
    "g_events": "事件",
    "in_events": "在事件中搜索“{{q}}”",
    "places_failed": "场所与$t(leaf.cur)查不到，其他结果照常",
    "seats": "云端录像席位",
    "syn_overview": "首页,仪表板,健康",
    "syn_live": "影像墙,看画面,直播",
    "syn_playback": "录像,时间轴",
    "syn_events": "警报,侦测,告警",
    "syn_map": "平面图,位置",
    "syn_exports": "导出,下载,证据包,验证",
    "syn_devices": "摄像头,NVR,设备列表,新增设备,配对",
    "syn_firmware": "固件,更新,OTA,版本",
    "syn_inventory": "库存,认领,序号,未归户",
    "syn_enroll": "开通,Kinio Node,node",
    "syn_sites": "场所,组织结构,节点,楼层,据点,指派",
    "syn_rules": "规则,自动化,场景",
    "syn_backup": "备份,异地",
    "syn_people": "成员,权限,授权,角色,分享,委派,邀请",
    "syn_audit": "审计,记录,操作记录",
    "syn_billing": "套餐,账单,付款,订阅,购买",
    "syn_seats": "席位,云录,云端录像",
    "syn_org": "组织,安全策略,MyCam 策略,层级名称",
    "syn_account": "账号,个人设置,设置,两步验证,密码,passkey,登录设备",
    "syn_apikeys": "API 密钥,API,密钥,token",
    "syn_notify": "通知设置,勿扰,浮动通知,email",
    "syn_verify": "验证,证据包,SHA-256,签名",
    "syn_access": "访问权限,权限,授权,$t(leaf.cur)成员,分享,指派",
    "syn_external": "对外,委派,委派代码,分享给本组织",
    "g_other": "其他范围",
    "only_other": "目前范围没有符合的结果；其他范围有 {{n}} 条（点了会先切范围）",
    "syn_shares": "分享,链接,收件人,撤销,水印"
  },
  "devtabs": {
    "all": "全部设备",
    "firmware": "固件",
    "inventory": "库存",
    "add": "新增",
    "add_kinio": "新增 Kinio 设备",
    "add_onvif": "新增 ONVIF 摄像头",
    "add_enroll": "开通 Kinio Node",
    "add_claim": "用序号认领",
    "enroll": "开通",
    "add_kinio_channel": "把 Kinio 摄像头接到录像主机的通道"
  },
  "toastpref": {
    "title": "浮动通知",
    "help": "新通知要不要在画面右下角弹出来。只影响这台电脑；铃铛里的通知照常都在。",
    "alarm": "只有警报（建议）",
    "alarm_help": "布防中的侦测、传感器触发、门铃、账号安全",
    "alarm_detect": "警报与侦测",
    "alarm_detect_help": "另外加上一般的移动、人、车侦测",
    "none": "都不弹",
    "none_help": "只看铃铛（警报卡也不弹；影像墙指定格位照常）"
  },
  "iam": {
    "tab_access": "访问权限",
    "tab_external": "对外",
    "left_member": "已离开的成员",
    "a_group": "成员群组",
    "an_org": "另一个组织",
    "org_role_other": "其他角色",
    "home_role": "$t(leaf.cur){{role}}",
    "src_org_role": "组织角色",
    "src_home_role": "$t(leaf.cur)角色",
    "src_site_grant": "场所授权",
    "src_node_assignment": "节点指派",
    "src_share": "分享",
    "src_delegation": "委派",
    "col_who": "对象",
    "col_where": "范围",
    "col_what": "能做什么",
    "col_source": "来源",
    "col_term": "期限",
    "inherited_from": "从「{{path}}」继承（只读）",
    "filter_who": "筛选对象",
    "filter_who_all": "全部的人",
    "filter_where": "筛选范围",
    "filter_where_all": "全部范围",
    "filter_source": "筛选来源",
    "filter_source_all": "全部来源",
    "grant_btn": "＋ 授予访问权限",
    "empty": "没有符合的访问权限。",
    "more": "加载更多",
    "details": "详情",
    "revoke": "撤销",
    "revoke_title": "撤销 {{who}} 在「{{where}}」的访问权限？",
    "revoke_body": "对方 30 秒内会失去这里的实时视频、回放与控制。",
    "revoke_body_home_role": "会把他从这个$t(leaf.cur)的成员中移除，30 秒内停止他正在看的视频。",
    "revoke_body_share": "分享会结束，对方 30 秒内看不到这些设备。",
    "revoke_body_site_grant": "场所授权会撤销，对方 30 秒内会失去这些设备的访问权限。",
    "revoke_action": "撤销访问权限",
    "revoke_gone": "这条访问权限已经不在了，请刷新页面。",
    "revoked": "已撤销 {{who}} 的访问权限。",
    "refresh": "刷新",
    "refresh_hint": "按目前的设备重新展开（之后新增的设备不会自动加入）",
    "refreshed": "已按目前的设备重新展开 {{who}} 的访问权限。",
    "all_now": "这个家庭现在的所有设备（之后新增的设备不会自动加入）",
    "grant_title": "授予访问权限",
    "step_who": "给谁",
    "step_where": "哪里",
    "step_what": "能做什么",
    "step_term": "多久",
    "kind_member": "本组织成员",
    "kind_member_desc": "组织里的人",
    "kind_group": "成员群组",
    "kind_group_desc": "一次给一群人（只能给节点）",
    "kind_org": "另一个组织",
    "kind_org_desc": "委派场所给对方代管，或把设备分享给服务商",
    "kind_person": "组织外的个人",
    "kind_person_desc": "用 email 分享某个家庭的设备",
    "person_hint": "对方有账号就立即生效，没有会收到邀请邮件；页面一律只显示“已发送”。",
    "org_delegation": "用对方的委派代码",
    "org_delegation_desc": "把场所交给另一个组织代管，对方再指派他们的人",
    "org_share": "用对方的分享请求代码",
    "org_share_desc": "把某个家庭的设备分享给安装商、保安或监控中心",
    "where_hint": "选一个节点（含下面的子场所与家庭）或一个家庭。",
    "where_hint_group": "成员群组只能给节点（含下面的子场所与家庭）。",
    "picked": "已选：{{where}}",
    "size_node": "{{homes}} 个家庭、{{devices}} 台",
    "size_home_one": "{{count}} 台",
    "size_home_other": "{{count}} 台",
    "size_list": "指定 {{n}} 台",
    "devices_all": "这个家庭现在的所有设备（之后新增的设备不会自动加入）",
    "devices_list": "只选几台",
    "devices_list_na": "只选几台（你没有这个家庭的视频权限，不能逐台选）",
    "role_node_admin": "管理这个场所（节点管理员）",
    "role_operator": "看与操作（操作员）",
    "role_viewer": "只看（观看者）",
    "role_installer": "安装调校（安装技师）",
    "role_maintainer": "设备运维（运维员）",
    "role_custom": "自定义…",
    "role_custom_desc": "用自定义角色模板的动作",
    "term_n_days": "天数",
    "term_max": "最长 90 天",
    "term_window_label": "只在某些时段",
    "term_days_one": "{{count}} 天",
    "term_days_other": "{{count}} 天",
    "term_window": "每天 {{from}}–{{to}}",
    "site_grant_term": "指定到单个家庭的访问权限一定有期限（最长 90 天），到期前可以延长。",
    "summary": "{{who}} 可以{{verb}} {{where}}{{size}}，{{term}}",
    "verb_node_admin": "管理",
    "verb_operator": "看与操作",
    "verb_viewer": "只看",
    "verb_installer": "安装调校",
    "verb_maintainer": "运维设备",
    "verb_custom": "按「{{name}}」使用",
    "verb_share": "「{{what}}」",
    "grant_submit": "授予访问权限",
    "done": "已授予 {{who}}「{{where}}」的访问权限。",
    "done_share": "已发送分享给 {{email}}。",
    "done_org_share": "已同意分享请求。",
    "drawer_title": "{{name}} 能做什么",
    "org_role": "组织角色",
    "powers": "组织权限",
    "no_powers": "没有组织事务的权限（能看什么看下方列表）",
    "can_all_org": "组织的一切（场所、成员、账单、审计、设备库存、问题反馈）",
    "can_org_sites": "可以管理场所与人员",
    "can_org_devices": "可以管理设备库存",
    "can_org_audit": "可以查看审计",
    "can_org_billing": "可以管理账单",
    "can_svc": "服务角色：{{role}}",
    "duty": "值班操作台账号",
    "drawer_access": "按范围列出的访问权限",
    "drawer_hint": "含他所属成员群组的节点指派；每行可以撤销。",
    "drawer_need_admin": "只有组织拥有者与管理员看得到完整的访问权限。",
    "what_can": "{{name}} 能做什么",
    "change_role": "变更角色…",
    "edit_perms": "组织权限…",
    "more_of": "{{name}} 的更多操作",
    "suspend_title": "停用 {{name}}？",
    "suspend_body": "他 30 秒内会被中断实时视频与回放，之后也进不了这个组织；可以再恢复。",
    "change_role_of": "变更 {{name}} 的角色",
    "new_role": "新角色",
    "role_before": "变更前：{{role}}——{{desc}}",
    "role_after": "变更后：{{role}}——{{desc}}",
    "change_role_action": "变更角色",
    "org_role_desc_owner": "组织的一切，含指定组织管理员",
    "org_role_desc_org_admin": "组织、场所树、成员、账单、审计、设备库存；看视频要另外授予访问权限",
    "org_role_desc_member": "组织成员；能看什么由节点指派、场所授权、$t(leaf.cur)角色或分享决定",
    "org_role_desc_guest": "默认看不到设备，要另外授予访问权限",
    "org_role_desc_developer": "开发者账号（develop portal 的工作）",
    "org_role_desc_factory_ops": "产线账号（产测与出货）",
    "roles_hint": "每个角色一行“可以做”、一行“不可以”。要给人访问权限，到“访问权限”分页按〔＋ 授予访问权限〕。",
    "roles_export_note": "下载 / 导出录像一律要另外勾选，不会随任何角色自动带入。",
    "col_layer": "层",
    "col_can": "可以做",
    "col_cannot": "不可以",
    "layer_org": "组织层",
    "layer_site": "场所层",
    "layer_home": "$t(leaf.cur)层",
    "layer_custom": "自定义角色",
    "custom_cannot": "没勾选的动作",
    "rl_owner_name": "拥有者",
    "rl_owner_how": "组织角色",
    "rl_owner_can": "组织的一切，含指定组织管理员",
    "rl_owner_cannot": "—",
    "rl_org_admin_name": "组织管理员",
    "rl_org_admin_how": "组织角色",
    "rl_org_admin_can": "组织、场所树、成员、账单、审计、设备库存与收编",
    "rl_org_admin_cannot": "本身不带看视频的权限；分享进本组织的设备不能管理",
    "rl_member_name": "成员 / 访客",
    "rl_member_how": "组织角色",
    "rl_member_can": "组织成员资格；能看什么由场所层角色、$t(leaf.cur)角色或分享决定",
    "rl_member_cannot": "组织事务",
    "rl_auditor_name": "审计员",
    "rl_auditor_how": "组织权限“可以查看审计”",
    "rl_auditor_can": "审计日志、事件",
    "rl_auditor_cannot": "实时视频、回放",
    "rl_node_admin_name": "节点管理员",
    "rl_node_admin_how": "节点指派",
    "rl_node_admin_can": "范围内全部数据动作含布防 / 撤防、运维、子节点与指派",
    "rl_node_admin_cannot": "分享、$t(leaf.cur)角色、录像设置、解绑、格式化",
    "rl_operator_name": "操作员",
    "rl_operator_how": "节点指派或场所授权",
    "rl_operator_can": "看实时与回放、对讲、PTZ、警报器、处理警报",
    "rl_operator_cannot": "导出、设置、授权",
    "rl_viewer_name": "观看者",
    "rl_viewer_how": "节点指派或场所授权",
    "rl_viewer_can": "实时与事件",
    "rl_viewer_cannot": "回放、导出、控制、处理警报（警报不推送）",
    "rl_installer_name": "安装技师",
    "rl_maintainer_name": "运维员",
    "rl_installer_how": "节点指派或场所授权",
    "rl_maintainer_how": "节点指派，或场所授权给单台",
    "rl_installer_can": "对焦调角度、设置",
    "rl_maintainer_can": "看设备与状态、OTA、重新开机、改名、看 Kinio KMS 监控",
    "rl_installer_cannot": "回放、导出、事件历史",
    "rl_maintainer_cannot": "影像、对讲、事件、回放、导出、设置、授权；KMS 的设置与处置",
    "rl_home_roles_name": "$t(leaf.cur)拥有者 / 管理员 / 成员 / 访客",
    "rl_home_roles_how": "$t(leaf.cur)角色",
    "rl_home_roles_can": "拥有者：$t(leaf.cur)的一切含解绑与分享；管理员：设置、授权、录像策略；成员：看、回放、事件、控制；访客：只看被分享的设备",
    "rl_home_roles_cannot": "按角色",
    "ext_out_desc": "把本组织的场所交给另一个组织代管，对方再指派他们的人。",
    "ext_in_desc": "别的组织把场所交给你们代管。",
    "ext_shares_title": "分享给本组织",
    "ext_shares_desc": "其他$t(leaf.cur)把设备分享给你们组织时，会出现在这里；你可以决定哪些成员能看。",
    "size_struct": "{{x}}（结构总数）",
    "here": "这一层",
    "maintenance": "维护",
    "maintenance_hint": "停用会暂时拿掉这个人在本组织的所有访问权限；移出组织会永久拿掉，之后要重新邀请。",
    "email_need": "请输入对方的 email",
    "assign_site_role": "分配场所角色",
    "subtree_scope": "涵盖此场所及继承权限的子场所与$t(leaf.cur)设备，包括以后新增的设备；中断继承的子场所不涵盖。",
    "site_admin_help": "可查看、回放、控制、布撤防及维护设备，并管理子场所与角色分配。下载／导出需另行授权。",
    "site_scope_help": "当前范围：{{scope}}。要让成员管理此范围的设备，点击“分配场所角色”，选择“管理这个场所”。下方每项授权的范围可能不同；子场所的分配不会向上扩及整个组织。",
    "can_org_support": "可以反馈问题、查看本组织的反馈",
    "err_dup_assignment": "{{who}} 在“{{where}}”已经有一笔指派：{{role}}，{{term}}。要改角色或期限，请到“访问权限”页改那一笔，不用再新增。",
    "err_dup_assignment_unknown": "这个对象在“{{where}}”已经有一笔指派。要改角色或期限，请到“访问权限”页改那一笔，不用再新增。",
    "dup_until": "到 {{date}}",
    "dup_schedule": "有时段限制"
  },
  "notfound": {
    "title": "找不到这一页",
    "body": "{{path}} 不是 VMS 的页面。可能网址打错了，或这一页已经搬家。",
    "home": "回总览"
  },
  "nuart": {
    "row": "UART（TTL）连接的设备",
    "open": "打开它的页面",
    "label_was": "接线时取的名字：{{label}}",
    "not_visible": "没有对到你看得到的 Kinio 设备（可能不是 Kinio 设备、在别的$t(leaf.cur)，或你没有查看权限），所以没有链接",
    "unset": "还没设置连接了哪台设备",
    "howto": "接线的人可以用设备群控制发送 ttl_config 带 dut，或在这台 Node 的 console 输入",
    "howto_name": "名称",
    "howto_model": "机种",
    "old_fw": "这台 Node 的固件 {{v}} 还不会回报连接了哪台设备，要先升级到 {{min}} 以上（可用更新 {{next}}）",
    "see_fw": "看固件",
    "rx_none": "还没收到连接的设备的输出",
    "rx_just_now": "连接的设备刚刚有输出",
    "rx_recent": "连接的设备 {{when}}有输出",
    "rx_quiet": "连接的设备超过 24 小时没有输出（最后 {{at}}），可能没接好或那台没开机",
    "rx_node_offline": "Node 离线前最后收到输出：{{when}}",
    "summary": "UART（TTL）连接的设备：{{name}}",
    "old_fw_unreleased": "这台 Node 的固件（{{v}}）还不会回报连接了哪台设备；支持的版本（{{min}} 以上）还没发布到更新通道"
  },
  "kinioch": {
    "title": "Kinio 摄像头接到录像主机的通道",
    "help": "让 Kinio Station 用自己的身份把一台 Kinio 摄像头接到它的某一路，跟其他通道一样录像、移动侦测、在视频墙看。摄像头不用跟 Station 在同一个家或场所，只要你看得到它的实时视频。",
    "no_station": "这个范围里没有你能管理的 Kinio Station（需要拥有者或管理员）。",
    "station": "录像主机",
    "camera": "摄像头",
    "pick_camera": "选一台你看得到实时视频的摄像头",
    "no_camera": "没有你看得到实时视频的 Kinio 摄像头。",
    "channel": "通道（留空 = 第一个空的）",
    "channel_auto": "自动",
    "add": "接上",
    "whose": "权限算设置的人：之后你看不到这台摄像头（例如分享被收回、离开组织），这一路就会停，要由别人重设或移除。",
    "added": "已接到 CH{{ch}}：{{name}}",
    "current": "这台录像主机的 Kinio 摄像头通道",
    "none": "还没有",
    "by_me": "你设置的",
    "by_other": "别人设置的",
    "ok": "可以使用",
    "remove": "移除",
    "denied": "设置的人已无法看这台摄像头",
    "denied_not_granted": "设置的人已无权限看这台摄像头",
    "denied_org_mfa_required": "摄像头的组织要求两步验证：设置的人用两步验证登录后重设一次",
    "denied_ip_not_allowed": "摄像头的组织不允许设置时的网络",
    "denied_session_reauth": "设置的人要重新登录后重设",
    "denied_share_expired": "分享已到期",
    "denied_share_suspended": "分享暂停中",
    "denied_alarm_window": "只在警报后的时窗内可看",
    "denied_armed": "只在布防时可看",
    "denied_schedule": "不在授权的时段内",
    "denied_org_suspended": "摄像头的组织已停用",
    "denied_station_rebound": "录像主机重新绑定过，要重设",
    "denied_device_unbound": "摄像头已解绑",
    "denied_no_assignment": "没有设置",
    "err_DEVICE_NOT_FOUND": "找不到这台摄像头，或你看不到它",
    "err_FORBIDDEN": "你没有这台摄像头的实时视频权限",
    "err_KINIO_SOURCE_SELF": "不能接这台录像主机自己的通道",
    "err_KINIO_SOURCE_UNSUPPORTED": "这台录像主机不支持 Kinio 摄像头通道",
    "err_NO_FREE_CHANNEL": "录像主机的通道都用完了",
    "err_ORG_MFA_REQUIRED": "摄像头的组织要求两步验证，请开启后重新登录",
    "err_GATEWAY_OFFLINE": "录像主机离线"
  },
  "rech": {
    "title": "录像健康",
    "table_title": "每路录像健康",
    "col_channel": "通道",
    "col_state": "状态",
    "state_ok": "正常录像中",
    "state_idle": "现在不用录",
    "idle_note": "不在录像计划内，或录像已关闭",
    "state_interrupted": "录像中断：{{reason}}",
    "since": "从 {{at}} 起（已 {{dur}}）",
    "state_none": "没有回报",
    "none_note": "这台录像主机的固件还不支持，或还没连上云端",
    "state_unreadable": "读不到",
    "host_offline": "录像主机离线，下面是最后一次回报（{{at}}）",
    "reason_disk_repairing": "硬盘正在修复，暂时不能写入",
    "reason_no_storage": "找不到录像硬盘",
    "reason_no_space": "硬盘满了，而且设置为不覆盖",
    "reason_io_error": "写入硬盘失败",
    "reason_no_stream": "收不到摄像头的画面（摄像头离线或断流）",
    "reason_unsupported_stream": "摄像头的视频格式无法录像",
    "reason_not_writing": "该录像却没有写出文件（原因不明）",
    "reason_unknown": "原因不明",
    "last_write": "最后写入",
    "dropped": "过去 1 小时丢掉的帧",
    "dropped_n": "{{n}} 帧",
    "dropped_note": "录像写入跟不上时丢掉的，摄像头那端断讯不算",
    "fsync": "存档耗时（过去 1 小时）",
    "fsync_v": "一般 {{p95}} 毫秒内 · 最慢 {{max}} 毫秒",
    "fsync_none": "这一小时没有存档",
    "write_err": "过去 24 小时写入失败",
    "write_err_n": "{{n}} 次",
    "reset_note": "录像主机重启后，这些数字从 0 重新计算",
    "loading": "读取中…",
    "dur_lt1m": "不到 1 分钟",
    "dur_min_one": "{{count}} 分钟",
    "dur_min_other": "{{count}} 分钟"
  },
  "lens": {
    "lens_upper": "上镜头",
    "lens_lower": "下镜头",
    "lens_wide": "广角镜头",
    "lens_tele": "长焦镜头",
    "lens_left": "左镜头",
    "lens_right": "右镜头",
    "lens_n": "镜头 {{n}}",
    "group": "镜头",
    "group_playback": "回放镜头",
    "filter_all": "全部镜头",
    "switching": "正在切换到{{name}}…",
    "switched": "已切换到{{name}}",
    "timeout": "{{name}}没有响应",
    "unsupported": "这台目前不能看{{name}}",
    "privacy": "开了隐私遮罩时不能看{{name}}",
    "moved_back": "开了隐私遮罩，已切回{{name}}",
    "old_fw": "这台目前只能看一颗镜头",
    "look": "看{{name}}",
    "timeline_main": "{{name}}的录像",
    "no_rec": "{{name}}没有开录像",
    "no_rec_at": "{{name}}这时没有录像",
    "open_settings": "到设置开启",
    "ask_owner": "请屋主到设置开启"
  },
  "wb": {
    "filter": "筛选",
    "filter_all": "全部",
    "filter_mine": "指派给我",
    "filter_overdue": "超时",
    "list": "警报列表",
    "pane": "警报详情",
    "empty": "目前没有警报",
    "empty_mine": "没有指派给你、尚未处理的警报",
    "empty_overdue": "没有超过接手时限的警报",
    "all_done": "全部处理完了",
    "recent_closed": "最近结案的",
    "group_security": "尚未处理（安防）",
    "group_status": "尚未处理（状态）",
    "group_recovered": "尚未处理（已恢复）",
    "group_claimed": "处理中",
    "group_closed": "已结案",
    "group_unlisted": "未登记或已移除的设备",
    "recovered": "↺ 已恢复",
    "me": "我",
    "left_member": "已离开的成员",
    "system": "系统",
    "assigned_to": "指派给 {{name}}",
    "assigned_line": "指派给 {{name}}（{{by}} 指派，{{at}}）",
    "assigned_now": "当前指派",
    "assign": "指派…",
    "assign_me": "{{name}}（我）",
    "unassign": "取消指派",
    "assign_filter": "输入名字筛选",
    "assign_none": "没有其他能处理这台的人",
    "assign_truncated": "只列前 500 位，请输入名字筛选",
    "assign_not_eligible": "这个人目前不能处理这台的警报",
    "assign_invalid": "当前状态不能这样指派",
    "assign_closed": "已结案的警报不能指派",
    "cannot": "这条是“{{state}}”，不能按“{{act}}”",
    "conflict": "已被 {{name}} 改成“{{state}}”，请再确认",
    "wave_skipped": "{{n}} 条已被别人处理，跳过",
    "note_placeholder": "备注（一行，最多 {{max}} 字；Enter 只加备注）",
    "note_saved": "已加备注",
    "read_only": "你只能查看这条警报",
    "no_media": "这台不是摄像头，没有片段",
    "live": "实时",
    "live_open": "看实时",
    "live_offline": "离线中",
    "enlarge": "打开大图",
    "floorplan": "平面图",
    "floorplan_open": "在地图页打开这张平面图",
    "related_more": "另有 {{n}} 台",
    "wave": "这一波 {{n}} 次",
    "wave_more": "全部列出",
    "wave_less": "收起",
    "wave_rest": "另有 {{n}} 次",
    "unlisted": "这台不在设备列表中（未登记的通道或已移除的设备），不计入未处理数，没有处理时限。",
    "started_before_alarm": "这次侦测开始时还不是警报（布防后才算警报，或没收到开始记录）。",
    "sla_left": "剩 {{d}}",
    "sla_over": "超时 {{d}}",
    "sla_over_now": "已超时",
    "sla_line": "接手时限 {{m}} 分 · {{s}}",
    "sla_recovered": "已恢复，不计时",
    "sla_stopped": "已接手",
    "sla_met": "{{d}}内接手",
    "sla_met_late": "超过时限 {{d}}才接手",
    "sla_src_org": "来源：组织的默认",
    "sla_src_site": "来源：节点的设置",
    "sla_src_share": "来源：{{org}}（分享）的默认",
    "sla_src_other_org": "另一个组织",
    "dur_min_one": "{{count}} 分",
    "dur_min_other": "{{count}} 分",
    "dur_hour_one": "{{count}} 小时",
    "dur_hour_other": "{{count}} 小时",
    "dur_day_one": "{{count}} 天",
    "dur_day_other": "{{count}} 天",
    "h_assign": "{{by}} 指派给 {{to}}",
    "h_unassign": "{{by}} 取消指派（原本是 {{to}}）",
    "h_note": "{{by}} 加了备注",
    "h_overdue": "超过接手时限，已通知 {{list}}",
    "h_overdue_none": "超过接手时限（没有可通知的人）",
    "h_overdue_merged": "超过接手时限，并入 {{at}} 的超时通知",
    "h_cleared": "（原本指派给 {{name}}）",
    "help_title": "键盘快捷键",
    "help_hint": "光标在输入框里、或有对话框打开时，快捷键不起作用。",
    "key_jk": "J / K（↓ / ↑）",
    "key_a": "A",
    "key_c": "C",
    "key_r": "R",
    "key_f": "F",
    "key_s": "S",
    "key_n": "N",
    "key_enter": "Enter",
    "key_x": "X",
    "key_q": "?",
    "key_esc": "Esc",
    "keydesc_jk": "下一条 / 上一条",
    "keydesc_a": "已看到",
    "keydesc_c": "我来处理（别人处理中 = 接手）",
    "keydesc_r": "已处理（自动到下一条）",
    "keydesc_f": "误报（自动到下一条）",
    "keydesc_s": "指派给同事",
    "keydesc_n": "备注（Enter 只加备注、Esc 不发）",
    "keydesc_enter": "打开大图（有片段就播放）",
    "keydesc_x": "展开 / 收起这一波",
    "keydesc_q": "列出快捷键",
    "keydesc_esc": "关闭大图、菜单、抽屉",
    "assigned_line_noat": "指派给 {{name}}（{{by}} 指派）"
  },
  "sla": {
    "title": "警报处理时限",
    "hint": "尚未有人接手的警报超过这个时间，会在画面标“超时”，并通知被指派的人与主管（组织所有者、管理员、节点管理员）一次。超时只提醒，不会改状态。留空 = 不设。",
    "default": "组织默认",
    "security": "安防类",
    "status": "状态类（视频信号中断）",
    "minutes": "分钟",
    "off": "不设",
    "invalid": "请填 1–{{max}} 的整数，或留空",
    "invalid_node": "请填正确的分钟数",
    "nodes": "节点覆盖",
    "nodes_none": "没有节点覆盖，全部按组织默认。",
    "node_unknown": "（已删除的节点）",
    "inherit": "沿用上一层",
    "set": "自定义",
    "node_off": "这个节点不设",
    "reset": "恢复沿用",
    "pick_node": "选择一个节点",
    "add": "新增覆盖"
  },
  "mycam": {
    "full_mode": "完整模式",
    "simple_mode": "简易模式",
    "add_title": "用旧手机加入摄像头",
    "add_intro": "在旧手机安装 MyCam，用这里生成的二维码或 8 位码把它加进你的家。",
    "home": "加到哪个家",
    "pick_home": "选一个家",
    "create_code": "生成绑定码",
    "steps": "在旧手机打开 MyCam，扫描这个二维码，或输入下面的 8 位码。",
    "qr_label": "MyCam 绑定码的二维码",
    "expires": "{{n}} 分钟内有效",
    "waiting": "等待旧手机扫描…",
    "compare_title": "旧手机上显示的是这个数字吗？",
    "compare_device": "要加入的手机：{{device}}",
    "name": "名称",
    "name_default": "客厅",
    "confirm": "是，加入",
    "reject": "不是这台",
    "done": "已加入“{{name}}”。旧手机设好 PIN 后就会开始看家。",
    "go_cameras": "看摄像头",
    "expired": "绑定码过期了。",
    "plan_limit": "方案的摄像头数已满。移除不用的摄像头或升级方案后再加入。",
    "no_admin_home": "你没有可以添加设备的家（需要是家的所有者或管理员）。",
    "brand_warn": "“{{home}}”是其他品牌 App 创建的家。MyCam 加在这里的话，检测到移动时手机 App 收不到通知。建议先在手机 App 新增一个家，再把 MyCam 加在新家。",
    "brand_keep": "仍加在这个家",
    "add_old_phone": "用旧手机加入"
  },
  "leaf": {
    "cur": "地点",
    "cur_lc": "地点",
    "cur_pl": "地点",
    "cur_lc_pl": "地点"
  },
  "support": {
    "title": "问题反馈",
    "no_right": "要组织管理员在「人员与访问 › 成员」帮你勾选「问题反馈」，才能在这里反馈问题、查看本组织的反馈。",
    "new": "新反馈",
    "hint": "反馈 VMS、设备、录像或账号的问题；同组织有「问题反馈」权限的人也看得到、可以补充。",
    "filter": "筛选",
    "scope_all": "全部",
    "scope_mine": "我提交的",
    "scope_watching": "我关注的",
    "scope_org": "本组织的",
    "load_failed": "读不到反馈列表，请稍后再试。",
    "empty": "还没有反馈。",
    "new_reply": "新回复",
    "by": "{{name}} 提交 · {{org}}",
    "status_open": "已收到",
    "status_triaged": "确认中",
    "status_in_progress": "处理中",
    "status_resolved": "已解决",
    "status_closed": "已结案",
    "cat_video": "画面与串流",
    "cat_offline": "设备离线",
    "cat_recording": "录像与回放",
    "cat_account": "账号与权限",
    "cat_alert": "通知与报警",
    "cat_other": "其他",
    "new_title": "新反馈",
    "new_hint": "提交后技术支持会在这里回复，也会发邮件通知你。",
    "org": "组织",
    "category": "问题类型",
    "device": "哪一台设备（选填）",
    "device_none": "不指定设备",
    "subject": "主题",
    "body": "发生了什么",
    "body_ph": "什么时候开始、在哪个地点、哪些画面、做了什么后出现…",
    "files": "截图或文件（最多 {{n}} 个）",
    "file_type": "{{name}}：只收图片、文字、JSON、ZIP、PDF",
    "file_big": "{{name}}：单个文件最多 20 MB",
    "file_many": "最多 {{n}} 个文件",
    "remove": "移除",
    "context": "会自动附上的技术信息",
    "context_hint": "VMS 版本、浏览器、当前页面、组织、设备与最近的错误，帮技术支持更快找到原因。",
    "blocked": "提交前检查发现：{{summary}}。可以修改后再提交，或写下理由照样提交。",
    "override": "照样提交的理由",
    "err_NOT_SUPPORT_REPORTER": "你在这个组织没有「问题反馈」权限，请联系组织管理员。",
    "err_BAD_ORG": "只能从你所属的组织反馈。",
    "err_RATE_LIMITED": "一小时内反馈太多次，请稍后再试。",
    "err_TICKET_CLOSED": "这个反馈已结案超过 7 天，请提交新反馈。",
    "err_generic": "提交失败（{{code}}），请稍后再试。",
    "upload_failed": "有 {{n}} 个附件没传上去，可以在下方留言补充。",
    "sending": "提交中…",
    "submit": "提交反馈",
    "not_found": "找不到这个反馈，或你没有权限查看。",
    "back": "回到问题反馈",
    "me": "我",
    "member": "同事",
    "staff": "技术支持",
    "status_changed": "状态已更新",
    "attachments": "附件",
    "watchers": "关注的人",
    "add_comment": "补充说明",
    "send": "发送",
    "report_device": "反馈这台的问题"
  },
  "sso": {
    "sign_in_with": "以 {{idp}} 登录",
    "sign_in_hint": "{{org}} 的成员可以用公司账号登录；也可以照常用密码登录。",
    "finishing": "正在完成公司账号验证…",
    "back_home": "回到首页",
    "continue": "继续",
    "email_reminder": "你的 Kinio 账号邮箱是公司邮箱，离职后公司邮箱会失效；建议到〔我的账号〕把邮箱改成个人邮箱。",
    "org_unavailable": "这个组织目前没有可用的公司账号登录。",
    "start_body": "用 {{org}} 的公司账号（{{idp}}）登录。",
    "use_password": "改用 Kinio 账号密码登录",
    "step_up_title": "需要以公司账号验证",
    "step_up_body": "{{org}} 要求以公司账号验证，才能查看这个组织的资源。你的其他组织与个人的家照常可用。",
    "other_orgs": "回到我的其他组织",
    "verify_with": "以 {{idp}} 验证",
    "break_glass_hint": "公司账号系统无法使用？",
    "break_glass": "用 passkey 紧急进入",
    "err_default": "公司账号验证没有完成（{{code}}），请重新开始。",
    "err_SSO_NOT_LINKED": "这个公司账号还没连到 Kinio 账号：请先用 Kinio 账号登录，再到组织页“以公司账号验证”。",
    "err_SSO_ALREADY_LINKED": "这个公司账号已经连到另一个 Kinio 账号。",
    "err_binding": "这次登录不是从这个浏览器开始的，请重新开始。",
    "err_SSO_BINDING_MISSING": "这次登录不是从这个浏览器开始的，请重新开始。",
    "err_BREAK_GLASS_NOT_ALLOWED": "你不在这个组织的紧急进入名单内。",
    "err_PASSKEY_REQUIRED": "请先用 passkey 验证。",
    "err_PASSKEY_CANCELED": "已取消 passkey 验证。",
    "err_SSO_IDP_UNAVAILABLE": "连不上公司的账号系统，请稍后再试。",
    "err_idp_error": "公司的账号系统报告错误，请联系公司 IT。",
    "err_state": "这次登录已过期或已使用，请重新开始。",
    "ff_title": "设置你的 passkey",
    "ff_body": "你的账号是用公司账号创建的，还没有自己的登录方式。设置一把 passkey，之后就能用它验证身份。",
    "ff_why": "有些组织要求两步验证，或某些操作要用你自己的账号再验证一次；公司账号登录只能用在你的公司组织。设置好 passkey 后这些都能用。",
    "ff_verified": "已用公司账号验证，请再点一次〔设置 passkey〕。",
    "ff_unsupported": "这个浏览器不支持 passkey，请改用最新版的 Chrome、Edge 或 Safari。",
    "ff_setup": "设置 passkey",
    "ff_later": "稍后再说",
    "ff_not_needed": "你的账号已经有自己的登录方式，不需要再设置。",
    "ff_go": "设置 passkey",
    "ff_passkey_name": "第一把 passkey",
    "no_account_title": "请先登录或注册 Kinio 账号",
    "no_account_body": "这个公司账号还没关联到 Kinio 账号。请先用你自己的 Kinio 账号登录（还没有的话先注册），再到组织页点击“以公司账号验证”。注册后请先完成邮箱验证。",
    "no_account_action": "登录 / 注册",
    "link_pending_body": "用公司账号（{{idp}}）验证之后，就能加入这个组织。",
    "link_pending_dismiss": "跳过",
    "link_not_eligible": "这个组织还没让你以公司账号加入。请组织管理员先邀请你（邀请发到你的 Kinio 账号邮箱），或确认公司名册上的邮箱与你的 Kinio 账号一致。"
  },
  "ssoadm": {
    "title": "企业 SSO",
    "hint": "让成员用公司账号（Entra ID、Okta、Google…）验证才能使用这个组织的资源。账号仍属个人：密码、两步验证、个人的家公司碰不到。",
    "idp": "公司的 IdP",
    "protocol": "协议",
    "display_name": "显示名称（登录按钮上的字）",
    "cert": "IdP 签名证书（PEM）",
    "create": "创建",
    "test": "测试连接",
    "activate": "启用",
    "disable": "停用",
    "delete": "删除 IdP",
    "delete_title": "删除公司的 IdP？",
    "delete_body": "所有成员的公司账号连接会一起失效；之后要重新设置、测试、启用，成员再各自以公司账号验证一次。",
    "status_draft": "草稿",
    "status_active": "已启用",
    "status_disabled": "已停用",
    "untested": "还没测试这个版本",
    "pending": "有一份待测的设置：测试连接成功后才会换上。",
    "sp_values": "把下面的值填到 IdP 的应用设置：",
    "sp_redirect_uri": "Redirect URI",
    "sp_entity_id": "SP Entity ID",
    "sp_acs_url": "ACS URL",
    "sp_metadata_url": "SP metadata",
    "domains": "公司域名",
    "domains_hint": "验证过的域名：登录框输入这个域名的邮箱会出现“以公司账号登录”。只比对完全相同的域名；不改任何现有账号。",
    "domain_pending": "待验证",
    "domain_verified": "已验证",
    "verify": "验证",
    "add_domain": "新增域名",
    "require": "要求 SSO",
    "require_label": "要求成员以公司账号验证",
    "require_hint": "只在使用这个组织的资源时要求；个人的家与其他组织照常。MFA 交由你的 IdP 负责。",
    "require_title": "开启要求 SSO？",
    "require_body": "没有用公司账号验证的成员会被挡在这个组织外（不会被登出整个账号）。委派给其他组织的节点，对方成员改为要求两步验证。break-glass 名单：{{bg}}。",
    "require_on": "开启",
    "max_age": "验证有效时间",
    "break_glass": "紧急进入（break-glass）",
    "break_glass_hint": "公司 IdP 故障时，名单上的人可以用 passkey 绕过 SSO 进入；每次使用都会写审计并通知其他管理员。最多 2 人，只有拥有者能改。",
    "bg_none": "（没有）",
    "err_default": "没有完成（{{code}}）",
    "err_SSO_IDP_INVALID": "IdP 设置有问题或连不上（{{reason}}）",
    "err_SSO_IDP_UNTESTED": "请先〔测试连接〕走一次 IdP 登录，再启用。",
    "err_SSO_REQUIRED_ON": "要求 SSO 开着，先关掉才能停用或删除 IdP。",
    "err_SSO_NOT_CONFIGURED": "先设好并启用公司的 IdP，才能要求 SSO。",
    "err_SSO_PROOF_REQUIRED": "你这次登录还没有用公司账号验证；先验证一次再开启，免得把自己锁在外面。",
    "err_DOMAIN_NOT_VERIFIED": "还查不到 TXT 记录（DNS 生效可能要几分钟）。",
    "err_DOMAIN_TAKEN": "这个域名已由别的组织验证；有争议请联系客服。",
    "err_INVALID_ARGUMENT": "值不合法（免费邮箱域名不能验证）。",
    "err_REAUTH_REQUIRED": "请重新验证身份。",
    "err_BAD_POLICY": "设置值不合法。",
    "scim": "SCIM 自动预配",
    "scim_hint": "让公司目录（Entra ID、Okta）自动同步名册：员工离职停用后，他在这个组织的权限会自动移除（账号本身不受影响）。",
    "scim_endpoint": "Tenant URL（SCIM 端点）",
    "scim_counts": "名册 {{users}} 人（{{unmatched}} 人还没对到账号）· 群组 {{groups}} 个",
    "scim_last_sync": "最后同步：{{at}}",
    "scim_never": "还没有同步过",
    "scim_token_row": "token 创建于 {{at}}",
    "scim_token_used": "最后使用 {{at}}",
    "scim_new": "生成 token",
    "scim_new_shown": "这是唯一一次显示这个 token，请现在复制到 IdP 的 Secret Token 字段：",
    "scim_revoke": "撤销",
    "scim_revoke_title": "撤销这个 SCIM token？",
    "scim_revoke_body": "撤销后 IdP 用这个 token 同步会失败，名册与成员不会被改动。",
    "err_CONFLICT": "最多 2 个有效的 token，请先撤销一个。"
  },
  "ssolink": {
    "title": "公司账号连接",
    "hint": "这些组织用你的公司账号验证。解除后，进这些组织要再用公司账号验证一次。",
    "unlink": "解除",
    "unlink_title": "解除与“{{org}}”的公司账号连接？",
    "unlink_body": "你在这个组织的公司账号验证会一起失效。",
    "unlink_failed": "没有解除成功，请重新验证身份后再试。"
  },
  "aiByo": {
    "title": "自带 AI",
    "help": "用你自己的 OpenAI / Anthropic / Gemini 账号分析事件画面：生成一句描述（可搜索）与人 / 车 / 动物 / 包裹标签。费用由服务商直接向你收取，Kinio 不加价、不代付。",
    "provider": "服务",
    "provider_openai": "OpenAI",
    "provider_anthropic": "Anthropic Claude",
    "provider_gemini": "Google Gemini",
    "api_key": "API key",
    "key_help": "保存后只显示最后 4 位，任何人（包括 Kinio）都看不到完整 key。平台会先用它查询一次可用模型（不收费）确认有效。",
    "consent_summary": "开启自带 AI 的摄像头，每个移动事件会发送 1 张画面到 {{provider}} 分析，结果回到事件与搜索。",
    "consent_body": "发送的数据：事件当下的 1 张画面（长边缩到 1024 px），不发送摄像头名称。\n目的地：你选择的服务（OpenAI / Anthropic / Google）的官方 API。\n保存与训练：由你与该服务的合约决定；Kinio 只保存分析结果，保存期同事件。\n费用：服务直接向你收取；可设每小时 / 每天上限。\n告知责任：你是数据控制者，请告知被拍摄的人。\n随时可撤回：删除 key 后 60 秒内停止发送。\n不做人脸识别：分析不会识别或推测任何人的身份。",
    "agree": "我已阅读并同意",
    "add": "验证并保存",
    "add_help": "需要重新验证身份。",
    "status_active": "使用中",
    "status_invalid": "key 无效",
    "status_disabled": "停用",
    "status_needs_reentry": "需要重新输入 key",
    "invalid_help": "服务回复这把 key 无效或没有权限，已停止使用。请更换 key。",
    "last_used": "最后使用 {{at}}",
    "model": "模型",
    "usage": "本月调用 {{calls}} 次",
    "cost_note": "费用以服务的账单为准。",
    "max_per_hour": "每小时上限",
    "max_per_day": "每天上限",
    "devices_help": "勾选要用自带 AI 分析的摄像头（这些摄像头 Kinio 云端 AI 不再分析、不扣额度）：",
    "rekey_placeholder": "粘贴新的 key",
    "rekey": "更换 key",
    "delete": "删除",
    "delete_help": "删除后 60 秒内停止发送；若担心泄露，请到服务后台作废这把 key。",
    "fail_auth": "key 无效",
    "fail_rate": "服务限流",
    "fail_quota": "额度用完",
    "fail_model": "模型不可用",
    "fail_timeout": "超时",
    "fail_server": "服务错误",
    "fail_schema": "回复格式不对",
    "fail_bad_request": "请求被拒",
    "err_BYO_AI_KEY_INVALID": "这把 key 无效或没有权限。",
    "err_BYO_AI_MODEL_UNAVAILABLE": "这把 key 用不了这个模型。",
    "err_BYO_AI_DISABLED_BY_POLICY": "组织的安全策略没有开放自带云端 AI。",
    "err_BYO_AI_CREDENTIAL_EXISTS": "已经有一把 key，请直接更换。",
    "err_BYO_AI_PROVIDER_UNAVAILABLE": "暂时连不上服务或被限流，请稍后再试。",
    "err_ENTITLEMENT_REQUIRED": "当前套餐不包含自带云端 AI。",
    "err_AI_ALREADY_ASSIGNED": "这台摄像头已指派给本地 AI，请先解除。",
    "err_VERSION_CONFLICT": "数据已被他人修改，请刷新。",
    "err_REAUTH_REQUIRED": "请重新验证身份后再试。"
  },
  "email_verify": {
    "title": "请先验证你的邮箱",
    "body": "为了保护你的账号，验证邮箱后才能添加登录方式。验证邮件将发送到 {{email}}。",
    "body_action": "为了保护你的账号，验证 email 之后才能做这件事。验证信会寄到 {{email}}。",
    "send": "发送验证邮件",
    "later": "稍后再说",
    "sent": "已发送验证邮件，到邮箱点击链接后再试一次。",
    "err_RATE_LIMITED": "发送太频繁，请稍后再试。",
    "err_default": "验证邮件发送失败（{{code}}），请稍后再试。",
    "already": "你的邮箱已经验证了，请再试一次。",
    "body_no_email": "为了保护你的账号，验证邮箱后才能添加登录方式。",
    "body_action_no_email": "为了保护你的账号，验证 email 之后才能做这件事。"
  }
}
